'use strict';

/**
 * Ønskeliste port 1 «Lagre og se» (snippets/wishlist-assets.liquid, snippets/wishlist-button.liquid, blocks/product-wishlist.liquid,
 * sections/wishlist-page.liquid; contract with Pippei Portal v1: docs/PORTAL-WISHLIST-CONTRACT.md).
 *
 * - Hearts (button[data-wl-btn]): on the product page (mode variant: the chosen variant from input[name=id] and pippei:variant-change) and on
 *   the shared product card (mode product: pressed when any variant of the product is saved). They start hidden and show when the state is
 *   known. One click handler on document (delegation), so the carousels' clones (aria-hidden, tabindex -1) and the grid HTML that the
 *   filters swap in need nothing of their own; a MutationObserver gives new buttons the current state. Clicks inside [inert] never act.
 * - Signed in: one GET /state per page (ticket, saved variant and product ids), writes as JSON with the ticket. 403 ticket_expired fetches
 *   the state once and tries again. 429, any 5xx (App Proxy turns them into an HTML page), a missing endpoint, or two network errors or time limits turn the wishlist off
 *   for the session (sessionStorage pp-wl-off): the hearts hide, the page shows «Kunne ikke hente varene».
 * - Guest: the list lives in this browser (localStorage pp-wl-guest, at most 250 lines); nothing goes to the server except the anonymous
 *   product lookup on the page. After sign-in a <dialog> asks once per customer (hash of the customer id) whether to move it (Flytt / Ikke
 *   nå / Forkast). The browser list is emptied only after the portal answered 200; a failed move is retried on the next page view.
 * - Everything from the server is drawn with textContent and DOM calls; time limits 8 s for reads and 10 s for writes.
 */
(function () {
  var OFF_KEY = 'pp-wl-off';
  var GUEST_KEY = 'pp-wl-guest';
  var GUEST_MAX = 250;
  var NOTE_MAX = 300;
  var QTY_MAX = 99;
  var READ_MS = 8000;
  var WRITE_MS = 10000;
  var ID_RE = /^[1-9][0-9]{0,18}$/;
  var STOCK = ['in_stock', 'preorder', 'temporarily_sold_out', 'long_term_sold_out'];
  var REF_RE = /^[0-9A-Za-z_-]{1,64}$/;
  var TOKEN_RE_G = /^[A-Za-z0-9_-]{43}$/;

  var cfgEl = document.querySelector('[data-wl-config]');
  if (!cfgEl || typeof window.fetch !== 'function') return;
  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  var base = typeof cfg.base === 'string' ? cfg.base : '';
  if (!base) return;
  var signedIn = cfg.signed_in === true;
  var who = typeof cfg.who === 'string' ? cfg.who : '';

  /* ── Helpers ─────────────────────────────────────────────────────────────────────────────────────────────────────── */
  function t(key, fallback) { return (cfg.t && typeof cfg.t[key] === 'string' && cfg.t[key]) || fallback || ''; }
  function tn(key, n, fallback) { return n === 1 && cfg.t && cfg.t[key + '_one'] ? cfg.t[key + '_one'] : t(key, fallback).replace('__N__', String(n)); }
  function str(v, max) { return typeof v === 'string' ? v.slice(0, max || 500) : ''; }
  function id(v) { var s = typeof v === 'number' ? String(v) : (typeof v === 'string' ? v : ''); return ID_RE.test(s) ? s : ''; }
  function el(tag, attrs, text) {
    var n = document.createElement(tag);
    if (attrs) Object.keys(attrs).forEach(function (k) { if (attrs[k] !== null && attrs[k] !== undefined && attrs[k] !== false) n.setAttribute(k, attrs[k] === true ? '' : attrs[k]); });
    if (text !== undefined && text !== null) n.textContent = text;
    return n;
  }
  function icon(name) {
    var tpl = document.querySelector('template[data-wl-icons]');
    var src = tpl && tpl.content.querySelector('[data-icon="' + name + '"]');
    return src ? src.firstElementChild.cloneNode(true) : null;
  }
  /* Only same-site paths and https images from the server end up in href/src. */
  function safePath(v) { var s = str(v, 1024); return /^\/(?![\/\\])/.test(s) ? s : ''; }
  function safeImg(v) { var s = str(v, 1024); return /^https:\/\//.test(s) || /^\/\/[^/]/.test(s) ? s : ''; }

  function loginHref() {
    var href = cfg.login || '/account/login';
    try {
      var u = new URL(href, window.location.origin);
      u.searchParams.set('return_to', window.location.pathname + window.location.search);
      href = u.origin === window.location.origin ? u.pathname + u.search : u.href;
    } catch (e) { /* keep the plain login address */ }
    return href;
  }

  /* Amount in øre in the shop's money format, without trailing zeros (as money_without_trailing_zeros). */
  function money(ore) {
    if (typeof ore !== 'number' || !isFinite(ore)) return '';
    var n = Math.round(ore) / 100;
    function f(dec, th, ds) {
      var parts = n.toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return parts[0] + (parts[1] ? ds + parts[1] : '');
    }
    var fmt = str(cfg.money, 100).replace(/<[^>]*>/g, '') || '{{amount_with_comma_separator}} kr';
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      switch (k) {
        case 'amount_no_decimals': return f(0, ',', '.');
        case 'amount_with_comma_separator': return f(2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return f(0, '.', ',');
        case 'amount_with_space_separator': return f(2, ' ', ',');
        case 'amount_no_decimals_with_space_separator': return f(0, ' ', ',');
        case 'amount_with_apostrophe_separator': return f(2, '\'', '.');
        default: return f(2, ',', '.');
      }
    }).replace(/[.,]00(?=\D|$)/, '');
  }

  /* ── Live region and notice ──────────────────────────────────────────────────────────────────────────────────────── */
  var live = document.querySelector('[data-wl-live]');
  var liveTimer = null;
  /* A short notice at the bottom (also read by screen readers). link = { href, text } or, for «Angre», { text, action: function } (a button).
     With a link or button it stays 8 s. */
  function say(text, link) {
    if (!live || !text) return;
    window.clearTimeout(liveTimer);
    live.textContent = '';
    live.appendChild(el('span', null, text));
    if (link && typeof link.action === 'function') {
      live.appendChild(document.createTextNode(' '));
      var b = el('button', { type: 'button', class: 'wl-live__action' }, link.text);
      b.addEventListener('click', function () { live.classList.remove('is-on'); live.textContent = ''; link.action(); });
      live.appendChild(b);
    } else if (link) { live.appendChild(document.createTextNode(' ')); live.appendChild(el('a', { href: link.href }, link.text)); }
    live.classList.add('is-on');
    liveMs = link ? 8000 : 4000;
    liveArm();
  }
  /* The notice waits while the pointer is on it or it has focus (WCAG 2.2.1), then gets its time again. */
  var liveMs = 4000, liveHold = false;
  function liveArm() {
    window.clearTimeout(liveTimer);
    if (liveHold) return;
    liveTimer = window.setTimeout(function () { live.classList.remove('is-on'); live.textContent = ''; }, liveMs);
  }
  if (live) {
    ['mouseenter', 'focusin'].forEach(function (ev) { live.addEventListener(ev, function () { liveHold = true; window.clearTimeout(liveTimer); }); });
    ['mouseleave', 'focusout'].forEach(function (ev) { live.addEventListener(ev, function () { liveHold = false; if (live.classList.contains('is-on')) liveArm(); }); });
  }

  /* ── Requests ────────────────────────────────────────────────────────────────────────────────────────────────────── */
  /* Resolves to { status, data } (data null when the answer is not JSON); status 0 = network error or time limit. Never rejects. */
  function request(path, opts, ms) {
    var ctrl = typeof AbortController === 'function' ? new AbortController() : null;
    var done = false;
    opts.credentials = 'same-origin';
    opts.headers = opts.headers || {};
    opts.headers.Accept = 'application/json';
    if (ctrl) opts.signal = ctrl.signal;
    return new Promise(function (resolve) {
      var timer = window.setTimeout(function () { if (ctrl) ctrl.abort(); finish({ status: 0, data: null }); }, ms);
      function finish(r) { if (done) return; done = true; window.clearTimeout(timer); resolve(r); }
      fetch(base + path, opts).then(function (res) {
        var json = (res.headers.get('content-type') || '').indexOf('json') !== -1;
        return (json ? res.json().catch(function () { return null; }) : Promise.resolve(null))
          .then(function (data) { finish({ status: res.status, data: data && typeof data === 'object' ? data : null }); });
      }).catch(function () { finish({ status: 0, data: null }); });
    });
  }
  function read(path) { return request(path, { method: 'GET' }, READ_MS); }

  /* Errors that end the wishlist for the session: 429, any 5xx, a success without JSON and 404 from /state at once; network and time limit
     the second time. */
  var strikes = 0;
  function isOff() { try { return window.sessionStorage.getItem(OFF_KEY) === '1'; } catch (e) { return false; } }
  function turnOff() {
    try { window.sessionStorage.setItem(OFF_KEY, '1'); } catch (e) { /* no storage */ }
    if (signedIn) { ready = false; hideHearts(); }
  }
  /* App Proxy turns every 5xx from the portal (also 503 {"error":"disabled"}) into the shop's HTML error page with status 500
     (portal log, 2026-10-11), so a 5xx or a success without JSON means «off» too; 4xx arrive as JSON. */
  function judge(r, fatal404) {
    var noJson = r.status >= 200 && r.status < 300 && r.data === null;
    if (r.status === 429 || r.status >= 500 || noJson || (fatal404 && r.status === 404)) { turnOff(); return; }
    if (r.status === 0) { strikes += 1; if (strikes >= 2) turnOff(); return; }
    if (r.status >= 200 && r.status < 300) strikes = 0;
  }

  /* ── Signed-in state ─────────────────────────────────────────────────────────────────────────────────────────────── */
  var S = { ticket: '', list: null, lists: null, sharing: false, variants: {}, products: {}, count: 0, stuaOn: false, stuaDigest: false, stua: [] };
  var statePromise = null;
  var refs = {};          // variant id -> { ref, product } for lines the page knows (list, add answers)
  var listLoaded = null;  // promise of the full list (lazy, for removals from a heart)

  /* Failure keeps the last good state; whether it ends the session is judge()'s call (plus 403: the proxy refused the signature).
     Only the newest call writes S, so an older answer cannot undo a later change. */
  var stateGen = 0;
  function loadState() {
    var my = ++stateGen;
    statePromise = read('/state').then(function (r) {
      judge(r, true);
      if (r.status === 403) turnOff();
      var d = r.data;
      if (r.status !== 200 || !d || typeof d.ticket !== 'string' || !d.ticket || d.ticket.length > 512) return false;
      if (my !== stateGen) return true;
      S.ticket = d.ticket;
      S.list = d.list && typeof d.list === 'object' && REF_RE.test(str(d.list.ref, 64))
        ? { ref: d.list.ref, count: typeof d.list.count === 'number' ? d.list.count : 0 } : null;
      /* Port 2 (contract v2.0): every list of the customer and whether sharing is on in the portal. Missing (an older portal): null, and
         the page looks as in port 1. saved is the union of the active lists. */
      S.lists = Array.isArray(d.lists) ? d.lists.slice(0, 200).map(listOf).filter(Boolean) : null;
      S.sharing = !!(d.features && d.features.sharing === true);
      S.gifts = !!(d.features && d.features.gifts === true);   // port 3 (contract v3.0)
      /* Ønskestua (contract v4.1, 2026-10-11): every Ønskestue the customer is in, also as owner. Missing or features.stua off: nothing of it
         shows. */
      S.stuaOn = !!(d.features && d.features.stua === true);
      S.stuaDigest = !!(d.features && d.features.digest === true);   // v4.3: the join box shows only with this (missing = off)
      S.stua = S.stuaOn && Array.isArray(d.stua) ? d.stua.slice(0, 100).map(stuaOf).filter(Boolean) : [];
      S.variants = {};
      S.products = {};
      var saved = d.saved || {};
      (Array.isArray(saved.variants) ? saved.variants : []).slice(0, GUEST_MAX).forEach(function (v) { if (id(v)) S.variants[id(v)] = true; });
      (Array.isArray(saved.products) ? saved.products : []).slice(0, GUEST_MAX).forEach(function (p) { if (id(p)) S.products[id(p)] = true; });
      S.count = S.list ? S.list.count : 0;
      return true;
    });
    return statePromise;
  }

  function listOf(o) {
    if (!o || typeof o !== 'object' || !REF_RE.test(str(o.ref, 64))) return null;
    return {
      ref: o.ref, name: str(o.name, 80) || t('header_label', 'Min ønskeliste'),
      count: typeof o.count === 'number' ? o.count : 0, isDefault: o.is_default === true,
      status: o.status === 'archived' ? 'archived' : 'active', shared: o.share_mode === 'unlisted',
      /* Port 3: a gift list (kind 'gift') with its settings; missing on an older portal. */
      kind: o.kind === 'gift' || o.kind === 'stua' ? o.kind : 'standard', gift: giftOf(o.gift),
      /* Ønskestua (portal answer 2026-10-11, Tillegg 1 §2): the settings for the edit form. */
      stua: o.kind === 'stua' && o.stua && typeof o.stua === 'object' ? {
        occasion: str(o.stua.occasion, 60), date: /^\d{4}-\d{2}-\d{2}$/.test(str(o.stua.event_date, 10)) ? o.stua.event_date : '',
        message: str(o.stua.message, 500), from: str(o.stua.from_name, 60), me: { name: str(o.stua.me && o.stua.me.display_name, 40) }
      } : null
    };
  }
  /* One entry of state.stua: {ref, name, role, count, locked, members}. */
  function stuaOf(o) {
    if (!o || typeof o !== 'object' || !REF_RE.test(str(o.ref, 64))) return null;
    return { ref: o.ref, name: str(o.name, 80) || t('s_name', 'Gaveplan'), owner: o.role === 'owner', count: count0(o.count), locked: o.locked === true, members: count0(o.members) };
  }
  function count0(v) { return typeof v === 'number' && isFinite(v) && v >= 0 ? Math.floor(v) : 0; }
  function giftOf(g) {
    if (!g || typeof g !== 'object') return null;
    return {
      occasion: str(g.occasion, 60), date: /^\d{4}-\d{2}-\d{2}$/.test(str(g.event_date, 10)) ? g.event_date : '',
      message: str(g.message, 500), from: str(g.from_name, 60),
      visibility: g.visibility === 'visible' ? 'visible' : 'surprise', mode: g.share_mode === 'unlisted' ? 'unlisted' : 'invite_only'
    };
  }
  /* «12.12.2026» from «2026-12-12». */
  function dateNo(v) { var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(v || ''); return m ? m[3] + '.' + m[2] + '.' + m[1] : ''; }
  /* «Today» in Norwegian time (the portal checks purchased_on against Oslo), the browser's date as a fallback. */
  function todayIso() {
    try { var o = new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Oslo', year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date()); if (/^\d{4}-\d{2}-\d{2}$/.test(o)) return o; } catch (e) { /* old browser */ }
    var d = new Date(); function p2(n) { return (n < 10 ? '0' : '') + n; } return d.getFullYear() + '-' + p2(d.getMonth() + 1) + '-' + p2(d.getDate());
  }
  function activeLists() { return (S.lists || []).filter(function (l) { return l.status === 'active'; }); }
  function listByRef(ref) { var f = null; (S.lists || []).forEach(function (l) { if (l.ref === ref) f = l; }); return f; }
  function defaultList() { var f = null; (S.lists || []).forEach(function (l) { if (l.isDefault) f = l; }); return f; }

  /* POST with the ticket; on 403 ticket_expired the state is fetched once and the request sent again. opts.noJudge: the answer never turns
     the wishlist off for the session (sharing, §14 A3). */
  function write(path, body, opts) {
    function send() {
      body.ticket = S.ticket;
      return request(path, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) }, WRITE_MS);
    }
    return send().then(function (r) {
      if (r.status === 403 && r.data && r.data.error === 'ticket_expired') {
        return loadState().then(function (ok) { return ok ? send() : r; });
      }
      return r;
    }).then(function (r) { if (!(opts && opts.noJudge)) judge(r, false); return r; });
  }

  /* Text for a failed write; null when the session is now off (the hearts are gone). */
  function failText(r) {
    var err = r.data && typeof r.data.error === 'string' ? r.data.error : '';
    if (r.status === 401) return { text: t('login_required', 'Logg inn på nytt.'), link: { href: loginHref(), text: t('login', 'Logg inn') } };
    if (r.status === 409 && err === 'already_in_list') return { text: t('already', 'Varen ligger allerede i ønskelisten.') };
    if (r.status === 409 && err === 'limit_reached') {
      var lim = typeof r.data.limit === 'number' ? r.data.limit : GUEST_MAX;
      return { text: t('limit', 'Ønskelisten er full.').replace('__N__', String(lim)) };
    }
    return { text: t('error', 'Noe gikk galt. Prøv igjen senere.') };
  }
  function sayFail(r) { var f = failText(r); say(f.text, f.link); }

  function rememberItem(item) {
    if (!item || typeof item !== 'object' || !REF_RE.test(str(item.ref, 64))) return;
    var p = item.product || {};
    var v = id(p.variant_id);
    if (v) refs[v] = { ref: item.ref, product: id(p.product_id) };
  }

  /* One list (default: the standard list). Only the standard list feeds the heart refs: a heart saves there and removes from there. */
  function loadList(ref) {
    var def = S.list ? S.list.ref : '';
    ref = ref || def;
    if (!ref) return Promise.resolve(null);
    return read('/list/' + encodeURIComponent(ref)).then(function (r) {
      judge(r, false);
      if (r.status !== 200 || !r.data || !Array.isArray(r.data.items)) return null;
      var items = r.data.items.slice(0, GUEST_MAX);
      if (ref === def) {
        items.forEach(rememberItem);
        if (r.data.list && typeof r.data.list.count === 'number') S.count = r.data.list.count;
      }
      return items;
    });
  }
  function knownList() {
    if (!listLoaded) listLoaded = loadList().then(function (items) { if (!items) listLoaded = null; return items; });
    return listLoaded;
  }

  /* ── Guest list (this browser) ───────────────────────────────────────────────────────────────────────────────────── */
  function guestRead() {
    var g = null;
    try { g = JSON.parse(window.localStorage.getItem(GUEST_KEY) || 'null'); } catch (e) { g = null; }
    if (!g || typeof g !== 'object' || !Array.isArray(g.items)) g = { v: 1, items: [], asked: '', pending: '' };
    var seen = {};
    g.items = g.items.filter(function (it) {
      if (!it || !id(it.v) || seen[it.v]) return false;
      seen[it.v] = true;
      it.p = id(it.p);
      it.q = Math.min(QTY_MAX, Math.max(1, parseInt(it.q, 10) || 1));
      it.c = it.c ? 1 : 0;
      it.pr = typeof it.pr === 'number' && it.pr >= 0 ? Math.round(it.pr) : null;
      return true;
    }).slice(0, GUEST_MAX);
    g.asked = str(g.asked, 64);
    g.pending = str(g.pending, 64);
    return g;
  }
  function guestWrite(g) {
    try {
      if (!g.items.length && !g.asked && !g.pending) window.localStorage.removeItem(GUEST_KEY);
      else window.localStorage.setItem(GUEST_KEY, JSON.stringify({ v: 1, items: g.items, asked: g.asked, pending: g.pending }));
      return true;
    } catch (e) { return false; }
  }
  function guestFind(g, v) { for (var i = 0; i < g.items.length; i++) if (g.items[i].v === v) return i; return -1; }

  /* ── Hearts ──────────────────────────────────────────────────────────────────────────────────────────────────────── */
  var ready = false;
  var settled = false;   // the first state request has answered (or the wishlist is off): a page set up later can draw at once
  function buttons() { return document.querySelectorAll('button[data-wl-btn]'); }
  function hideHearts() {
    Array.prototype.forEach.call(buttons(), function (b) { b.hidden = true; });
    document.querySelectorAll('[data-wl-move]').forEach(function (b) { b.hidden = true; });
    document.querySelectorAll('[data-wl-stua-add]').forEach(function (b) { b.hidden = true; });
  }

  /* Saved? Variant mode: that variant. Product mode: any variant of the product. */
  function isSaved(btn, g) {
    var v = btn.getAttribute('data-wl-variant');
    var p = btn.getAttribute('data-wl-product');
    var variantMode = btn.getAttribute('data-wl-mode') === 'variant';
    if (signedIn) return variantMode ? !!S.variants[v] : !!S.products[p];
    g = g || guestRead();
    return g.items.some(function (it) { return variantMode ? it.v === v : it.p === p; });
  }

  function sync() {
    if (!ready) return;
    var g = signedIn ? null : guestRead();
    Array.prototype.forEach.call(buttons(), function (b) {
      b.setAttribute('aria-pressed', isSaved(b, g) ? 'true' : 'false');
      b.hidden = false;
    });
    document.querySelectorAll('[data-wl-move]').forEach(function (b) { b.hidden = false; });
    stuaButtons();
    var n = signedIn ? S.count : g.items.length;
    document.querySelectorAll('[data-wl-header]').forEach(function (a) {
      var bubble = a.querySelector('[data-wl-count]');
      if (bubble) { bubble.textContent = n > 99 ? '99+' : String(n); bubble.hidden = !(n > 0); }
      if (n > 0) a.setAttribute('aria-label', tn('count_label', n, a.getAttribute('title') || ''));
      else if (a.getAttribute('title')) a.setAttribute('aria-label', a.getAttribute('title'));
    });
  }

  var syncQueued = false;
  function queueSync() {
    if (syncQueued) return;
    syncQueued = true;
    window.requestAnimationFrame(function () { syncQueued = false; sync(); });
  }

  /* Product page: the chosen variant from the form, now and after every change. */
  function pickVariant(scope) {
    var input = scope.querySelector('product-form input[name="id"], form[action*="/cart/add"] input[name="id"]');
    return input && id(input.value) ? input.value : '';
  }
  function followForm() {
    document.querySelectorAll('button[data-wl-btn][data-wl-mode="variant"]').forEach(function (b) {
      var v = pickVariant(b.closest('.shopify-section') || document);
      if (v) b.setAttribute('data-wl-variant', v);
    });
  }
  document.addEventListener('pippei:variant-change', function (e) {
    var v = e.detail && e.detail.variant && id(e.detail.variant.id);
    if (!v) return;
    var scope = (e.target && e.target.closest && e.target.closest('.shopify-section')) || document;
    var price = e.detail.variant.price;
    scope.querySelectorAll('button[data-wl-btn][data-wl-mode="variant"]').forEach(function (b) {
      b.setAttribute('data-wl-variant', v);
      if (typeof price === 'number') b.setAttribute('data-wl-price', String(price));
    });
    queueSync();
  });

  var busy = {};
  var lastHeart = null;   // focus goes back here after «Velg annen liste»
  var pendingInvites = {};   // port 3: addresses kept when a wizard save sent no invitations (list ref -> text)
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('button[data-wl-btn]') : null;
    if (!btn) return;
    e.preventDefault();
    if (!ready || btn.closest('[inert]')) return;
    var v = btn.getAttribute('data-wl-variant');
    var p = btn.getAttribute('data-wl-product');
    if (!id(v) || !id(p)) return;
    var key = v + '|' + p;
    if (busy[key]) return;
    var chosen = btn.getAttribute('data-wl-chosen') === '1';
    var variantMode = btn.getAttribute('data-wl-mode') === 'variant';
    var saved = isSaved(btn);
    lastHeart = btn;
    if (!signedIn) { guestToggle(btn, v, p, chosen, variantMode, saved); return; }

    busy[key] = true;
    setPressed(p, v, variantMode, !saved);   // optimistic; rolled back below on failure
    var job = saved ? removeFrom(v, p, variantMode) : addTo(v, chosen);
    job.then(function (ok) {
      busy[key] = false;
      if (!ok) { queueSync(); return; }
      sync();
      /* With several lists (port 2) the counts on the list tabs come from the state. */
      if (S.lists) loadState().then(function () { sync(); if (page) page.refresh(); });
      else if (page) page.refresh();
    });
  });

  /* Optimistic pressed state for every button of the same variant/product (also the inert clones). */
  function setPressed(p, v, variantMode, on) {
    Array.prototype.forEach.call(buttons(), function (b) {
      var same = variantMode ? b.getAttribute('data-wl-variant') === v && b.getAttribute('data-wl-mode') === 'variant'
        : b.getAttribute('data-wl-product') === p && b.getAttribute('data-wl-mode') === 'product';
      if (same) b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  function addTo(v, chosen) {
    return write('/items', { variant_id: v, quantity: 1, variant_chosen: chosen }).then(function (r) {
      if ((r.status === 200 || r.status === 201) && r.data && r.data.item) {
        rememberItem(r.data.item);
        var p = id(r.data.item.product && r.data.item.product.product_id);
        S.variants[v] = true;
        if (p) S.products[p] = true;
        if (r.data.created === true) {
          S.count += 1;
          if (!S.list) loadState();
          savedNotice(r.data.item);
        } else say(t('already', 'Varen ligger allerede i ønskelisten.'));
        return true;
      }
      if (r.status === 409 && r.data && r.data.error === 'already_in_list') { S.variants[v] = true; say(t('already')); return true; }
      if (isOff()) return false;
      sayFail(r);
      return false;
    });
  }

  /* Remove from a heart: the line(s) of that variant, or of that product when the card is pressed. Several lines of one product from a
     card: nothing is removed; the notice points to the list page. */
  function removeFrom(v, p, variantMode, again) {
    var known = variantMode && refs[v] ? Promise.resolve(null) : knownList();
    return known.then(function (items) {
      if (items === null && !(variantMode && refs[v])) { if (!isOff()) say(t('error', 'Noe gikk galt. Prøv igjen senere.')); return false; }
      var targets = [];
      Object.keys(refs).forEach(function (rv) {
        if (variantMode ? rv === v : refs[rv].product === p) targets.push(refs[rv].ref);
      });
      if (!targets.length) {
        /* Not in the standard list as far as the page knows: read it once more (a copy or move may have changed it). */
        if (S.lists && !again) { listLoaded = null; return removeFrom(v, p, variantMode, true); }
        /* Port 2: in another list (saved is the union, §14 A4) or already gone; other lists are changed on the page. Port 1 portal:
           already gone, as before. */
        return loadState().then(function () {
          if (S.lists && (variantMode ? S.variants[v] : S.products[p])) {
            say(t('in_other', 'Varen ligger i en annen liste.'), { href: cfg.page || '/pages/onskeliste', text: t('header_label', 'Min ønskeliste') });
            return false;
          }
          return true;
        });
      }
      if (targets.length > 1) {
        say(t('several', 'Flere varianter ligger i ønskelisten.'), { href: cfg.page || '/pages/onskeliste', text: t('header_label', 'Min ønskeliste') });
        return false;
      }
      return write('/items/' + encodeURIComponent(targets[0]) + '/remove', {}).then(function (r) {
        if (r.status === 200 || r.status === 404) {
          Object.keys(refs).forEach(function (rv) { if (refs[rv].ref === targets[0]) delete refs[rv]; });
          say(t('removed', 'Fjernet fra ønskelisten.'));
          return loadState().then(function () { return true; });   // which products still have lines: the portal knows
        }
        if (!isOff()) sayFail(r);
        return false;
      });
    });
  }

  function guestToggle(btn, v, p, chosen, variantMode, saved) {
    var g = guestRead();
    if (saved) {
      var hits = g.items.filter(function (it) { return variantMode ? it.v === v : it.p === p; });
      if (hits.length > 1) { say(t('several'), { href: cfg.page || '/pages/onskeliste', text: t('header_label', 'Min ønskeliste') }); return; }
      g.items = g.items.filter(function (it) { return it !== hits[0]; });
      if (guestWrite(g)) say(t('removed', 'Fjernet fra ønskelisten.'));
    } else {
      if (g.items.length >= GUEST_MAX) { say(t('guest_full').replace('__N__', String(GUEST_MAX)), { href: loginHref(), text: t('login', 'Logg inn') }); return; }
      var pr = parseInt(btn.getAttribute('data-wl-price'), 10);
      g.items.unshift({ v: v, p: p, q: 1, c: chosen ? 1 : 0, t: Math.floor(Date.now() / 1000), pr: pr >= 0 ? pr : null });
      g.asked = '';   // new lines: the next sign-in asks again
      if (guestWrite(g)) say(t('saved_guest', 'Lagret i denne nettleseren.'), { href: loginHref(), text: t('login', 'Logg inn') });
    }
    sync();
    if (page) page.refresh();
  }

  /* «Lagret i Min ønskeliste · Velg annen liste» (Knut 2026-10-11, port 2 choice 1): a heart always saves in the standard list; with more
     than one active list the notice offers to move the item. Without lists (an older portal) the notice is as before. */
  function savedNotice(item) {
    var def = defaultList();
    if (!def) { say(t('saved', 'Lagret i ønskelisten.')); return; }
    var text = t('saved_in', 'Lagret i __L__.').replace('__L__', def.name);
    var others = activeLists().filter(function (l) { return !l.isDefault && l.kind !== 'stua'; });
    var ref = item && REF_RE.test(str(item.ref, 64)) ? item.ref : '';
    if (!others.length || !ref) { say(text); return; }
    say(text, { text: t('choose_list', 'Velg annen liste'), action: function () { pickList(ref, others); } });
  }

  /* A small dialog with the other active lists; «Flytt» moves the item there (POST items/{ref}/move). */
  function pickList(itemRef, lists) {
    if (typeof HTMLDialogElement === 'undefined' || !document.body) return;
    var d = el('dialog', { class: 'rw wl-pick', 'aria-labelledby': 'wl-pick-title' });
    var box = el('div', { class: 'rw__box' });
    var head = el('div', { class: 'rw__head' });
    head.appendChild(el('h2', { id: 'wl-pick-title', class: 'rw__title' }, t('choose_title', 'Hvilken liste skal varen ligge i?')));
    var x = el('button', { type: 'button', class: 'rw__close', 'aria-label': t('close', 'Lukk') }, '×');
    head.appendChild(x);
    var body = el('div', { class: 'rw__body' });
    var fs = el('fieldset', { class: 'wl-pick__set' });
    fs.appendChild(el('legend', { class: 'rw__sr' }, t('choose_title', 'Hvilken liste skal varen ligge i?')));
    lists.forEach(function (l, i) {
      var lab = el('label', { class: 'wl-pick__opt' });
      lab.appendChild(el('input', { type: 'radio', name: 'wl-pick', value: l.ref, checked: i === 0 ? true : null }));
      lab.appendChild(el('span', null, l.name));
      fs.appendChild(lab);
    });
    body.appendChild(fs);
    var actions = el('div', { class: 'rw__actions' });
    var go = el('button', { type: 'button', class: 'rw__submit' }, t('move_btn', 'Flytt'));
    var no = el('button', { type: 'button', class: 'rw__cancel' }, t('cancel', 'Avbryt'));
    actions.appendChild(go); actions.appendChild(no);
    body.appendChild(actions);
    box.appendChild(head); box.appendChild(body); d.appendChild(box);
    var opener = lastHeart && document.contains(lastHeart) ? lastHeart : document.activeElement;
    var closed = false;
    function close() {
      if (closed) return;
      closed = true;
      if (d.open) d.close();
      document.documentElement.classList.remove('pk-lock');
      if (d.parentNode) d.parentNode.removeChild(d);
      if (opener && opener.focus && document.contains(opener)) opener.focus({ preventScroll: true });
    }
    x.addEventListener('click', close);
    no.addEventListener('click', close);
    d.addEventListener('close', close);
    d.addEventListener('click', function (e) { if (e.target === d) close(); });
    go.addEventListener('click', function () {
      var pick = d.querySelector('input[name="wl-pick"]:checked');
      var to = pick ? listByRef(pick.value) : null;
      if (!to) return;
      go.disabled = true;
      write('/items/' + encodeURIComponent(itemRef) + '/move', { list_ref: to.ref }).then(function (r) {
        close();
        if (r.status === 200) {
          Object.keys(refs).forEach(function (rv) { if (refs[rv].ref === itemRef) delete refs[rv]; });
          say(t('moved', 'Flyttet til __L__.').replace('__L__', to.name));
          loadState().then(function () { sync(); if (page) page.refresh(); });
          return;
        }
        if (!isOff()) say(listFail(r, to.name, 'line'));
      });
    });
    document.body.appendChild(d);
    d.showModal();
    document.documentElement.classList.add('pk-lock');
    var first = d.querySelector('input[name="wl-pick"]');
    if (first) first.focus({ preventScroll: true });
  }

  /* Texts for the list and move answers (port 2): 409 limit_reached (20 lists or 250 lines), already_in_list, default_list. */
  function listFail(r, listName, kind) {
    var err = r.data && typeof r.data.error === 'string' ? r.data.error : '';
    if (r.status === 409 && err === 'already_in_list') return t('already_in', 'Varen ligger allerede i __L__.').replace('__L__', listName || '');
    if (r.status === 409 && err === 'default_list') return t('default_list', 'Standardlista kan ikke slettes eller arkiveres.');
    if (r.status === 409 && err === 'limit_reached') {
      var lim = r.data && typeof r.data.limit === 'number' ? r.data.limit : 0;
      return kind === 'list' ? t('lists_limit', '').replace('__N__', String(lim || 20)) : t('limit', '').replace('__N__', String(lim || GUEST_MAX));
    }
    if (r.status === 422) return t('name_invalid', 'Sjekk navnet.');
    return failText(r).text;
  }

  /* ── «Flytt til ønskelisten» from a cart line (snippets/wishlist-move.liquid) ─────────────────────────────────────────── */
  /* Save first (chosen variant, the line quantity up to 99), then remove the line with its own remove link, so assets/cart-drawer.js
     updates the drawer or the cart page as usual. Already saved: the line is removed all the same («Lå allerede …»; the list keeps its
     quantity). A failed save keeps the line. «Angre» puts the line back in the cart and takes a newly saved item off the list again. */
  var moving = false;
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('[data-wl-move]') : null;
    if (!b) return;
    e.preventDefault();
    if (moving || b.disabled) return;
    if (!ready) { say(t('error', 'Noe gikk galt. Prøv igjen senere.')); return; }
    var v = id(b.getAttribute('data-variant'));
    var p = id(b.getAttribute('data-product'));
    var line = b.closest('[data-cart-line]');
    var qtyInput = line && line.querySelector('[data-line-qty]');   // a quantity change may still be on its way: the field is the truth
    var q = Math.min(QTY_MAX, Math.max(1, parseInt(qtyInput ? qtyInput.value : b.getAttribute('data-qty'), 10) || 1));
    var pr = parseInt(b.getAttribute('data-price'), 10);
    if (!v || !p) return;
    var inDrawer = !!b.closest('cart-drawer');
    moving = true;
    b.disabled = true;
    saveFromCart(v, p, q, pr >= 0 ? pr : null).then(function (res) {
      if (!res) { moving = false; b.disabled = false; return; }
      /* The cart may have been drawn again while saving (another change, the delivery-date guard): find the line anew. Eligible lines
         carry no properties, so one variant is one line. */
      var fresh = document.querySelector('[data-cart-root] [data-wl-move][data-variant="' + v + '"]');
      var target = fresh ? fresh.closest('[data-cart-line]') : null;
      var cart = window.PippeiCart;
      var gone = target && cart && typeof cart.remove === 'function' ? cart.remove(target) : Promise.resolve(false);
      return gone.then(function (removed) {
        moving = false;
        sync();
        if (page) page.refresh();
        if (!removed) { say(res.created ? t('saved', 'Lagret i ønskelisten.') : t('already', 'Varen ligger allerede i ønskelisten.')); return; }
        say(res.created ? t('move_done', 'Flyttet til ønskelisten.') : t('move_already', 'Lå allerede i ønskelisten.'), {
          text: t('undo', 'Angre'),
          action: function () { undoMove(v, q, res, inDrawer); }
        });
        /* The line (and the focused button) is gone: keyboard focus goes to «Angre» (in the drawer's Tab loop, see cart-drawer.js). */
        var undo = live && live.querySelector('.wl-live__action');
        if (undo) undo.focus({ preventScroll: true });
      });
    }).catch(function () { moving = false; if (b.isConnected) b.disabled = false; });
  });

  /* Resolves to { created, ref } or null (nothing saved; the notice is shown). */
  function saveFromCart(v, p, q, pr) {
    if (!signedIn) {
      var g = guestRead();
      if (guestFind(g, v) !== -1) return Promise.resolve({ created: false });
      if (g.items.length >= GUEST_MAX) { say(t('guest_full').replace('__N__', String(GUEST_MAX)), { href: loginHref(), text: t('login', 'Logg inn') }); return Promise.resolve(null); }
      g.items.unshift({ v: v, p: p, q: q, c: 1, t: Math.floor(Date.now() / 1000), pr: pr });
      g.asked = '';
      return Promise.resolve(guestWrite(g) ? { created: true } : null);
    }
    return write('/items', { variant_id: v, quantity: q, variant_chosen: true }).then(function (r) {
      if ((r.status === 200 || r.status === 201) && r.data && r.data.item) {
        rememberItem(r.data.item);
        S.variants[v] = true;
        S.products[p] = true;
        var created = r.data.created === true;
        if (created) { S.count += 1; if (!S.list) loadState(); }
        return { created: created, ref: str(r.data.item.ref, 64) };
      }
      if (r.status === 409 && r.data && r.data.error === 'already_in_list') return { created: false };
      if (!isOff()) sayFail(r);
      return null;
    });
  }

  function undoMove(v, q, res, inDrawer) {
    var cart = window.PippeiCart && typeof window.PippeiCart.add === 'function' ? window.PippeiCart.add([{ id: Number(v), quantity: q }]) : null;
    if (!cart) { say(t('error', 'Noe gikk galt. Prøv igjen senere.')); return; }
    cart.then(function () {
      /* The notice (and its focused button) is gone: back into the open drawer, at its close button. */
      var d = inDrawer && document.querySelector('cart-drawer.is-open');
      var f = d && d.querySelector('[data-drawer-close]:not(.cart-drawer__overlay)');
      if (f) f.focus({ preventScroll: true });
      if (!res.created) return;
      if (!signedIn) {
        var g = guestRead();
        var i = guestFind(g, v);
        if (i !== -1) { g.items.splice(i, 1); guestWrite(g); }
        sync();
        if (page) page.refresh();
        return;
      }
      if (!REF_RE.test(res.ref || '')) return;
      write('/items/' + encodeURIComponent(res.ref) + '/remove', {}).then(function (r) {
        if (r.status === 200 || r.status === 404) {
          delete refs[v];
          loadState().then(function () { sync(); if (page) page.refresh(); });
        }
      });
    }, function () { /* the cart shows its own error */ });
  }

  /* ── Moving the guest list after sign-in ─────────────────────────────────────────────────────────────────────────── */
  var dlg = null;
  /* variant_chosen per line (portal 2026-10-10): a card save of a product with several variants stays «Velg variant» after the move. */
  function mergeLines(g) { return g.items.map(function (it) { return { variant_id: it.v, quantity: it.q, variant_chosen: it.c === 1 }; }); }

  function runMerge() {
    var g = guestRead();
    if (!g.items.length) return Promise.resolve(false);
    g.pending = who;
    guestWrite(g);
    return write('/merge', { items: mergeLines(g) }).then(function (r) {
      var d = r.data;
      if (r.status === 200 && d && typeof d === 'object') {
        /* Three outcomes (Knut 2026-10-11, guest test): new in the list (added), already in the list (sent − added − skipped; «updated»
           only raised the quantity, the portal keeps the larger one) and could not be moved (skipped: unknown variant or the list full).
           The browser list is emptied after 200 as agreed; skipped lines are not kept. */
        var sent = g.items.length;
        var added = typeof d.added === 'number' ? d.added : 0;
        var skipped = Array.isArray(d.skipped) ? d.skipped.length : 0;
        var already = Math.max(0, sent - added - skipped);
        var parts = [];
        if (added) parts.push(tn('merge_done', added, ''));
        if (already) parts.push(tn('merge_already', already, ''));
        if (skipped) parts.push(tn('merge_skipped', skipped, ''));
        guestWrite({ items: [], asked: '', pending: '' });
        listLoaded = null;
        say(parts.join(' '));
        return loadState().then(function () { sync(); if (page) page.refresh(); return true; });
      }
      if (r.status === 422 || r.status === 413 || r.status === 415) { g.pending = ''; g.asked = who; guestWrite(g); }
      if (!isOff()) say(t('merge_failed', 'Kunne ikke flytte varene nå.'));
      return false;
    });
  }

  function askMerge(n) {
    if (typeof HTMLDialogElement === 'undefined' || !document.body) return;
    dlg = el('dialog', { class: 'rw wl-merge', 'aria-labelledby': 'wl-merge-title' });
    var box = el('div', { class: 'rw__box' });
    var head = el('div', { class: 'rw__head' });
    head.appendChild(el('h2', { id: 'wl-merge-title', class: 'rw__title' }, t('merge_title', 'Flytte varene til ønskelisten din?')));
    var x = el('button', { type: 'button', class: 'rw__close', 'aria-label': t('close', 'Lukk') }, '×');
    head.appendChild(x);
    var body = el('div', { class: 'rw__body' });
    body.appendChild(el('p', { class: 'rw__intro' }, tn('merge_text', n, '')));
    var actions = el('div', { class: 'rw__actions' });
    var move = el('button', { type: 'button', class: 'rw__submit' }, t('merge_move', 'Flytt'));
    var later = el('button', { type: 'button', class: 'rw__cancel' }, t('merge_later', 'Ikke nå'));
    var drop = el('button', { type: 'button', class: 'rw__cancel' }, t('merge_discard', 'Forkast'));
    actions.appendChild(move); actions.appendChild(later); actions.appendChild(drop);
    body.appendChild(actions);
    box.appendChild(head); box.appendChild(body); dlg.appendChild(box);
    var box2 = dlg, done = false, opener = document.activeElement;
    /* The choice is handled right away; the close event (Esc and the browser's own ways of closing) only covers «Ikke nå». Runs once. */
    function finish(c) {
      if (done) return;
      done = true;
      if (box2.open) box2.close();
      document.documentElement.classList.remove('pk-lock');
      if (box2.parentNode) box2.parentNode.removeChild(box2);
      if (dlg === box2) dlg = null;
      var g = guestRead();
      if (c === 'move') runMerge();
      else if (c === 'drop') { guestWrite({ items: [], asked: '', pending: '' }); sync(); if (page) page.refresh(); }
      else { g.asked = who; guestWrite(g); if (page) page.refresh(); }
      if (opener && opener.focus && document.contains(opener)) opener.focus({ preventScroll: true });
    }
    move.addEventListener('click', function () { finish('move'); });
    later.addEventListener('click', function () { finish('later'); });
    drop.addEventListener('click', function () { finish('drop'); });
    x.addEventListener('click', function () { finish('later'); });
    box2.addEventListener('click', function (e) { if (e.target === box2) finish('later'); });
    box2.addEventListener('close', function () { finish('later'); });
    document.body.appendChild(dlg);
    dlg.showModal();
    document.documentElement.classList.add('pk-lock');
    move.focus({ preventScroll: true });
  }

  function checkGuestList() {
    if (!signedIn || !who) return;
    var g = guestRead();
    if (!g.items.length) return;
    if (g.pending === who) { runMerge(); return; }   // the last move failed: try again without asking
    if (g.asked !== who) askMerge(g.items.length);
  }

  /* ── «Min ønskeliste» (sections/wishlist-page.liquid) ────────────────────────────────────────────────────────────── */
  /* ── Ønskestua, shared parts (2026-10-11): the invitation waiting in sessionStorage (layout/theme.liquid puts #s= there), texts for
     refused stua calls, and «Legg til i Ønskestua» next to the heart on the product page. ── */
  var STUA_INV_KEY = 'pp-wl-stua-inv';
  function stuaInvite() { try { var v = window.sessionStorage.getItem(STUA_INV_KEY) || ''; return TOKEN_RE_G.test(v) ? v : ''; } catch (e) { return ''; } }
  function dropInvite() { try { window.sessionStorage.removeItem(STUA_INV_KEY); } catch (e) { /* no storage */ } }
  function stuaPageLink(ref) { var p = cfg.page || '/pages/onskeliste'; return p + (p.indexOf('?') === -1 ? '?' : '&') + 'stue=' + encodeURIComponent(ref); }
  /* A member as the others see her: the visible name, or «Tidligere deltaker» (left, removed or deleted). Never an e-mail. */
  function whoName(m) { return !m || m.former === true ? t('s_former', 'Tidligere deltaker') : (str(m.display_name, 40) || t('s_former', 'Tidligere deltaker')); }
  function stuaFail(r) {
    var err = r.data && typeof r.data.error === 'string' ? r.data.error : '';
    if (r.status === 401) return t('login_required', 'Logg inn på nytt.');
    if (err === 'list_locked') return t('s_locked', 'Gaveplanen er låst av eieren.');
    if (err === 'forbidden') return t('s_forbidden', 'Det har du ikke tilgang til.');
    if (err === 'limit_reached') {
      var lim = r.data.limit;
      if (lim === 'members') return t('s_limit_members', 'Gaveplanen er full (høyst 30 deltakere).');
      if (lim === 'comments') return t('s_limit_comments', 'Tråden er full (høyst 200 kommentarer).');
      if (lim === 'max_lists') return t('s_limit_lists', 'Du har nådd grensen for antall lister.');
      return t('s_limit_items', 'Gaveplanen er full (høyst 250 varer).');
    }
    if (err === 'wrong_kind') return t('s_wrong_kind', 'Det går ikke med denne listetypen.');
    /* Gaveplan fase 2 (contract v4.2). */
    if (err === 'expired') return t('s_expired', 'Det er for sent å gjenopprette (mer enn 30 dager).');
    if (err === 'item_removed') return t('s_item_removed', 'Forslaget kommentaren hører til, er fjernet. Gjenopprett forslaget først.');
    if (err === 'deleted') return t('s_comment_gone', 'Kommentaren er slettet.');
    if (err === 'not_restorable') return t('s_not_restorable', 'Dette kan ikke gjenopprettes.');
    if (err === 'already_in_list') return t('s_already', 'Varen er allerede foreslått i gaveplanen.');
    /* Gaveplan last delivery (contract v4.3). */
    if (err === 'email_unavailable') return t('s_email_unavailable', 'Vi har ingen e-postadresse for deg ennå. Den hentes fra din siste ordre, så varsler kan slås på når du har handlet hos oss.');
    if (err === 'transfer_disabled') return t('s_transfer_off', 'Overføring av eierskap er ikke tilgjengelig akkurat nå.');
    if (r.status === 404) return t('s_gone', 'Du har ikke tilgang til denne gaveplanen lenger.');
    if (r.status === 422) return t('s_invalid', 'Sjekk det du har skrevet.');
    if (r.status === 0 || r.status >= 500) return t('s_unavailable', 'Gaveplanen er ikke tilgjengelig akkurat nå.');
    return t('error', 'Noe gikk galt. Prøv igjen senere.');
  }
  /* Shown only for a signed-in customer in at least one Ønskestue that is not locked (features.stua on). */
  function stuaOpenList() { return signedIn && ready && S.stuaOn ? S.stua.filter(function (s) { return !s.locked; }) : []; }
  function stuaButtons() {
    var n = stuaOpenList().length;
    document.querySelectorAll('[data-wl-stua-add]').forEach(function (b) { b.hidden = !n; });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-wl-stua-add]');
    if (!b || b.closest('[inert]')) return;
    var open = stuaOpenList();
    if (!open.length) return;
    var v = pickVariant(b.closest('.shopify-section') || document);
    if (!v) { say(t('select_first', 'Velg variant først')); return; }
    if (open.length === 1) { stuaAdd(open[0], v, b); return; }
    stuaPick(open, function (s) { stuaAdd(s, v, b); });
  });
  /* POST stua/{ref}/items: a variant already suggested becomes a thumbs up (D6, created false, voted true). */
  function stuaAdd(s, v, b) {
    b.disabled = true;
    write('/stua/' + encodeURIComponent(s.ref) + '/items', { variant_id: v, quantity: 1 }, { noJudge: true }).then(function (r) {
      b.disabled = false;
      var d = r.data, err = d && typeof d.error === 'string' ? d.error : '';
      var open = { href: stuaPageLink(s.ref), text: t('s_open', 'Åpne gaveplanen') };
      if (r.status === 200 && d && d.item) {
        if (d.created !== true && d.voted === true) say(t('s_voted_instead', 'Den var allerede foreslått – du ga den en tommel opp'), open);
        else say(t('s_added', 'Lagt til i «__L__».').replace('__L__', s.name), open);
        return;
      }
      say(stuaFail(r));
      if (err === 'list_locked') { s.locked = true; stuaButtons(); }
      else if (r.status === 404) loadState().then(stuaButtons);
    });
  }
  /* Which Ønskestue (more than one open). */
  function stuaPick(list, done) {
    if (typeof HTMLDialogElement === 'undefined' || !document.body) return;
    var d = el('dialog', { class: 'rw wl-pick', 'aria-labelledby': 'wl-spick-title' });
    var box = el('div', { class: 'rw__box' });
    var head = el('div', { class: 'rw__head' });
    head.appendChild(el('h2', { id: 'wl-spick-title', class: 'rw__title' }, t('s_pick_title', 'Hvilken gaveplan?')));
    var x = el('button', { type: 'button', class: 'rw__close', 'aria-label': t('close', 'Lukk') }, '×');
    head.appendChild(x);
    var body = el('div', { class: 'rw__body' });
    var fs = el('fieldset', { class: 'wl-pick__set' });
    fs.appendChild(el('legend', { class: 'rw__sr' }, t('s_pick_title', 'Hvilken gaveplan?')));
    list.forEach(function (s, i) {
      var lab = el('label', { class: 'wl-pick__opt' });
      lab.appendChild(el('input', { type: 'radio', name: 'wl-spick', value: s.ref, checked: i === 0 ? true : null }));
      lab.appendChild(el('span', null, s.name));
      fs.appendChild(lab);
    });
    body.appendChild(fs);
    var acts = el('div', { class: 'rw__actions' });
    var ok = el('button', { type: 'button', class: 'rw__submit' }, t('s_add', 'Legg til'));
    var no = el('button', { type: 'button', class: 'rw__cancel' }, t('cancel', 'Avbryt'));
    acts.appendChild(ok); acts.appendChild(no);
    body.appendChild(acts);
    box.appendChild(head); box.appendChild(body); d.appendChild(box);
    var opener = document.activeElement, closed = false;
    function close() {
      if (closed) return;
      closed = true;
      if (d.open) d.close();
      document.documentElement.classList.remove('pk-lock');
      if (d.parentNode) d.parentNode.removeChild(d);
      if (opener && opener.focus && document.contains(opener)) opener.focus({ preventScroll: true });
    }
    x.addEventListener('click', close);
    no.addEventListener('click', close);
    d.addEventListener('close', close);
    d.addEventListener('click', function (e) { if (e.target === d) close(); });
    ok.addEventListener('click', function () {
      var c = fs.querySelector('input:checked');
      var s = null;
      list.forEach(function (o) { if (c && o.ref === c.value) s = o; });
      close();
      if (s) done(s);
    });
    document.body.appendChild(d);
    d.showModal();
    document.documentElement.classList.add('pk-lock');
    var first = fs.querySelector('input:checked');
    if (first) first.focus();
  }

  var page = null;
  var pageRoot = document.querySelector('[data-wl-page]');
  if (pageRoot) page = makePage(pageRoot);

  function makePage(root) {
    var lines = [];        // normalized lines: { ref, v, p, q, note, chosen, product, snapshot, saved, li, removed }
    var gen = 0;
    var countEl = document.querySelector('[data-wl-page-count]');
    var owl = safeImg(root.getAttribute('data-owl'));
    /* The section around the list: the fixed «Oversikt» and the movable blocks (snippets/wishlist-page-block.liquid), shown and filled by
       showSlots(). In the theme editor (data-wl-design) blocks that are hidden for this visitor show greyed, so they can be edited. */
    var sec = root.closest('.pg-wl') || document;
    var sumEl = sec.querySelector('[data-wl-fill="sum"]');
    var design = root.hasAttribute('data-wl-design');
    var menuPc = root.getAttribute('data-menu-pc') === 'm2' ? 'm2' : 'm1';
    var menuMobile = root.getAttribute('data-menu-mobile') === 'picker' ? 'picker' : 'tabs';
    var sum = null, bar = null, adding = false;
    var dead = false;                // the theme editor drew the section again: this page no longer draws (destroy)
    var current = '';                // the list shown (port 2); '' = the standard list
    var TOKEN_RE = /^[A-Za-z0-9_-]{43}$/;
    var shared = parseShared();      // a shared list opened from a link (#t=…) or after the exchange (?delt=<ref>)
    /* A second link pasted into an open tab: same path (strip, exchange). */
    window.addEventListener('hashchange', function () {
      if (dead) return;
      var m = /(?:^#|&)(t|i|s)=([A-Za-z0-9_-]{43})(?:&|$)/.exec(window.location.hash || '');
      if (!m) return;
      if (m[1] === 's') {
        try { window.sessionStorage.setItem(STUA_INV_KEY, m[2]); } catch (e) { /* no storage */ }
        try { window.history.replaceState(window.history.state, '', window.location.pathname + window.location.search); } catch (e) { /* old browser */ }
        refresh();
        return;
      }
      replaceUrl('');
      shared = m[1] === 'i' ? { token: '', invite: m[2], ref: '' } : { token: m[2], invite: '', ref: '' };
      refresh();
    });
    var focusTab = false;            // after a tab click or a list change, focus goes to the pressed tab once the page is drawn
    var giftView = null;             // port 3: the gift settings of a shared gift list (null for a plain shared list)
    var sharedSession = '';          // port 3: the session of the shared list shown (claims)
    var ownView = false;             // port 3: the signed-in owner looks at her or his own gift list through a link
    var orderLink = false;           // port 4: the portal links cart purchases to the giver's claim on this list (list.order_link)
    var focusClaim = '';             // port 3: after a claim, focus goes back to that line's gift box

    function clear() {
      closeMenu();
      root.textContent = '';
      sum = null;
      if (sumEl) { sumEl.textContent = ''; sumEl.hidden = true; }
      if (bar && bar.parentNode) bar.parentNode.removeChild(bar);
      bar = null;
      document.documentElement.classList.remove('pg-wl-has-bar');
      if (countEl) countEl.hidden = true;
      showSlots(false);
    }

    /* Loading: three placeholder rows and the text. */
    function loading() {
      clear();
      var box = el('div', { class: 'pg-wl-skel', 'aria-busy': 'true' });
      for (var i = 0; i < 3; i++) {
        var r = el('div', { class: 'pg-wl-skel__row', 'aria-hidden': 'true' });
        r.appendChild(el('span', { class: 'pg-wl-skel__img' }));
        var tx = el('span', { class: 'pg-wl-skel__text' });
        tx.appendChild(el('span')); tx.appendChild(el('span'));
        r.appendChild(tx);
        box.appendChild(r);
      }
      box.appendChild(el('p', { class: 'pg-wl__status' }, t('loading', 'Henter ønskelisten …')));
      root.appendChild(box);
    }

    function status(text, retry) {
      clear();
      var box = el('div', { class: retry ? 'pg-wl-error' : 'pg-wl__statusbox', role: retry ? 'alert' : null });
      box.appendChild(el('p', { class: 'pg-wl__status' }, text));
      if (retry) {
        var b = el('button', { type: 'button', class: 'pg-wl__btn pg-wl__btn--alt' }, t('retry', 'Prøv igjen'));
        b.addEventListener('click', function () {
          try { window.sessionStorage.removeItem(OFF_KEY); } catch (e) { /* no storage */ }
          strikes = 0;
          if (signedIn && !ready) { loading(); start(); } else refresh();
        });
        box.appendChild(b);
      }
      root.appendChild(box);
    }

    function productOf(o) {
      if (!o || typeof o !== 'object') return null;
      var v = id(o.variant_id);
      if (!v) return null;
      if (o.status !== 'ok') return { v: v, p: id(o.product_id), ok: false };
      return {
        v: v, p: id(o.product_id), ok: true,
        title: str(o.title, 300), variant: str(o.variant_title, 200), image: safeImg(o.image),
        short: str(o.short_title, 120).trim(),   // contract v4: pippei.korttittel, variant before product (null when unset)
        vendor: str(o.vendor, 120),
        price: typeof o.price === 'number' ? o.price : null,
        compare: typeof o.compare_at === 'number' ? o.compare_at : null,
        availability: STOCK.indexOf(o.availability) !== -1 ? o.availability : null,
        url: safePath(o.url),
        /* Contract v1.2 (Knut 2026-10-11): stock, the order cap (snippets/qty-cap.liquid rule) and the rough ready date. Missing = nothing. */
        inStock: count(o.in_stock_qty),
        maxQty: count(o.max_qty),
        ready: dayMonth(o.ready_date)
      };
    }
    function count(v) { return typeof v === 'number' && isFinite(v) && v >= 0 ? Math.floor(v) : null; }
    /* «YYYY-MM-DD» → «dd/mm», the format of the delivery text on the product card. */
    function dayMonth(v) { var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(typeof v === 'string' ? v : ''); return m ? m[3] + '/' + m[2] : ''; }
    /* saved = the price when the line was added: price_at_add from the portal (contract v1.1, null before), else nothing. For a line that is
       no longer for sale the snapshot price stands in, as before. */
    function lineOf(item) {
      var prod = productOf(item.product);
      if (!prod || !REF_RE.test(str(item.ref, 64))) return null;
      var snap = item.snapshot && typeof item.snapshot === 'object' ? item.snapshot : {};
      var snapshot = { title: str(snap.title, 300), variant: str(snap.variant_title, 200), image: safeImg(snap.image), price: typeof snap.price === 'number' ? snap.price : null };
      var saved = typeof item.price_at_add === 'number' ? item.price_at_add : null;
      if (saved === null && !prod.ok) saved = snapshot.price;
      return {
        ref: item.ref, v: prod.v, p: prod.p,
        q: Math.min(QTY_MAX, Math.max(1, parseInt(item.quantity, 10) || 1)),
        note: str(item.note, NOTE_MAX), chosen: item.variant_chosen !== false, product: prod, snapshot: snapshot, saved: saved,
        /* Port 3: on a gift list with «visible» the portal sends {intended, purchased}; with «surprise» nothing at all (§13 B1). */
        giftCounts: item.gift && typeof item.gift === 'object' ? { intended: count(item.gift.intended) || 0, purchased: count(item.gift.purchased) || 0 } : null
      };
    }

    function refresh() {
      if (dead) return;
      inStua = false;
      /* Ønskestua: a waiting invitation (#s=), then an Ønskestue (?stue=<ref>, or the owner's stua tab). */
      if (!shared && stuaInvite()) { joinView(); return; }
      if (!shared && stuaRef && !signedIn) { stuaLogin(); return; }
      if (!shared && signedIn && ready && S.stuaOn) {
        if (stuaRef) { showStua(stuaRef); return; }
        var sl = S.lists ? listByRef(curRef()) : null;
        if (sl && sl.kind === 'stua' && sl.status === 'active') { showStua(sl.ref); return; }
      }
      if (shared) { showShared(); return; }
      var my = ++gen;
      if (signedIn) {
        if (isOff() || !ready) { status(t('load_failed', 'Kunne ikke hente varene akkurat nå.'), true); return; }
        var ref = curRef();
        if (!ref) { lines = []; draw(); return; }
        if (!root.querySelector('.pg-wl__list')) loading();
        var job = loadList(ref);
        if (S.list && ref === S.list.ref) listLoaded = job;
        job.then(function (items) {
          if (my !== gen) return;
          if (!items) { if (S.list && ref === S.list.ref) listLoaded = null; status(t('load_failed', 'Kunne ikke hente varene akkurat nå.'), true); return; }
          lines = items.map(lineOf).filter(Boolean);
          sync();
          draw();
        });
        return;
      }
      var g = guestRead();
      if (!g.items.length) { lines = []; draw(); return; }
      if (!root.querySelector('.pg-wl__list')) loading();
      lookup(g.items.map(function (it) { return it.v; })).then(function (map) {
        if (my !== gen) return;
        if (!map) { status(t('load_failed', 'Kunne ikke hente varene akkurat nå.'), true); return; }
        lines = g.items.map(function (it) {
          var prod = map[it.v] || { v: it.v, p: it.p, ok: false };
          return { ref: null, v: it.v, p: it.p, q: it.q, note: '', chosen: !!it.c, product: prod, snapshot: {}, saved: typeof it.pr === 'number' ? it.pr : null };
        });
        draw();
      });
    }

    /* Public product data for guests (anonymous endpoint), at most 250 ids. */
    function lookup(ids) {
      ids = ids.filter(id).slice(0, GUEST_MAX);
      if (!ids.length) return Promise.resolve({});
      return read('/varer?ids=' + encodeURIComponent(ids.join(','))).then(function (r) {
        if (r.status !== 200 || !r.data || !Array.isArray(r.data.items)) return null;
        var map = {};
        r.data.items.forEach(function (o) { var prod = productOf(o); if (prod) map[prod.v] = prod; });
        return map;
      });
    }

    function iconEl(name, cls) { var i = icon(name); if (i && cls) i.setAttribute('class', (i.getAttribute('class') || '') + ' ' + cls); return i; }

    function draw() {
      if (dead) return;
      clear();
      var g = guestRead();
      if (shared) {
        if (!lines.length) { status(t('shared_empty', 'Lista er tom.')); return; }
      } else if (!signedIn) {
        root.appendChild(guestStrip());
      } else if (g.items.length) {
        var banner = el('div', { class: 'pg-wl__banner' });
        banner.appendChild(el('p', null, tn('merge_banner', g.items.length, '')));
        var mv = el('button', { type: 'button', class: 'pg-wl__btn' }, t('merge_move', 'Flytt'));
        mv.addEventListener('click', function () { mv.disabled = true; runMerge().then(function (ok) { if (!ok) mv.disabled = false; }); });
        banner.appendChild(mv);
        root.appendChild(banner);
      }
      if (signedIn && !shared && S.lists) {
        root.appendChild(listBar());
        var curL = listByRef(curRef());
        if (curL && curL.status === 'archived') root.appendChild(el('p', { class: 'pg-wl__hint' }, t('archived_note', 'Denne lista er arkivert.')));
      }
      if (!lines.length) { root.appendChild(emptyState()); showSlots(true); tabFocus(); return; }

      var ul = el('ul', { class: 'pg-wl__list', role: 'list' });
      lines.forEach(function (line) {
        line.li = el('li', { class: 'pg-wl-item' });
        line.removed = false;
        fill(line.li, line);
        ul.appendChild(line.li);
      });
      root.appendChild(ul);
      /* «Oversikt»: fixed at the top of the right column (sections/wishlist-page.liquid), filled by totals(). */
      if (sumEl) { sum = sumEl; sumEl.hidden = false; }
      showSlots(true);
      bar = el('div', { class: 'pg-wl-bar', role: 'region', 'aria-label': t('sum_title', 'Oversikt') });
      document.body.appendChild(bar);
      document.documentElement.classList.add('pg-wl-has-bar');
      vendors();
      totals();
      tabFocus();
    }
    function tabFocus() {
      if (!focusTab) return;
      focusTab = false;
      var tb = root.querySelector('.pg-wl-lists__pick[aria-pressed="true"]') || root.querySelector('.pg-wl-lists__plans.is-on');
      if (!tb || !tb.offsetParent) tb = root.querySelector('.pg-wl-lists__picker');   // M3 on mobile: the tabs are hidden
      if (!tb) return;
      tb.focus({ preventScroll: true });
      if (tb.scrollIntoView) tb.scrollIntoView({ block: 'nearest', inline: 'nearest' });   // the tabs scroll sideways on mobile
    }

    /* F3 (Knut 2026-10-11): the guest message as one line with «Logg inn og lagre»; the full text behind «Hvorfor?» (section settings). */
    function guestStrip() {
      var box = el('div', { class: 'pg-wl-strip' });
      var gi = iconEl('info', 'pg-wl-strip__icon');
      if (gi) box.appendChild(gi);
      var p = el('p', { class: 'pg-wl-strip__text' }, (root.getAttribute('data-guest-text') || t('guest_intro', '')) + ' ');
      p.appendChild(el('a', { href: loginHref(), class: 'pg-wl-strip__link' }, root.getAttribute('data-guest-link') || t('login', 'Logg inn')));
      box.appendChild(p);
      if (root.hasAttribute('data-guest-why') && t('guest_intro', '')) {
        /* «Hvorfor?» on the same line; the full text opens under the strip. */
        var more = el('p', { id: 'pg-wl-strip-more', class: 'pg-wl-strip__more' }, t('guest_intro', ''));
        more.hidden = true;
        var why = el('button', { type: 'button', class: 'pg-wl-strip__why', 'aria-expanded': 'false', 'aria-controls': 'pg-wl-strip-more' }, t('guest_why', 'Hvorfor?'));
        why.addEventListener('click', function () { more.hidden = !more.hidden; why.setAttribute('aria-expanded', more.hidden ? 'false' : 'true'); });
        p.appendChild(document.createTextNode(' · '));
        p.appendChild(why);
        box.appendChild(more);
      }
      return box;
    }

    /* The movable blocks (Knut 2026-10-11), each shown only when it fits the list shown. ready = false while loading, on an error, for an
       unavailable or empty shared list: then no block shows. The right column gets .has-side when something in it shows, so the list can take
       the full width otherwise. */
    function showSlots(ready) {
      var own = signedIn && !shared;
      var guest = !signedIn && !shared;
      var cur = own && ready ? listByRef(curRef()) : null;
      Array.prototype.forEach.call(sec.querySelectorAll('[data-wl-slot-type]'), function (slot) {
        var type = slot.getAttribute('data-wl-slot-type');
        var aud = slot.getAttribute('data-wl-audience') || 'all';
        var on = false;
        if (!ready) on = false;
        else if (inStua && (type === 'share' || type === 'notes' || type === 'gift_help')) on = false;
        else if (type === 'share') { on = !!(cur && canShare(cur)); if (on) fillShare(slot, cur); }
        else if (type === 'notes') {
          on = ready && (own || guest);
          Array.prototype.forEach.call(slot.querySelectorAll('[data-wl-when]'), function (n) { n.hidden = n.getAttribute('data-wl-when') !== (own ? 'own' : 'guest'); });
        }
        else if (type === 'gift_help') on = !!(cur && cur.kind === 'gift');
        else if (type === 'faq') on = true;
        else on = aud === 'all' || (aud === 'guest' && guest) || (aud === 'signed_in' && own);
        /* Owl places: data-owl, or hidden when the section has no owl. */
        Array.prototype.forEach.call(slot.querySelectorAll('img[data-wl-owl]'), function (img) {
          if (owl && img.getAttribute('src') !== owl) img.setAttribute('src', owl);
          img.hidden = !owl;
        });
        slot.classList.toggle('is-ghost', !on && design);
        slot.hidden = !on && !design;
      });
      var side = sec.querySelector('[data-wl-side]');
      var cols = sec.querySelector('[data-wl-cols]');
      if (side && cols) {
        var any = Array.prototype.some.call(side.children, function (c) { return !c.hidden; });
        cols.classList.toggle('has-side', any);
      }
    }

    /* «Deling»: status with a dot, the text for shared or not shared, and the actions. A gift list for invited guests only is shared through
       the invitations, so it shows that status and «Invitasjoner». */
    function fillShare(p, list) {
      var invite = list.kind === 'gift' && list.gift && list.gift.mode !== 'unlisted';
      var on = invite || list.shared;
      var st = p.querySelector('[data-wl-fill="status"]');
      if (st) {
        st.textContent = '';
        st.classList.toggle('is-on', !!on);
        st.appendChild(el('span', { class: 'pg-wl-panel__dot', 'aria-hidden': 'true' }));
        st.appendChild(el('span', null, invite ? t('share_invite', 'Bare de du inviterer') : (list.shared ? t('share_on', 'Delt med lenke') : t('share_off', 'Ikke delt'))));
      }
      Array.prototype.forEach.call(p.querySelectorAll('[data-wl-when]'), function (n) {
        n.hidden = invite || n.getAttribute('data-wl-when') !== (list.shared ? 'on' : 'off');
      });
      var actions = p.querySelector('[data-wl-fill="actions"]');
      if (!actions) return;
      function button(label, cls, fn) { var b = el('button', { type: 'button', class: cls }, label); b.addEventListener('click', function () { fn(b); }); actions.appendChild(b); return b; }
      function normal() {
        actions.textContent = '';
        if (invite) {
          if (canGift(list)) button(t('g_invitations', 'Invitasjoner'), 'pg-wl__btn pg-wl__btn--alt pg-wl-panel__btn', function () { invitesDialog(list); });
          return;
        }
        if (!list.shared) { button(t('share_make', 'Del lista'), 'pg-wl__btn pg-wl__btn--alt pg-wl-panel__btn', function () { shareDialog(list); }); return; }
        button(t('share_copy', 'Kopier lenke'), 'pg-wl__btn pg-wl__btn--alt pg-wl-panel__btn', function (b) { copyShare(list, b); });
        var stop = button(t('share_revoke', 'Slutt å dele'), 'pg-wl__link', function () { confirmStop(stop); });
      }
      /* «Slutt å dele» asks once in the panel: the link stops working for everyone it was sent to. */
      function confirmStop(opener) {
        actions.textContent = '';
        actions.appendChild(el('p', { id: 'pg-wl-stop-why', class: 'pg-wl-panel__confirm' }, t('share_stop_confirm', 'Lenken slutter å virke for alle du har sendt den til.')));
        var yes = button(t('share_stop_yes', 'Ja, slutt å dele'), 'pg-wl__btn pg-wl-panel__btn', function () {
          yes.disabled = true;
          write('/lists/' + encodeURIComponent(list.ref) + '/share/revoke', {}, { noJudge: true }).then(function (r) {
            if (r.status === 200) { reload(list.ref, t('share_revoked', 'Lista er ikke delt lenger.')); return; }
            yes.disabled = false;
            say(r.status === 404 ? failText(r).text : t('share_unavailable', 'Deling er ikke tilgjengelig akkurat nå.'));
          });
        });
        button(t('cancel', 'Avbryt'), 'pg-wl__link', function () {
          normal();
          var again = actions.querySelector('.pg-wl__link');
          if (again) again.focus({ preventScroll: true }); else if (opener && document.contains(opener)) opener.focus({ preventScroll: true });
        });
        yes.setAttribute('aria-describedby', 'pg-wl-stop-why');
        yes.focus({ preventScroll: true });
      }
      normal();
    }
    /* «Kopier lenke»: POST share gives the active link again (§13 choice 2); if the link or the clipboard is not there, the share dialog opens
       with the link to select by hand. */
    function copyShare(list, b) {
      b.disabled = true;
      write('/lists/' + encodeURIComponent(list.ref) + '/share', {}, { noJudge: true }).then(function (r) {
        b.disabled = false;
        var link = (r.status === 200 || r.status === 201) ? shareLinkOf(r) : '';
        if (!link || !navigator.clipboard || !navigator.clipboard.writeText) { shareDialog(list); return; }
        navigator.clipboard.writeText(link).then(function () {
          var was = b.textContent;
          b.textContent = t('share_copied', 'Kopiert!');
          say(t('share_copied', 'Kopiert!'));
          window.setTimeout(function () { b.textContent = was; }, 2000);
        }, function () { shareDialog(list); });
      });
    }
    function shareLinkOf(r) {
      var tok = r.data && r.data.share && typeof r.data.share.token === 'string' ? r.data.share.token : '';
      return TOKEN_RE.test(tok) ? window.location.origin + (cfg.page || '/pages/onskeliste') + '#t=' + tok : '';
    }

    function emptyState() {
      var box = el('div', { class: 'pg-wl-empty' });
      /* The circle only with an owl in data-owl (none until the wish owl is chosen, Knut 2026-10-11). */
      if (owl) {
        var art = el('div', { class: 'pg-wl-empty__art', 'aria-hidden': 'true' });
        art.appendChild(el('img', { src: owl, alt: '', width: '96', height: '96' }));
        box.appendChild(art);
      }
      var tx = el('div', { class: 'pg-wl-empty__text' });
      tx.appendChild(el('h2', { class: 'pg-wl-empty__title' }, t('empty_title', 'Ønskelisten er tom')));
      /* «Trykk på hjertet [heart] ved en vare …»: the heart icon goes where the text has __H__. */
      var parts = t('empty', '').split('__H__');
      var p = el('p');
      p.appendChild(document.createTextNode(parts[0]));
      if (parts.length > 1) { var hi = iconEl('heart', 'pg-wl-empty__heart'); if (hi) p.appendChild(hi); p.appendChild(document.createTextNode(parts.slice(1).join(''))); }
      tx.appendChild(p);
      var shop = root.getAttribute('data-shop-url');
      if (shop && safePath(shop)) {
        var bp = el('p');
        bp.appendChild(el('a', { href: shop, class: 'pg-wl__btn pg-wl__btn--alt' }, root.getAttribute('data-shop-label') || ''));
        tx.appendChild(bp);
      }
      box.appendChild(tx);
      return box;
    }

    function title(line) {
      var full = (line.product.ok && line.product.title) || line.snapshot.title;
      if (line.product.ok && line.product.short) return line.product.short;
      return full ? shortTitle(full, line.product.ok ? line.product.vendor : '') : t('unavailable', 'Ikke tilgjengelig nå');
    }
    /* F2 (Knut 2026-10-11): the name without the brand segment, the rule of snippets/product-display-title.liquid (Theme settings: title_strip
       before_first / after_last, and with «only when it is the brand» the segment must equal the vendor). The brand stands above the name. */
    function shortTitle(full, vendor) {
      var mode = cfg.title_strip;
      var parts = full.split('|');
      if (parts.length < 2 || (mode !== 'before_first' && mode !== 'after_last')) return full;
      var seg = (mode === 'before_first' ? parts[0] : parts[parts.length - 1]).trim();
      var rest = (mode === 'before_first' ? parts.slice(1) : parts.slice(0, -1)).join('|').trim();
      if (!rest) return full;
      if (cfg.title_only_vendor !== false && seg.toLowerCase() !== String(vendor || '').trim().toLowerCase()) return full;
      return rest;
    }
    function soldOut(prod) { return prod.availability === 'temporarily_sold_out' || prod.availability === 'long_term_sold_out'; }
    function buyable(line) { return !line.removed && line.product.ok && line.chosen && !soldOut(line.product) && line.product.maxQty !== 0 && line.product.price !== null; }
    /* Highest quantity the field and the cart take: max_qty when the portal sends one (0 = cannot be ordered now), else 99. */
    function capOf(line) { var m = line.product.ok ? line.product.maxQty : null; return m === null || m === 0 ? QTY_MAX : Math.min(QTY_MAX, m); }

    /* Stock line with the product card's words (Knut 2026-10-11, v1.2):
         cannot be bought (sold out, or max_qty 0)        → «Tilbake ca. dd/mm» (else the plain status)
         preorder, or nothing in stock but still for sale → «Sendes ca. dd/mm» (else «Bestillingsvare»)
         more wanted than in stock                        → «N stk klar, resten ca. dd/mm»
       Dot: green ready, yellow later, red gone for a long time. */
    function stockEl(line) {
      var prod = line.product;
      var text = '', kind = 'ok';
      var q = qtyOf(line);
      if (soldOut(prod) || prod.maxQty === 0) {
        kind = prod.availability === 'long_term_sold_out' ? 'out' : 'later';
        text = prod.ready ? t('back_about', '').replace('__D__', prod.ready) : (soldOut(prod) ? t(prod.availability) : t('unavailable', 'Ikke tilgjengelig nå'));
      } else if (prod.availability === 'preorder' || (prod.inStock === 0 && prod.maxQty === null)) {
        kind = 'later';
        text = prod.ready ? t('ships_about', '').replace('__D__', prod.ready) : (prod.availability === 'preorder' ? t('preorder') : t('ships_later', 'Bestillingsvare'));
      } else if (prod.inStock !== null && prod.inStock > 0 && q > prod.inStock && prod.ready) {
        kind = 'later';
        text = t('partial', '').replace('__N__', String(prod.inStock)).replace('__D__', prod.ready);
      } else if (prod.availability) {
        text = t(prod.availability);
      }
      if (!text) return null;
      var av = el('p', { class: 'pg-wl-item__stock pg-wl-item__stock--' + kind });
      av.appendChild(el('span', { class: 'pg-wl-item__dot', 'aria-hidden': 'true' }));
      av.appendChild(el('span', null, text));
      return av;
    }
    function restock(line) {
      if (!line.li || !line.product.ok) return;
      var old = line.li.querySelector('.pg-wl-item__stock');
      var fresh = stockEl(line);
      if (old && fresh) old.parentNode.replaceChild(fresh, old);
      else if (old) old.parentNode.removeChild(old);
    }

    function fill(li, line) {
      li.textContent = '';
      var prod = line.product;
      var name = title(line);
      var href = prod.ok ? prod.url : '';
      var img = (prod.ok && prod.image) || line.snapshot.image;

      var media = el(href ? 'a' : 'div', { class: 'pg-wl-item__media', href: href || null, tabindex: href ? '-1' : null, 'aria-hidden': 'true' });
      if (img) media.appendChild(el('img', { src: img, alt: '', loading: 'lazy', width: '224', height: '224' }));
      li.appendChild(media);

      /* Info: brand (filled in by vendors()), title, variant / «Velg variant», stock. */
      var info = el('div', { class: 'pg-wl-item__info' });
      if (prod.ok && prod.vendor) info.appendChild(el('p', { class: 'pg-wl-item__vendor', 'data-vendor': prod.vendor }, prod.vendor));
      var h = el('h2', { class: 'pg-wl-item__title' });
      if (href) h.appendChild(el('a', { href: href }, name)); else h.textContent = name;
      info.appendChild(h);
      if (prod.ok) info.appendChild(line.readonly ? variantText(line) : variantControl(li, line));
      if (prod.ok) {
        var av = stockEl(line);
        if (av) info.appendChild(av);
        /* W6: the owner's counts («visible» only) as badges: honey «Noen har tenkt å kjøpe», moss «N kjøpt». */
        if (!line.readonly && line.giftCounts && (line.giftCounts.intended || line.giftCounts.purchased)) {
          var badges = el('p', { class: 'pg-wl-badges' });
          if (line.giftCounts.intended) badges.appendChild(el('span', { class: 'pg-wl-badge pg-wl-badge--intended' }, t('g_others_badge', 'Noen har tenkt å kjøpe')));
          if (line.giftCounts.purchased) badges.appendChild(el('span', { class: 'pg-wl-badge pg-wl-badge--bought' }, tn('g_owner_bought', line.giftCounts.purchased, '__N__ kjøpt')));
          info.appendChild(badges);
        }
        if (line.readonly && line.giftItem) info.appendChild(giftBox(line));
      } else {
        info.appendChild(el('p', { class: 'pg-wl-item__gone' }, t('unavailable', 'Ikke tilgjengelig nå')));
        if (line.readonly && line.giftItem) info.appendChild(giftBox(line));
      }
      if (!line.readonly && signedIn && line.ref && otherLists().length) info.appendChild(moveControl(li, line));
      li.appendChild(info);

      /* Price: now (terrakotta on sale), «Før», and «Pris da du lagret den» when it differs (or the item is gone). */
      var price = el('div', { class: 'pg-wl-item__price' });
      if (prod.ok && prod.price !== null) price.appendChild(el('p', { class: 'pg-wl-item__now' + (prod.compare ? ' is-sale' : '') }, money(prod.price)));
      if (prod.ok && prod.compare) {
        var before = el('p', { class: 'pg-wl-item__before' }, t('compare_at', 'Før') + ' ');
        before.appendChild(el('s', null, money(prod.compare)));
        price.appendChild(before);
      }
      if (line.saved !== null && (!prod.ok || line.saved !== prod.price)) {
        price.appendChild(el('p', { class: 'pg-wl-item__was' }, t('saved_price', '').replace('__P__', money(line.saved))));
      }
      li.appendChild(price);

      if (prod.ok) li.appendChild(qtyControl(line, name));
      if (signedIn && line.ref) li.appendChild(noteControl(line));

      /* Cart: the line with its chosen quantity (addToCart). Not possible now: a disabled button that says why. */
      var cart;
      if (buyable(line)) {
        /* The chosen quantity (Knut 2026-10-11, go/no-go): one /cart/add.js call through PippeiCart.add; the store decides about stock. */
        /* F1: an outlined «Legg i kurv» on the rows, so the bar / «Oversikt» is the one filled button. A giver on a gift list buys one gift at
           a time, so there the row button stays the filled one. */
        cart = el('button', { type: 'button', class: 'pg-wl__btn pg-wl-item__cart' + (line.giftItem ? '' : ' pg-wl__btn--alt') });
        cart.addEventListener('click', function () { cartFor([line], cart); });
        var ci = iconEl('cart'); if (ci) cart.appendChild(ci);
        cart.appendChild(el('span', null, t('row_cart', 'Legg i kurv')));
        cart.appendChild(el('span', { class: 'rw__sr' }, ': ' + name));
      } else {
        cart = el('button', { type: 'button', class: 'pg-wl__btn pg-wl-item__cart', disabled: true },
          prod.ok && !line.chosen ? t('select_first', 'Velg variant først') : t('unavailable', 'Ikke tilgjengelig nå'));
      }
      li.appendChild(cart);
      if (line.readonly) return;   // a shared list: no remove, no notes (§13 choice 4)
      var rm = el('button', { type: 'button', class: 'pg-wl-item__remove', 'aria-label': t('remove', '').replace('__T__', name) });
      var ri = iconEl('x'); if (ri) rm.appendChild(ri);
      rm.appendChild(el('span', { class: 'pg-wl-item__remove-text' }, t('remove_short', 'Fjern')));
      rm.addEventListener('click', function () { remove(li, line, name); });
      li.appendChild(rm);
    }

    /* «Oversikt» (PC) and the bar at the bottom (smaller screens), worked out from the list in the browser. */
    function totals() {
      var active = lines.filter(function (l) { return !l.removed; });
      var avail = active.filter(buyable);
      var total = avail.reduce(function (s, l) { return s + l.product.price * qtyOf(l); }, 0);
      var lower = active.filter(function (l) { return l.product.ok && l.saved !== null && l.product.price !== null && l.product.price < l.saved; }).length;
      if (countEl) { countEl.textContent = tn('count', active.length, ''); countEl.hidden = false; }
      if (sum) {
        sum.textContent = '';
        sum.appendChild(el('h2', { id: 'pg-wl-sum-title', class: 'pg-wl-sum__title' }, t('sum_title', 'Oversikt')));
        function row(label, value, cls) {
          var r = el('p', { class: 'pg-wl-sum__row' });
          r.appendChild(el('span', null, label));
          r.appendChild(el('b', { class: cls || null }, value));
          sum.appendChild(r);
        }
        row(t('sum_available', 'Tilgjengelige nå'), t('sum_of', '__A__ av __B__').replace('__A__', String(avail.length)).replace('__B__', String(active.length)));
        row(t('sum_total', 'Sum tilgjengelige'), money(total));
        if (lower) row(t('sum_lower', 'Lavere pris enn da du lagret'), tn('count', lower, ''), 'is-sale');
        sum.appendChild(addAllButton(avail, addAllLabel(avail.length)));
        sum.appendChild(el('p', { class: 'pg-wl-sum__help' }, t('add_all_help', '')));
      }
      if (bar) {
        bar.textContent = '';
        var info = el('p', { class: 'pg-wl-bar__info' });
        info.appendChild(el('span', null, tn('bar_available', avail.length, '__N__ tilgjengelige')));
        info.appendChild(el('b', null, money(total)));
        bar.appendChild(info);
        bar.appendChild(addAllButton(avail, addAllLabel(avail.length)));
        bar.hidden = !active.length;
        document.documentElement.classList.toggle('pg-wl-has-bar', !!active.length);
      }
    }

    /* The quantity a line shows now: the field wins over line.q, which is only updated when the change is saved (0.5 s later). */
    function qtyOf(line) {
      var input = line.li && line.li.querySelector('.pg-wl-qty__input');
      var n = parseInt(input ? input.value : line.q, 10);
      return Math.min(capOf(line), Math.max(1, n || line.q || 1));
    }

    /* Items into the cart in one /cart/add.js call (assets/cart-drawer.js PippeiCart.add), then the cart drawer opens. All or nothing:
       on a 422 (stock changed, a quantity cap) the cart shows its message and the list is read again. */
    function addToCart(items, b) {
      if (!items.length || adding) return;
      var cart = window.PippeiCart && typeof window.PippeiCart.add === 'function' ? window.PippeiCart.add(items, b) : null;
      if (!cart) { say(t('error', 'Noe gikk galt. Prøv igjen senere.')); return; }
      adding = true;
      b.setAttribute('aria-busy', 'true');
      cart.then(function () { adding = false; b.removeAttribute('aria-busy'); }, function (e) {
        adding = false;
        b.removeAttribute('aria-busy');
        if (e && e.status === 422) refresh();
      });
    }

    /* Port 4 «Ordrekobling»: a giver on a gift list with order_link asks POST shared/cart {session, item_ref, quantity} per line first and
       puts the answer's order_ref on the cart line as the hidden property _pippei_onskeliste (the cart hides names starting with «_», and
       the delivery-date guard in assets/cart-drawer.js keeps all properties). Any answer other than 200, or a network error, puts that
       line in the cart without the property: the purchase is never stopped. Everyone else (own list, plain shared list, older portal) adds
       as before. After an order-linked add the list is read again (claims and counts). */
    var ORDER_REF_RE = /^[0-9A-Za-z]{26}$/;   // C1 says [0-9a-z]{26}; upper case accepted too (ULID), checked on the whole value
    var CART_LINK_MS = 4000;                   // a slow portal must not hold the purchase: after 4 s the line goes in without the link
    function cartFor(ls, b) {
      if (!ls.length || adding) return;
      var plain = ls.map(function (l) { return { id: Number(l.v), quantity: qtyOf(l) }; });
      var linked = giftView && !ownView && orderLink && sharedSession;
      if (!linked) { addToCart(plain, b); return; }
      adding = true;
      b.setAttribute('aria-busy', 'true');
      /* At most 4 shared/cart calls at a time (rate limit, the browser's queue per host). */
      var items = plain.slice(), next = 0, linkedAny = false;
      function one() {
        if (next >= ls.length) return Promise.resolve();
        var i = next++;
        var g = ls[i].giftItem;
        if (!g) return one();
        return request('/shared/cart', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ session: sharedSession, item_ref: g.ref, quantity: plain[i].quantity }) }, CART_LINK_MS)
          .then(function (r) {
            var ref = r.status === 200 && r.data ? str(r.data.order_ref, 64) : '';
            if (ORDER_REF_RE.test(ref)) { items[i] = { id: plain[i].id, quantity: plain[i].quantity, properties: { _pippei_onskeliste: ref } }; linkedAny = true; }
          })
          .then(one);
      }
      var workers = [];
      for (var w = 0; w < Math.min(4, ls.length); w++) workers.push(one());
      Promise.all(workers).then(function () {
        var cart = window.PippeiCart && typeof window.PippeiCart.add === 'function' ? window.PippeiCart.add(items, b) : null;
        if (!cart) { adding = false; b.removeAttribute('aria-busy'); say(t('error', 'Noe gikk galt. Prøv igjen senere.')); return; }
        var firstRef = ls[0].giftItem ? ls[0].giftItem.ref : '';
        cart.then(function () {
          adding = false;
          b.removeAttribute('aria-busy');
          if (linkedAny) reloadAfterDrawer(firstRef);
        }, function (e) {
          adding = false;
          b.removeAttribute('aria-busy');
          if (linkedAny || (e && e.status === 422)) reloadAfterDrawer(firstRef);
        });
      });
    }
    /* The claims are read again once the cart drawer has closed, so focus is not pulled out of the open drawer and the drawer's opener
       stays in the page until then; afterwards focus goes to the line's gift box. */
    function reloadAfterDrawer(itemRef) {
      var dr = document.querySelector('cart-drawer');
      if (!dr || !dr.classList.contains('is-open') || typeof MutationObserver !== 'function') { claimReload(itemRef); return; }
      var mo = new MutationObserver(function () {
        if (dr.classList.contains('is-open')) return;
        mo.disconnect();
        window.setTimeout(function () { claimReload(itemRef); }, 0);
      });
      mo.observe(dr, { attributes: true, attributeFilter: ['class'] });
    }

    /* F1 (Knut 2026-10-11): the one filled button says how many go in: «Legg alle 4 i kurven» / «Legg varen i kurven»; none: «Legg i kurven». */
    function addAllLabel(n) { return n ? tn('add_all_n', n, 'Legg alle __N__ i kurven') : t('add_all_short', 'Legg i kurven'); }
    /* All available items with the chosen quantities. */
    function addAllButton(avail, label) {
      var b = el('button', { type: 'button', class: 'pg-wl__btn pg-wl-sum__add', disabled: avail.length ? null : true });
      var ci = iconEl('cart'); if (ci) b.appendChild(ci);
      b.appendChild(el('span', null, label));
      b.addEventListener('click', function () {
        cartFor(avail.slice(0, GUEST_MAX), b);
      });
      return b;
    }

    /* Brand line → link to the brand collection, same rule as snippets/vendor-collection-url.liquid: the collection whose handle is the
       handleized brand and whose title is the brand. Looked up once per brand (/collections/<handle>.json), remembered for the session. */
    function handleize(s) {
      return String(s).toLowerCase().replace(/æ/g, 'ae').replace(/ø/g, 'o').replace(/å/g, 'a')
        .normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/['"]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
    }
    var brandCache = {};
    function vendors() {
      var nodes = root.querySelectorAll('.pg-wl-item__vendor[data-vendor]');
      var names = {};
      Array.prototype.forEach.call(nodes, function (n) { names[n.getAttribute('data-vendor')] = true; });
      Object.keys(names).slice(0, 30).forEach(function (name) {
        brandUrl(name).then(function (url) {
          if (!url) return;
          Array.prototype.forEach.call(root.querySelectorAll('.pg-wl-item__vendor[data-vendor]'), function (n) {
            if (n.getAttribute('data-vendor') !== name || n.firstElementChild) return;
            n.textContent = '';
            n.appendChild(el('a', { href: url }, name));
          });
        });
      });
    }
    function brandUrl(name) {
      if (brandCache[name]) return brandCache[name];
      var h = handleize(name);
      var key = 'pp-wl-brand:' + h;
      var url = '/collections/' + h;
      try {
        var c = window.sessionStorage.getItem(key);
        if (c === '' || c === url) return (brandCache[name] = Promise.resolve(c));   // only these two values are trusted
      } catch (e) { /* no storage */ }
      brandCache[name] = !h ? Promise.resolve('') : fetch(url + '.json', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) {
          /* Remembered for the session only on a clear answer (200 or 404); other errors try again on the next page view. */
          var sure = r.status === 200 || r.status === 404;
          return (r.ok ? r.json().catch(function () { return null; }) : Promise.resolve(null)).then(function (d) {
            var ok = d && d.collection && typeof d.collection.title === 'string' && d.collection.title.trim().toLowerCase() === name.trim().toLowerCase();
            var out = ok ? url : '';
            if (sure) { try { window.sessionStorage.setItem(key, out); } catch (e) { /* no storage */ } }
            return out;
          });
        }, function () { return ''; });
      return brandCache[name];
    }

    function qtyControl(line, name) {
      var wrap = el('div', { class: 'pg-wl-qty' });
      var inputId = 'wl-q-' + line.v;
      wrap.appendChild(el('label', { for: inputId, class: 'pg-wl-qty__label' }, t('quantity', 'Antall')));
      var box = el('div', { class: 'pg-wl-qty__box' });
      var less = el('button', { type: 'button', class: 'pg-wl-qty__btn', 'aria-label': t('less', '').replace('__T__', name) || '-' });
      var more = el('button', { type: 'button', class: 'pg-wl-qty__btn', 'aria-label': t('more', '').replace('__T__', name) || '+' });
      var lessIcon = icon('minus'); if (lessIcon) less.appendChild(lessIcon); else less.textContent = '−';
      var moreIcon = icon('plus'); if (moreIcon) more.appendChild(moreIcon); else more.textContent = '+';
      /* Clamped to max_qty (v1.2) with the cart's own message under the field; a saved quantity above the cap shows the cap. */
      var cap = capOf(line);
      var start = Math.min(cap, line.q);
      var input = el('input', { id: inputId, type: 'number', min: '1', max: String(cap), step: '1', inputmode: 'numeric', class: 'pg-wl-qty__input', value: String(start), 'aria-describedby': inputId + '-m' });
      var note = el('p', { id: inputId + '-m', class: 'pg-wl-qty__note', role: 'status' }, cap < QTY_MAX ? t('max_qty', '').replace('__MAX__', String(cap)) : null);
      note.hidden = !(cap < QTY_MAX && line.q > cap);
      var timer = null;
      function set(n, now) {
        var wanted = Math.max(1, n || 1);
        n = Math.min(cap, wanted);
        input.value = String(n);
        less.disabled = n <= 1;
        more.disabled = n >= cap;
        note.hidden = !(cap < QTY_MAX && wanted > cap);
        window.clearTimeout(timer);
        totals();   // the sum follows the field at once
        restock(line);
        if (n === line.q) return;
        timer = window.setTimeout(function () { saveQty(line, n, input); }, now ? 0 : 500);
      }
      less.addEventListener('click', function () { set((parseInt(input.value, 10) || 1) - 1); });
      more.addEventListener('click', function () { set((parseInt(input.value, 10) || 1) + 1); });
      input.addEventListener('change', function () { set(parseInt(input.value, 10), true); });
      less.disabled = start <= 1;
      more.disabled = start >= cap;
      /* «+» at the cap still says why: a click shows the message. */
      more.addEventListener('pointerdown', function () { if (more.disabled && cap < QTY_MAX) note.hidden = false; });
      box.appendChild(less); box.appendChild(input); box.appendChild(more);
      wrap.appendChild(box);
      wrap.appendChild(note);
      return wrap;
    }

    function saveQty(line, n, input) {
      if (line.readonly) { line.q = n; return; }   // a shared list: the quantity is only for the cart here
      if (!signedIn) {
        var g = guestRead();
        var i = guestFind(g, line.v);
        if (i !== -1) { g.items[i].q = n; guestWrite(g); }
        line.q = n;
        return;
      }
      var before = line.q;
      line.q = n;
      write('/items/' + encodeURIComponent(line.ref), { quantity: n }).then(function (r) {
        if (r.status === 200) return;
        line.q = before;
        input.value = String(before);
        totals();
        if (!isOff()) sayFail(r);
      });
    }

    /* Note (signed in): a cream box with the text and «Endre», or the link «Legg til notat»; both open the form. */
    function noteControl(line) {
      var wrap = el('div', { class: 'pg-wl-note' });
      var fid = 'wl-n-' + line.v;
      var shown = el('div', { class: 'pg-wl-note__box' });
      var ni = iconEl('note', 'pg-wl-note__icon'); if (ni) shown.appendChild(ni);
      var text = el('p', { class: 'pg-wl-note__text' }, line.note || null);
      shown.appendChild(text);
      var edit = el('button', { type: 'button', class: 'pg-wl-note__edit', 'aria-expanded': 'false', 'aria-controls': fid + '-f', 'aria-label': t('note_edit', 'Endre notat') }, t('note_change', 'Endre'));
      shown.appendChild(edit);
      var add = el('button', { type: 'button', class: 'pg-wl__link pg-wl-note__add', 'aria-expanded': 'false', 'aria-controls': fid + '-f' });
      var ai = iconEl('note'); if (ai) add.appendChild(ai);
      add.appendChild(el('span', null, t('note_add', 'Legg til notat')));
      var form = el('div', { id: fid + '-f', class: 'pg-wl-note__form' });
      form.hidden = true;
      form.appendChild(el('label', { for: fid, class: 'pg-wl-qty__label' }, t('note', 'Notat')));
      var ta = el('textarea', { id: fid, class: 'pg-wl-note__input', maxlength: String(NOTE_MAX), rows: '3', 'aria-describedby': fid + '-h' });
      ta.value = line.note;
      form.appendChild(ta);
      form.appendChild(el('p', { id: fid + '-h', class: 'pg-wl-note__help' }, t('note_help', '').replace('__N__', String(NOTE_MAX))));
      var save = el('button', { type: 'button', class: 'pg-wl__btn pg-wl__btn--alt' }, t('note_save', 'Lagre notat'));
      form.appendChild(save);
      function show() {
        shown.hidden = !line.note;
        add.hidden = !!line.note;
        text.textContent = line.note;
      }
      function toggle(btn) {
        form.hidden = !form.hidden;
        edit.setAttribute('aria-expanded', form.hidden ? 'false' : 'true');
        add.setAttribute('aria-expanded', form.hidden ? 'false' : 'true');
        if (!form.hidden) ta.focus(); else btn.focus();
      }
      edit.addEventListener('click', function () { toggle(edit); });
      add.addEventListener('click', function () { toggle(add); });
      save.addEventListener('click', function () {
        var value = ta.value.trim().slice(0, NOTE_MAX);
        save.disabled = true;
        write('/items/' + encodeURIComponent(line.ref), { note: value }).then(function (r) {
          save.disabled = false;
          if (r.status !== 200) { if (!isOff()) sayFail(r); return; }
          var item = r.data && r.data.item;
          line.note = item && typeof item.note === 'string' ? str(item.note, NOTE_MAX) : (value || '');
          show();
          form.hidden = true;
          edit.setAttribute('aria-expanded', 'false');
          add.setAttribute('aria-expanded', 'false');
          (line.note ? edit : add).focus();
          say(t('note_saved', 'Notatet er lagret.'));
        });
      });
      show();
      wrap.appendChild(shown); wrap.appendChild(add); wrap.appendChild(form);
      return wrap;
    }

    /* Variant line: «Brun · 30 cm · Bytt variant», or the honey «Velg variant» badge for a card save of a product with several variants.
       The variants come from the portal on demand; saved with a button (arrow keys on a closed select fire change in Chrome on Windows). */
    function variantControl(li, line) {
      var wrap = el('div', { class: 'pg-wl-variant' });
      var vt = line.product.variant;
      var named = vt && vt !== 'Default Title';
      if (line.chosen && !named) return wrap;
      var open;
      if (line.chosen) {
        var p = el('p', { class: 'pg-wl-item__variant' });
        p.appendChild(document.createTextNode(vt + ' · '));
        open = el('button', { type: 'button', class: 'pg-wl-variant__change' }, t('variant_change', 'Bytt variant'));
        p.appendChild(open);
        wrap.appendChild(p);
      } else {
        open = el('button', { type: 'button', class: 'pg-wl-variant__choose' });
        var wi = iconEl('info'); if (wi) open.appendChild(wi);
        open.appendChild(el('span', null, t('variant_choose', 'Velg variant')));
        wrap.appendChild(open);
      }
      open.addEventListener('click', function () {
        open.disabled = true;
        read('/varianter?product_id=' + encodeURIComponent(line.p)).then(function (r) {
          open.disabled = false;
          if (r.status !== 200 || !r.data || !Array.isArray(r.data.variants)) { say(t('load_failed', 'Kunne ikke hente varene akkurat nå.')); return; }
          var opts = r.data.variants.slice(0, 100).map(productOf).filter(function (o) { return o && o.ok; });
          if (opts.length < 2 && line.chosen) { say(t('variant_none', 'Ingen andre varianter.')); return; }
          var sid = 'wl-v-' + line.v;
          var lab = el('label', { for: sid, class: 'pg-wl-qty__label' }, t('variant', 'Variant'));
          var sel = el('select', { id: sid, class: 'pg-wl-variant__select' });
          sel.appendChild(el('option', { value: '' }, t('variant_pick', 'Velg …')));
          opts.forEach(function (o) {
            var label = (o.variant && o.variant !== 'Default Title' ? o.variant : o.title);
            if (soldOut(o)) label += ' – ' + t(o.availability);
            var opt = el('option', { value: o.v }, label);
            if (line.chosen && o.v === line.v) opt.selected = true;
            sel.appendChild(opt);
          });
          var save = el('button', { type: 'button', class: 'pg-wl__btn pg-wl__btn--alt' }, t('variant_save', 'Lagre variant'));
          save.addEventListener('click', function () {
            var pick = null;
            opts.forEach(function (o) { if (o.v === sel.value) pick = o; });
            if (!pick || (pick.v === line.v && line.chosen)) return;
            changeVariant(li, line, pick, sel);
          });
          wrap.textContent = '';
          var row = el('div', { class: 'pg-wl-variant__row' });
          row.appendChild(sel); row.appendChild(save);
          wrap.appendChild(lab); wrap.appendChild(row);
          sel.focus();
        });
      });
      return wrap;
    }

    function changeVariant(li, line, pick, sel) {
      if (!signedIn) {
        var g = guestRead();
        if (pick.v !== line.v && guestFind(g, pick.v) !== -1) { sel.value = line.chosen ? line.v : ''; say(t('already', 'Varen ligger allerede i ønskelisten.')); return; }
        var i = guestFind(g, line.v);
        if (i === -1) return;
        g.items[i].v = pick.v; g.items[i].c = 1;
        if (typeof pick.price === 'number') g.items[i].pr = pick.price;   // a new variant is a new item: its price from now
        guestWrite(g);
        line.v = pick.v; line.chosen = true; line.product = pick; line.saved = typeof pick.price === 'number' ? pick.price : null;
        fill(li, line);
        vendors();
        totals();
        sync();
        say(t('variant_saved', 'Varianten er endret.'));
        return;
      }
      sel.disabled = true;
      write('/items/' + encodeURIComponent(line.ref), { variant_id: pick.v }).then(function (r) {
        sel.disabled = false;
        if (r.status !== 200 || !r.data || !r.data.item) { sel.value = line.chosen ? line.v : ''; if (!isOff()) sayFail(r); return; }
        var next = lineOf(r.data.item);
        if (!next) return;
        delete refs[line.v];
        rememberItem(r.data.item);
        next.li = li;
        lines[lines.indexOf(line)] = next;
        fill(li, next);
        vendors();
        totals();
        say(t('variant_saved', 'Varianten er endret.'));
        loadState().then(sync);
      });
    }

    function remove(li, line, name) {
      function removed() {
        li.textContent = '';
        li.classList.add('is-removed');
        line.removed = true;
        var p = el('p', { class: 'pg-wl-item__removed' });
        var parts = t('removed_line', '__T__').split('__T__');
        p.appendChild(document.createTextNode(parts[0]));
        p.appendChild(el('b', null, name));
        p.appendChild(document.createTextNode(parts.slice(1).join('')));
        say(t('removed_line', '').replace('__T__', name));
        var undo = el('button', { type: 'button', class: 'pg-wl-item__undo' }, t('undo', 'Angre'));
        undo.addEventListener('click', function () { restore(li, line); });
        li.appendChild(p);
        li.appendChild(undo);
        undo.focus();
        totals();
      }
      if (!signedIn) {
        var g = guestRead();
        var i = guestFind(g, line.v);
        if (i !== -1) { line.guest = g.items[i]; g.items.splice(i, 1); guestWrite(g); }
        removed();
        sync();
        return;
      }
      var rmBtn = li.querySelector('.pg-wl-item__remove');
      if (rmBtn) { if (rmBtn.disabled) return; rmBtn.disabled = true; }
      write('/items/' + encodeURIComponent(line.ref) + '/remove', {}).then(function (r) {
        if (r.status !== 200 && r.status !== 404) { if (rmBtn) rmBtn.disabled = false; if (!isOff()) sayFail(r); return; }
        delete refs[line.v];
        S.count = Math.max(0, S.count - 1);
        removed();
        loadState().then(sync);
      });
    }

    /* After «Angre»: focus back on the row (title link, else the remove button) and the totals updated. */
    function restored(li, line) {
      line.removed = false;
      li.classList.remove('is-removed');
      fill(li, line);
      vendors();
      totals();
      var f = li.querySelector('.pg-wl-item__title a, .pg-wl-item__remove');
      if (f) f.focus({ preventScroll: true });
    }

    function restore(li, line) {
      if (!signedIn) {
        var g = guestRead();
        if (guestFind(g, line.v) === -1 && g.items.length < GUEST_MAX && line.guest) { g.items.unshift(line.guest); guestWrite(g); }
        restored(li, line);
        sync();
        return;
      }
      write('/items/' + encodeURIComponent(line.ref) + '/restore', {}).then(function (r) {
        if (r.status !== 200 || !r.data || !r.data.item) { if (!isOff()) sayFail(r); return; }
        var next = lineOf(r.data.item) || line;
        rememberItem(r.data.item);
        next.li = li;
        lines[lines.indexOf(line)] = next;
        restored(li, next);
        loadState().then(sync);
      });
    }

    /* ── Lists (port 2) ── */
    function curRef() {
      if (!S.lists) return S.list ? S.list.ref : '';
      if (!current) { try { current = window.sessionStorage.getItem('pp-wl-cur') || ''; } catch (e) { current = ''; } }
      if (current && listByRef(current)) return current;
      var d = defaultList();
      current = d ? d.ref : (S.list ? S.list.ref : '');
      return current;
    }
    function setCurrent(ref) {
      current = ref || '';
      try { window.sessionStorage.setItem('pp-wl-cur', current); } catch (e) { /* no storage */ }
    }
    /* Targets for «Flytt eller kopier»: never an Ønskestue (suggestions there belong to members; contract stua v4.1 has no move into it). */
    function otherLists() { var c = curRef(); return S.lists ? activeLists().filter(function (l) { return l.ref !== c && l.kind !== 'stua'; }) : []; }
    function canShare(l) { return cfg.can_share === true && S.sharing && l && l.status === 'active' && l.kind !== 'stua'; }   // an Ønskestue is shared by invitation only
    /* Port 3: the gift wizard only when the portal has gifts on (features.gifts) and the theme allows it (wishlist_gift_staff_only). */
    function canGift(l) { return cfg.can_gift === true && S.gifts && l && l.status === 'active' && l.kind !== 'stua'; }
    /* Gift lists are on for this customer (portal features.gifts and the theme's gift pilot switch). */
    function giftsOn() { return cfg.can_gift === true && S.gifts; }
    /* Ønskestua (2026-10-11): «Gjør om til Ønskestua» on an active standard list when the portal has it on (features.stua). */
    function canStua(l) { return S.stuaOn && l && l.status === 'active' && l.kind === 'standard' && !l.isDefault; }   // never the standard list (portal: 409 wrong_kind, Tillegg 1 §1)

    /* After a list change: the state again (names, counts, union), then the page. */
    function reload(ref, text, undo) {
      listLoaded = null;   // the standard list may have changed: the heart refs are read again when needed
      loadState().then(function () {
        if (ref !== undefined) setCurrent(ref);
        sync();
        focusTab = true;
        refresh();
        if (text) say(text, undo);
      });
    }

    /* ── Menus (Knut 2026-10-11): one open at a time, under its button inside the list bar. Arrow keys move, Home/End jump, Escape closes and
       gives focus back to the button, Tab or a click outside closes. ── */
    var openMenu = null;   // { menu, btn }
    function closeMenu(focusBtn) {
      if (!openMenu) return;
      var m = openMenu;
      openMenu = null;
      if (m.menu.parentNode) m.menu.parentNode.removeChild(m.menu);
      m.btn.setAttribute('aria-expanded', 'false');
      document.removeEventListener('click', menuOutside, true);
      document.removeEventListener('keydown', menuKeys, true);
      if (focusBtn && document.contains(m.btn)) m.btn.focus({ preventScroll: true });
    }
    function menuOutside(e) { if (openMenu && !openMenu.menu.contains(e.target) && !openMenu.btn.contains(e.target)) closeMenu(false); }
    function menuKeys(e) {
      if (!openMenu) return;
      var items = Array.prototype.slice.call(openMenu.menu.querySelectorAll('[role^="menuitem"]'));
      var i = items.indexOf(document.activeElement);
      if (e.key === 'Escape') { e.preventDefault(); closeMenu(true); }
      else if (e.key === 'Tab') closeMenu(true);   // Tab then moves on from the menu button
      else if (!items.length) return;
      else if (e.key === 'ArrowDown') { e.preventDefault(); items[(i + 1) % items.length].focus(); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); items[i <= 0 ? items.length - 1 : i - 1].focus(); }
      else if (e.key === 'Home') { e.preventDefault(); items[0].focus(); }
      else if (e.key === 'End') { e.preventDefault(); items[items.length - 1].focus(); }
    }
    /* build(menu, btn) fills the menu with menuItem()/menuGroup()/menuSep(). */
    function menuButton(btn, label, build) {
      btn.setAttribute('aria-haspopup', 'menu');
      btn.setAttribute('aria-expanded', 'false');
      btn.addEventListener('click', function () {
        if (openMenu && openMenu.btn === btn) { closeMenu(true); return; }
        closeMenu(false);
        var host = btn.closest('.pg-wl-lists');
        if (!host) return;
        var menu = el('div', { class: 'pg-wl-menu', role: 'menu', 'aria-label': label });
        build(menu, btn);
        host.appendChild(menu);
        var hr = host.getBoundingClientRect(), br = btn.getBoundingClientRect();
        var left = br.left - hr.left;
        if (left + menu.offsetWidth > host.clientWidth) left = Math.max(0, br.right - hr.left - menu.offsetWidth);
        menu.style.top = Math.round(br.bottom - hr.top + 4) + 'px';
        menu.style.left = Math.round(Math.max(0, left)) + 'px';
        btn.setAttribute('aria-expanded', 'true');
        openMenu = { menu: menu, btn: btn };
        document.addEventListener('click', menuOutside, true);
        document.addEventListener('keydown', menuKeys, true);
        var first = menu.querySelector('[role^="menuitem"]');
        if (first) first.focus({ preventScroll: true });
      });
    }
    function menuItem(menu, label, fn, opts) {
      opts = opts || {};
      var it = opts.href
        ? el('a', { href: opts.href, class: 'pg-wl-menu__item', role: 'menuitem', tabindex: '-1' }, label)
        : el('button', { type: 'button', class: 'pg-wl-menu__item' + (opts.danger ? ' is-danger' : '') + (opts.note ? ' is-note' : ''), role: opts.radio ? 'menuitemradio' : 'menuitem', tabindex: '-1', 'aria-checked': opts.radio ? (opts.checked ? 'true' : 'false') : null }, label);
      /* Focus goes back to the menu button first, so a dialog opened by the item returns focus there when it closes. */
      if (fn) it.addEventListener('click', function () { var btn = openMenu && openMenu.btn; closeMenu(true); fn(btn); });
      else if (!opts.href) it.setAttribute('aria-disabled', 'true');
      menu.appendChild(it);
      return it;
    }
    /* A labelled group in a menu (screen readers announce the label when the arrow keys enter it); items go into the returned element. */
    function menuGroup(menu, label) {
      var g = el('div', { role: 'group', 'aria-label': label });
      g.appendChild(el('p', { class: 'pg-wl-menu__head', 'aria-hidden': 'true' }, label));
      menu.appendChild(g);
      return g;
    }
    function menuSep(menu) { menu.appendChild(el('div', { class: 'pg-wl-menu__sep', role: 'separator' })); }

    /* ── The list bar (Knut 2026-10-11, M1/M2/M3): ☰ at the far left with «Ny liste», «Ny gaveliste», the archived lists and help; a tab per
       active list (and the archived list shown); «⋯» with the choices for that list, on every tab (M1, default) or only on the open one (M2).
       On mobile the tabs scroll, or (M3, section setting) become one list picker with «⋯» next to it. ── */
    function listBar() {
      var cur = listByRef(curRef()) || defaultList();
      var wrap = el('div', { class: 'pg-wl-lists', 'data-menu-pc': menuPc, 'data-menu-mobile': menuMobile });
      var row = el('div', { class: 'pg-wl-lists__row' });
      var form = el('div', { class: 'pg-wl-lists__form' });
      form.hidden = true;
      function select(l) { if (!stuaRef && cur && l.ref === cur.ref) return; stuaRef = ''; setStueUrl(''); setCurrent(l.ref); focusTab = true; refresh(); }
      function shown() {
        var a = activeLists();
        if (cur && cur.status === 'archived') a = a.concat([cur]);
        return a;
      }

      /* Name form for «Ny liste», «Ny gaveliste» and «Gi nytt navn»: 1–80 characters, plain text. */
      function nameForm(start, onSave, opener) {
        form.textContent = '';
        form.hidden = false;
        var fid = 'wl-list-name';
        form.appendChild(el('label', { for: fid, class: 'pg-wl-qty__label' }, t('list_name', 'Navn på lista')));
        var r = el('div', { class: 'pg-wl-variant__row' });
        var input = el('input', { id: fid, type: 'text', maxlength: '80', class: 'pg-wl-lists__input', value: start, autocomplete: 'off' });
        var save = el('button', { type: 'button', class: 'pg-wl__btn' }, t('save', 'Lagre'));
        var cancel = el('button', { type: 'button', class: 'pg-wl__btn pg-wl__btn--alt' }, t('cancel', 'Avbryt'));
        r.appendChild(input); r.appendChild(save); r.appendChild(cancel);
        form.appendChild(r);
        function done() { form.hidden = true; form.textContent = ''; if (opener && document.contains(opener)) opener.focus({ preventScroll: true }); }
        cancel.addEventListener('click', done);
        input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); save.click(); } if (e.key === 'Escape') done(); });
        save.addEventListener('click', function () {
          var name = input.value.replace(/\s+/g, ' ').trim().slice(0, 80);
          if (!name) { say(t('name_required', 'Skriv et navn.')); input.focus(); return; }
          save.disabled = true;
          onSave(name).then(function (ok) { save.disabled = false; if (ok) { form.hidden = true; form.textContent = ''; } });
        });
        input.focus();
      }
      /* «Ny liste» / «Ny gaveliste»: the gift wizard opens on the new list once the state is read again. */
      function newList(opener, gift) {
        nameForm('', function (name) {
          return write('/lists', { name: name }).then(function (r) {
            if ((r.status === 201 || r.status === 200) && r.data) {
              var made = r.data.list && REF_RE.test(str(r.data.list.ref, 64)) ? r.data.list.ref : undefined;
              if (!gift || !made) { reload(made, t('list_created', 'Lista «__L__» er laget.').replace('__L__', name)); return true; }
              listLoaded = null;
              loadState().then(function () {
                setCurrent(made); sync(); focusTab = true; refresh();
                var l = listByRef(made);
                if (l && canGift(l)) giftWizard(l, 1);
              });
              return true;
            }
            if (!isOff()) say(listFail(r, '', 'list'));
            return false;
          });
        }, opener);
      }

      /* The choices for one list (its «⋯»). Actions on another list than the open one keep the open one. */
      function listMenu(menu, l) {
        var isCur = cur && l.ref === cur.ref;
        menuItem(menu, t('rename', 'Gi nytt navn'), function (opener) {
          nameForm(l.name, function (name) {
            return write('/lists/' + encodeURIComponent(l.ref), { name: name }).then(function (r) {
              if (r.status === 200) { reload(curRef(), t('renamed', 'Navnet er endret.')); return true; }
              if (!isOff()) say(listFail(r));
              return false;
            });
          }, opener);
        });
        if (canShare(l) && !(l.kind === 'gift' && l.gift && l.gift.mode !== 'unlisted')) menuItem(menu, t('share_make', 'Del lista'), function () { shareDialog(l); });
        if (l.kind === 'stua' && S.stuaOn) {
          menuItem(menu, t('s_invite', 'Inviter'), function () { invitesDialog(l); });
          menuItem(menu, t('s_settings_menu', 'Innstillinger for gaveplanen'), function () {
            if (stuaData && stuaData.ref === l.ref) { stuaDialog(l, 'edit'); return; }
            if (l.stua) { stuaDialog(l, 'edit', l.stua); return; }   // the list object has the settings (Tillegg 1 §2)
            stuaGet('/stua/' + encodeURIComponent(l.ref)).then(function (r) {
              var d = r.data;
              if (r.status !== 200 || !d || !d.list) { say(stuaFail(r)); return; }
              var me = d.me && d.me.member ? d.me.member : {};
              stuaDialog(l, 'edit', {
                me: { name: str(me.display_name, 40) }, occasion: str(d.list.occasion, 60), message: str(d.list.message, 500), from: str(d.list.from_name, 60),
                date: /^\d{4}-\d{2}-\d{2}$/.test(str(d.list.event_date, 10)) ? d.list.event_date : ''
              });
            });
          });
          menuItem(menu, t('s_unstua_menu', 'Gjør til vanlig liste'), function () { unstuaDialog(l); });
        } else if (canStua(l)) menuItem(menu, t('s_convert_menu', 'Gjør om til en gaveplan'), function () { stuaDialog(l, 'convert'); });
        if (canGift(l)) {
          if (l.kind === 'gift') {
            menuItem(menu, t('g_settings', 'Gaveinnstillinger'), function () { giftWizard(l, 2); });
            menuItem(menu, t('g_invitations', 'Invitasjoner'), function () { invitesDialog(l); });
          } else menuItem(menu, t('g_make', 'Gjør til gaveliste'), function () { giftWizard(l, 1); });
        }
        menuSep(menu);
        if (l.isDefault) { menuItem(menu, t('default_list', 'Standardlista kan ikke slettes eller arkiveres.'), null, { note: true }); return; }
        var arch = l.status === 'archived';
        menuItem(menu, arch ? t('unarchive', 'Hent fram') : t('archive', 'Arkiver'), function () {
          write('/lists/' + encodeURIComponent(l.ref), { status: arch ? 'active' : 'archived' }).then(function (r) {
            if (r.status === 200) { reload(arch ? l.ref : (isCur ? '' : curRef()), arch ? t('unarchived', 'Lista er hentet fram.') : t('archived', 'Lista er arkivert.')); return; }
            if (!isOff()) say(listFail(r));
          });
        });
        menuItem(menu, t('delete_list', 'Slett lista'), function () {
          write('/lists/' + encodeURIComponent(l.ref) + '/delete', {}).then(function (r) {
            if (r.status !== 200) { if (!isOff()) say(listFail(r)); return; }
            reload(isCur ? '' : curRef(), t('list_deleted', 'Lista «__L__» er slettet.').replace('__L__', l.name), {
              text: t('undo', 'Angre'),
              action: function () {
                write('/lists/' + encodeURIComponent(l.ref) + '/restore', {}).then(function (r2) {
                  if (r2.status === 200) reload(l.ref, t('list_restored', 'Lista er hentet tilbake.'));
                  else if (!isOff()) say(listFail(r2));
                });
              }
            });
          });
        }, { danger: true });
      }
      function dotsFor(l, cls) {
        var d = el('button', { type: 'button', class: cls, 'aria-label': t('list_options', 'Valg for «__L__»').replace('__L__', l.name) }, '⋯');
        menuButton(d, t('list_options', 'Valg for «__L__»').replace('__L__', l.name), function (menu) { listMenu(menu, l); });
        return d;
      }

      /* J: «Gaveplaner (n)» for the plans the customer is a member of (her own are tabs). Per plan: open, members, new visible name, leave;
         actions on a plan that is not open open it first. */
      function plansButton() {
        var mine = S.stuaOn ? S.stua.filter(function (s) { return !s.owner; }) : [];
        if (!mine.length) return null;
        var openNow = !!stuaRef && mine.some(function (s) { return s.ref === stuaRef; });
        var b = el('button', { type: 'button', class: 'pg-wl-lists__plans' + (openNow ? ' is-on' : '') });
        b.appendChild(el('span', null, t('s_plans_btn', 'Gaveplaner')));
        b.appendChild(el('span', { class: 'pg-wl-lists__n' }, String(mine.length)));
        b.appendChild(el('span', { class: 'pg-wl-lists__caret', 'aria-hidden': 'true' }, '▾'));
        menuButton(b, t('s_plans_btn', 'Gaveplaner'), function (menu) {
          mine.forEach(function (s, i) {
            if (i) menuSep(menu);
            var g = menuGroup(menu, s.name + (s.locked ? ' · ' + t('s_locked_short', 'låst') : ''));
            function inPlan(fn) { return function () { if (stuaData && stuaData.ref === s.ref && root.querySelector('.pg-wl-stua')) { fn(); return; } stuaPending = { ref: s.ref, fn: fn }; openStua(s.ref); }; }
            menuItem(g, t('s_open', 'Åpne gaveplanen'), function () { openStua(s.ref); }, { radio: true, checked: stuaRef === s.ref });
            menuItem(g, t('s_members_btn', 'Deltakere'), inPlan(function () { membersDialog(); }));
            if (stuaV42) menuItem(g, t('s_rename_me', 'Bytt visningsnavn'), inPlan(function () { var rb = root.querySelector('.pg-wl-stua__renameme'); if (rb) rb.click(); }));
            menuItem(g, t('s_leave', 'Forlat gaveplanen'), inPlan(function () { var lv = root.querySelector('.pg-wl-stua__leave'); if (lv) lv.click(); }), { danger: true });
          });
        });
        return b;
      }
      /* ☰ */
      var burger = el('button', { type: 'button', class: 'pg-wl-lists__burger', 'aria-label': t('list_menu', 'Listemeny') });
      burger.appendChild(el('span', { 'aria-hidden': 'true' })); burger.appendChild(el('span', { 'aria-hidden': 'true' })); burger.appendChild(el('span', { 'aria-hidden': 'true' }));
      menuButton(burger, t('list_menu', 'Listemeny'), function (menu) {
        menuItem(menu, t('new_list', 'Ny liste'), function (opener) { newList(opener, false); });
        if (cfg.can_gift === true && S.gifts) menuItem(menu, t('new_gift_list', 'Ny gaveliste'), function (opener) { newList(opener, true); });
        if (S.stuaOn) menuItem(menu, t('s_new', 'Ny gaveplan'), function () { stuaDialog(null, 'new'); });
        var archived = (S.lists || []).filter(function (l) { return l.status === 'archived'; });
        if (archived.length) {
          menuSep(menu);
          var ag = menuGroup(menu, t('archived_group', 'Arkiverte') + ' (' + archived.length + ')');
          archived.forEach(function (l) { menuItem(ag, l.name, function () { select(l); }, { radio: true, checked: cur && l.ref === cur.ref }); });
        }
        var help = safePath(root.getAttribute('data-help-url'));
        if (/[\s\\]/.test(help)) help = '';   // the same rule as snippets/wishlist-panel-link.liquid: no whitespace or backslash
        var helpLabel = root.getAttribute('data-help-label');
        if (help && helpLabel) { menuSep(menu); menuItem(menu, helpLabel, null, { href: help }); }
      });
      row.appendChild(burger);

      /* Tabs (PC, and mobile with «Faner»). The plans button (J, Knut 2026-10-12) sits right after the standard list's tab. */
      var tabs = el('div', { class: 'pg-wl-lists__tabs', role: 'group', 'aria-label': t('list_label', 'Lister') });
      var plansBtn = plansButton();
      shown().forEach(function (l) {
        var on = !stuaRef && cur && l.ref === cur.ref;
        var tab = el('div', { class: 'pg-wl-lists__tab' + (on ? ' is-on' : '') });
        var b = el('button', { type: 'button', class: 'pg-wl-lists__pick', 'aria-pressed': on ? 'true' : 'false' });
        b.appendChild(el('span', { class: 'pg-wl-lists__name' }, l.name));
        if (l.kind === 'gift') b.appendChild(el('span', { class: 'pg-wl-lists__badge pg-wl-lists__badge--gift' }, t('g_badge', 'Gave')));
        if (l.kind === 'stua' && S.stuaOn) b.appendChild(el('span', { class: 'pg-wl-lists__badge pg-wl-lists__badge--stua' }, t('s_badge', 'Gaveplan')));
        if (l.shared) b.appendChild(el('span', { class: 'pg-wl-lists__badge' }, t('shared_badge', 'Delt')));
        if (l.status === 'archived') b.appendChild(el('span', { class: 'pg-wl-lists__badge' }, t('archived_group', 'Arkiverte')));
        b.appendChild(el('span', { class: 'pg-wl-lists__n' }, String(l.count)));
        b.addEventListener('click', function () { select(l); });
        tab.appendChild(b);
        if (menuPc === 'm1' || on) tab.appendChild(dotsFor(l, 'pg-wl-lists__dots'));
        tabs.appendChild(tab);
        if (l.isDefault && plansBtn) tabs.appendChild(plansBtn);
      });
      if (plansBtn && !plansBtn.parentNode) tabs.appendChild(plansBtn);
      row.appendChild(tabs);

      /* M3 on mobile: one picker with the lists, and «⋯» for the open one. */
      if (menuMobile === 'picker' && cur) {
        var pickWrap = el('div', { class: 'pg-wl-lists__pickwrap' });
        var picker = el('button', { type: 'button', class: 'pg-wl-lists__picker' });
        var pickName = stuaRef && stuaData ? stuaData.name + ' · ' + t('s_name', 'Gaveplan') : cur.name + ' · ' + tn('count', cur.count, '__N__ varer');
        picker.appendChild(el('span', { class: 'pg-wl-lists__name' }, pickName));
        picker.appendChild(el('span', { class: 'pg-wl-lists__caret', 'aria-hidden': 'true' }, '▾'));
        menuButton(picker, t('choose_menu', 'Velg liste'), function (menu) {
          shown().forEach(function (l) {
            menuItem(menu, l.name + ' · ' + tn('count', l.count, '__N__ varer') + (l.kind === 'gift' ? ' · ' + t('g_badge', 'Gave') : ''), function () { select(l); }, { radio: true, checked: !stuaRef && l.ref === cur.ref });
          });
          var memberPlans = S.stuaOn ? S.stua.filter(function (x) { return !x.owner; }) : [];
          if (memberPlans.length) {
            menuSep(menu);
            var pg = menuGroup(menu, t('s_plans_btn', 'Gaveplaner'));
            memberPlans.forEach(function (x) { menuItem(pg, x.name + (x.locked ? ' · ' + t('s_locked_short', 'låst') : ''), function () { openStua(x.ref); }, { radio: true, checked: stuaRef === x.ref }); });
          }
        });
        pickWrap.appendChild(picker);
        if (!stuaRef) pickWrap.appendChild(dotsFor(cur, 'pg-wl-lists__dots pg-wl-lists__dots--box'));
        row.appendChild(pickWrap);
      }
      wrap.appendChild(row);
      wrap.appendChild(form);
      return wrap;
    }
    function redrawBar() {
      var old = root.querySelector('.pg-wl-lists');
      if (old && S.lists) old.parentNode.replaceChild(listBar(), old);
    }

    /* «Flytt eller kopier» on a line: the other active lists; 409 already_in_list / limit_reached as text. */
    function moveControl(li, line) {
      var wrap = el('div', { class: 'pg-wl-move' });
      var fid = 'wl-mv-' + line.v;
      var open = el('button', { type: 'button', class: 'pg-wl-variant__change', 'aria-expanded': 'false', 'aria-controls': fid + '-f' }, t('move_copy', 'Flytt eller kopier'));
      var form = el('div', { id: fid + '-f', class: 'pg-wl-move__form' });
      form.hidden = true;
      open.addEventListener('click', function () {
        form.hidden = !form.hidden;
        open.setAttribute('aria-expanded', form.hidden ? 'false' : 'true');
        if (form.hidden) return;
        form.textContent = '';
        form.appendChild(el('label', { for: fid, class: 'pg-wl-qty__label' }, t('to_list', 'Til liste')));
        var sel = el('select', { id: fid, class: 'pg-wl-variant__select' });
        otherLists().forEach(function (l) { sel.appendChild(el('option', { value: l.ref }, l.name)); });
        var row = el('div', { class: 'pg-wl-variant__row' });
        var mv = el('button', { type: 'button', class: 'pg-wl__btn pg-wl__btn--alt' }, t('move_btn', 'Flytt'));
        var cp = el('button', { type: 'button', class: 'pg-wl__btn pg-wl__btn--alt' }, t('copy_btn', 'Kopier'));
        row.appendChild(sel); row.appendChild(mv); row.appendChild(cp);
        form.appendChild(row);
        function target() { return listByRef(sel.value); }
        mv.addEventListener('click', function () {
          var to = target(); if (!to) return;
          var from = curRef();
          mv.disabled = cp.disabled = true;
          write('/items/' + encodeURIComponent(line.ref) + '/move', { list_ref: to.ref }).then(function (r) {
            mv.disabled = cp.disabled = false;
            if (r.status !== 200) { if (!isOff()) say(listFail(r, to.name, 'line')); return; }
            line.removed = true;
            if (li.parentNode) li.parentNode.removeChild(li);
            var at = lines.indexOf(line);
            if (at !== -1) lines.splice(at, 1);
            delete refs[line.v];
            listLoaded = null;
            totals();
            say(t('moved', 'Flyttet til __L__.').replace('__L__', to.name), {
              text: t('undo', 'Angre'),
              action: function () {
                write('/items/' + encodeURIComponent(line.ref) + '/move', { list_ref: from }).then(function (r2) {
                  if (r2.status === 200) reload(from); else if (!isOff()) say(listFail(r2));
                });
              }
            });
            var und = live && live.querySelector('.wl-live__action');
            if (und) und.focus({ preventScroll: true });   // the moved line (and its focused button) is gone
            loadState().then(function () { sync(); redrawBar(); if (!lines.length) refresh(); });
          });
        });
        cp.addEventListener('click', function () {
          var to = target(); if (!to) return;
          mv.disabled = cp.disabled = true;
          write('/items/' + encodeURIComponent(line.ref) + '/copy', { list_ref: to.ref }).then(function (r) {
            mv.disabled = cp.disabled = false;
            if (r.status !== 200 && r.status !== 201) { if (!isOff()) say(listFail(r, to.name, 'line')); return; }
            form.hidden = true;
            open.setAttribute('aria-expanded', 'false');
            say(t('copied_to', 'Kopiert til __L__.').replace('__L__', to.name));
            listLoaded = null;
            loadState().then(function () { sync(); redrawBar(); });
          });
        });
        sel.focus();
      });
      wrap.appendChild(open);
      wrap.appendChild(form);
      return wrap;
    }

    /* ── Sharing (port 2, §14 A2/A3): only when the portal has it on (features.sharing) and the theme allows it (can_share). The theme
       builds the link from the token; answers never turn the wishlist off. ── */
    function shareDialog(list) {
      if (typeof HTMLDialogElement === 'undefined' || !document.body) return;
      var d = el('dialog', { class: 'rw wl-share', 'aria-labelledby': 'wl-share-title' });
      var box = el('div', { class: 'rw__box' });
      var head = el('div', { class: 'rw__head' });
      head.appendChild(el('h2', { id: 'wl-share-title', class: 'rw__title' }, t('share_title', 'Del «__L__»').replace('__L__', list.name)));
      var x = el('button', { type: 'button', class: 'rw__close', 'aria-label': t('close', 'Lukk') }, '×');
      head.appendChild(x);
      var body = el('div', { class: 'rw__body', 'aria-live': 'polite' });
      box.appendChild(head); box.appendChild(body); d.appendChild(box);
      var opener = document.activeElement;
      var changed = false, closed = false;
      function close() {
        if (closed) return;
        closed = true;
        if (d.open) d.close();
        document.documentElement.classList.remove('pk-lock');
        if (d.parentNode) d.parentNode.removeChild(d);
        if (changed) reload(list.ref);
        else if (opener && opener.focus && document.contains(opener)) opener.focus({ preventScroll: true });
      }
      x.addEventListener('click', close);
      d.addEventListener('close', close);
      d.addEventListener('click', function (e) { if (e.target === d) close(); });
      function msg(text, kind) { return el('p', { class: 'rw__msg rw__msg--' + (kind || 'info'), role: kind === 'error' ? 'alert' : null }, text); }
      function call(path) { return write('/lists/' + encodeURIComponent(list.ref) + path, {}, { noJudge: true }); }
      var linkOf = shareLinkOf;
      function failed(r) {
        body.textContent = '';
        body.appendChild(msg(r.status === 404 ? failText(r).text : t('share_unavailable', 'Deling er ikke tilgjengelig akkurat nå.'), 'error'));
        x.focus({ preventScroll: true });
      }
      function showLink(link) {
        body.textContent = '';
        body.appendChild(el('p', { class: 'rw__intro' }, t('share_intro', '')));
        var fid = 'wl-share-link';
        body.appendChild(el('label', { for: fid, class: 'rw__label' }, t('share_link', 'Lenke til lista')));
        var input = el('input', { id: fid, type: 'text', readonly: true, class: 'rw__input wl-share__link', value: link });
        body.appendChild(input);
        var actions = el('div', { class: 'rw__actions' });
        var cp = el('button', { type: 'button', class: 'rw__submit' }, t('share_copy', 'Kopier lenke'));
        var rot = el('button', { type: 'button', class: 'rw__cancel' }, t('share_rotate', 'Lag ny lenke'));
        var rev = el('button', { type: 'button', class: 'rw__cancel' }, t('share_revoke', 'Slutt å dele'));
        actions.appendChild(cp); actions.appendChild(rot); actions.appendChild(rev);
        body.appendChild(actions);
        body.appendChild(el('p', { class: 'rw__help' }, t('share_rotate_help', 'En ny lenke gjør at den gamle slutter å virke.')));
        cp.addEventListener('click', function () {
          function done() { cp.textContent = t('share_copied', 'Kopiert!'); window.setTimeout(function () { cp.textContent = t('share_copy', 'Kopier lenke'); }, 2000); }
          function selectIt() { input.focus(); input.select(); }
          if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(link).then(done, selectIt); else selectIt();
        });
        rot.addEventListener('click', function () {
          rot.disabled = true;
          call('/share/rotate').then(function (r) {
            var l2 = r.status === 200 ? linkOf(r) : '';
            if (!l2) { failed(r); return; }
            changed = true;
            showLink(l2);
            body.insertBefore(msg(t('share_rotated', 'Ny lenke er laget. Den gamle virker ikke lenger.'), 'ok'), body.firstChild);
            var c2 = body.querySelector('.rw__submit'); if (c2) c2.focus({ preventScroll: true });
          });
        });
        rev.addEventListener('click', function () {
          rev.disabled = true;
          call('/share/revoke').then(function (r) {
            if (r.status !== 200) { failed(r); return; }
            changed = true;
            notShared(t('share_revoked', 'Lista er ikke delt lenger.'));
          });
        });
      }
      function notShared(note) {
        body.textContent = '';
        if (note) body.appendChild(msg(note, 'ok'));
        body.appendChild(el('p', { class: 'rw__intro' }, t('share_intro', '')));
        var actions = el('div', { class: 'rw__actions' });
        var mk = el('button', { type: 'button', class: 'rw__submit' }, t('share_create', 'Lag lenke'));
        var no = el('button', { type: 'button', class: 'rw__cancel' }, t('close', 'Lukk'));
        actions.appendChild(mk); actions.appendChild(no);
        body.appendChild(actions);
        no.addEventListener('click', close);
        mk.addEventListener('click', function () {
          mk.disabled = true;
          call('/share').then(function (r) {
            var link = (r.status === 200 || r.status === 201) ? linkOf(r) : '';
            if (!link) { failed(r); return; }
            changed = true;
            showLink(link);
            var c3 = body.querySelector('.rw__submit'); if (c3) c3.focus({ preventScroll: true });
          });
        });
        mk.focus();
      }
      document.body.appendChild(d);
      d.showModal();
      document.documentElement.classList.add('pk-lock');
      if (list.shared) {
        body.appendChild(el('p', { class: 'rw__intro' }, t('loading', 'Henter …')));
        /* POST share shows the active link again (§13 choice 2). */
        call('/share').then(function (r) {
          var link = (r.status === 200 || r.status === 201) ? linkOf(r) : '';
          if (!link) { failed(r); return; }
          showLink(link);
          var c = body.querySelector('.rw__submit'); if (c) c.focus();
        });
      } else notShared('');
    }

    /* ── A shared list (recipient, §14 A1): #t=<token> is exchanged once for a read session kept in localStorage (pp-wl-shared:<ref>), the
       address becomes ?delt=<ref> (keeping ?view=), and with a stored session only shared/list is asked. 404 = the link no longer works.
       These answers never turn the wishlist off. Shown for every visitor, signed in or not. ── */
    function parseShared() {
      /* layout/theme.liquid takes #t=<token> out of the address in <head>, before content_for_header (analytics) runs, and keeps it in
         window.__ppWlT for this script. Read once. */
      var early = typeof window.__ppWlT === 'string' ? window.__ppWlT : '';
      var earlyI = typeof window.__ppWlI === 'string' ? window.__ppWlI : '';   // port 3: an invitation (#i=)
      try { delete window.__ppWlT; delete window.__ppWlI; } catch (e) { window.__ppWlT = window.__ppWlI = undefined; }
      if (TOKEN_RE_G.test(earlyI)) return { token: '', invite: earlyI, ref: '' };
      if (TOKEN_RE_G.test(early)) return { token: early, invite: '', ref: '' };
      var m = /(?:^#|&)(t|i)=([A-Za-z0-9_-]{43})(?:&|$)/.exec(window.location.hash || '');
      if (m) { replaceUrl(''); return m[1] === 'i' ? { token: '', invite: m[2], ref: '' } : { token: m[2], invite: '', ref: '' }; }
      var q = '';
      try { q = new URLSearchParams(window.location.search).get('delt') || ''; } catch (e) { q = ''; }
      return REF_RE.test(q) ? { token: '', invite: '', ref: q } : null;
    }
    function postShared(path, body) {
      return request(path, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) }, WRITE_MS);
    }
    function sessKey(ref) { return 'pp-wl-shared:' + ref; }
    function readSession(ref) {
      try {
        var o = JSON.parse(window.localStorage.getItem(sessKey(ref)) || 'null');
        if (!o || !TOKEN_RE.test(o.s || '')) return '';
        if (typeof o.e === 'number' && o.e < Date.now()) { window.localStorage.removeItem(sessKey(ref)); return ''; }
        return o.s;
      } catch (e) { return ''; }
    }
    function storeSession(ref, session, expires) {
      var e = Date.parse(typeof expires === 'string' ? expires : '');
      try { window.localStorage.setItem(sessKey(ref), JSON.stringify({ s: session, e: isFinite(e) ? e : null })); } catch (er) { /* no storage */ }
    }
    function dropSession(ref) { try { window.localStorage.removeItem(sessKey(ref)); } catch (e) { /* no storage */ } }
    /* The secret leaves the address bar at once: ?delt=<ref> instead of #t=… (history.replaceState, other parameters kept). */
    function replaceUrl(ref) {
      try {
        var u = new URL(window.location.href);
        u.hash = '';
        if (ref) u.searchParams.set('delt', ref); else u.searchParams.delete('delt');
        window.history.replaceState(window.history.state, '', u.pathname + u.search);
      } catch (e) { /* old browser: the fragment stays */ }
    }
    function dead() { status(t('link_dead', 'Lenken virker ikke lenger.')); }
    function sharedDown() { status(t('shared_unavailable', 'Delte lister er ikke tilgjengelige akkurat nå.'), true); }
    function setHeading(name) {
      var h = document.querySelector('.pg-wl__title span');
      if (h && name) h.textContent = name;
      var intro = document.querySelector('.pg-wl__intro');
      var head = document.querySelector('.pg-wl__headtext');
      if (!intro && head) { intro = el('div', { class: 'pg-wl__intro' }); head.appendChild(intro); }
      var kick = head && head.querySelector('.pg-wl__kicker');
      if (head && !kick) { kick = el('p', { class: 'pg-wl__kicker' }); head.insertBefore(kick, head.firstChild); }
      if (kick) kick.textContent = giftView ? t('g_kicker', 'Gaveliste') : t('shared_kicker', 'Delt ønskeliste');
      /* U3 (Knut 2026-10-11): the wish owl next to the heading of a list someone shared. */
      var headRow = document.querySelector('.pg-wl__head');
      if (owl && headRow && !headRow.querySelector('.pg-wl__owl')) headRow.insertBefore(el('img', { class: 'pg-wl__owl', src: owl, alt: '', width: '72', height: '72' }), headRow.firstChild);
      if (!intro) return;
      intro.textContent = '';
      if (!giftView) { intro.textContent = t('shared_intro', ''); return; }
      /* Gift list: occasion and date, the owner's message as a quote, «Fra …», and what the giver can do. All plain text. */
      var when = [giftView.occasion, dateNo(giftView.date)].filter(Boolean).join(' · ');
      if (when) intro.appendChild(el('p', { class: 'pg-wl-gift__when' }, when));
      if (giftView.message) intro.appendChild(el('blockquote', { class: 'pg-wl-gift__quote' }, giftView.message));
      if (giftView.from) intro.appendChild(el('p', { class: 'pg-wl-gift__from' }, t('g_from', 'Fra __N__').replace('__N__', giftView.from)));
      intro.appendChild(el('p', null, ownView ? t('g_own_view', 'Slik ser giverne lista. Det de har planlagt eller kjøpt, vises ikke her.') : t('g_intro', '')));
    }

    /* ── Port 3: the giver's buttons on a gift line (shared/claims, …/cancel). Intention never blocks; «Kjøpt» can pass the wanted
       quantity. Answers never turn the wishlist off; after each change the list is read again. ── */
    /* The list again without the skeleton (no jump), focus back on the same line's gift box. */
    function claimReload(itemRef) {
      focusClaim = itemRef || '';
      listShared(++gen);
    }
    function giftBox(line) {
      var g = line.giftItem;
      var box = el('div', { class: 'pg-wl-gift' + (g.done ? ' is-done' : ''), tabindex: '-1', 'data-gift-ref': g.ref });
      /* W6 badges: moss for bought, honey for «Noen har tenkt å kjøpe» (a hint, not a reservation; the full sentence for screen readers). */
      var badges = el('p', { class: 'pg-wl-badges' });
      if (g.done) badges.appendChild(el('span', { class: 'pg-wl-badge pg-wl-badge--bought' }, t('g_purchased', 'Kjøpt')));
      else if (g.purchased > 0) badges.appendChild(el('span', { class: 'pg-wl-badge pg-wl-badge--bought' }, t('g_some_bought', '__P__ av __W__ er kjøpt').replace('__P__', String(g.purchased)).replace('__W__', String(g.wanted))));
      if (!g.done && g.intended > 0) {
        var ob = el('span', { class: 'pg-wl-badge pg-wl-badge--intended', title: t('g_others', '') || null }, t('g_others_badge', 'Noen har tenkt å kjøpe'));
        ob.appendChild(el('span', { class: 'rw__sr' }, ' – ' + t('g_others', 'Noen har tenkt å kjøpe denne – du kan fortsatt kjøpe den.').replace(/^[^–]*–\s*/, '')));
        badges.appendChild(ob);
      }
      var actions = el('div', { class: 'pg-wl-gift__actions' });
      var form = el('div', { class: 'pg-wl-gift__form' });
      form.hidden = true;
      function act(label, cls, fn) { var b = el('button', { type: 'button', class: cls }, label); b.addEventListener('click', function () { fn(b); }); actions.appendChild(b); return b; }
      if (g.mine && g.mine.ordered > 0) {
        /* Port 4: bought through an order with this list's link. No «Angre» (409 order_linked); «Denne er kjøpt» stays, so a giver who
           also bought more elsewhere can report the quantity (§14 C3: quantity = max(reported, ordered)). */
        /* «Kjøpt hos pippei.no 11.10.» (Knut 2026-10-11): the date from mine.purchased_on as day.month.; without a date the text alone. */
        var onDm = /^\d{4}-(\d{2})-(\d{2})$/.exec(g.mine.on || '');
        badges.appendChild(el('span', { class: 'pg-wl-badge pg-wl-badge--bought' }, t('g_ordered', 'Kjøpt hos pippei.no') + (onDm ? ' ' + onDm[2] + '.' + onDm[1] + '.' : '')));
        act(t('g_bought', 'Denne er kjøpt'), 'pg-wl__btn pg-wl__btn--alt', function (b) { boughtForm(b); });
      } else if (g.mine) {
        box.appendChild(el('p', { class: 'pg-wl-gift__mine' }, g.mine.status === 'purchased'
          ? t('g_mine_bought', 'Du har kjøpt __Q__').replace('__Q__', String(g.mine.quantity)) + (g.mine.on ? ' (' + dateNo(g.mine.on) + ')' : '')
          : t('g_mine_intended', 'Du har tenkt å kjøpe denne.')));
        if (g.mine.status === 'intended') act(t('g_bought', 'Denne er kjøpt'), 'pg-wl__btn pg-wl__btn--alt', function (b) { boughtForm(b); });
        act(t('undo', 'Angre'), 'pg-wl__link', function (b) {
          b.disabled = true;
          postShared('/shared/claims/' + encodeURIComponent(g.mine.ref) + '/cancel', { session: sharedSession }).then(function (r) { claimDone(r, b, t('g_undone', 'Angret.'), g.ref); });
        });
      } else {
        act(t('g_intend', 'Denne har jeg tenkt å kjøpe'), 'pg-wl__btn pg-wl__btn--alt', function (b) {
          b.disabled = true;
          postShared('/shared/claims', { session: sharedSession, item_ref: g.ref, status: 'intended', quantity: 1 }).then(function (r) { claimDone(r, b, t('g_intended_ok', 'Lagret: du har tenkt å kjøpe denne.'), g.ref); });
        });
        act(t('g_bought', 'Denne er kjøpt'), 'pg-wl__btn pg-wl__btn--alt', function (b) { boughtForm(b); });
      }
      /* «Denne er kjøpt»: date (today, at the latest today) and quantity. */
      function boughtForm(opener) {
        form.textContent = '';
        form.hidden = false;
        var fid = 'wl-g-' + g.ref;
        var row = el('div', { class: 'pg-wl-variant__row' });
        var dl = el('label', { class: 'pg-wl-gift__field' });
        dl.appendChild(el('span', { class: 'pg-wl-qty__label' }, t('g_date', 'Kjøpt dato')));
        var date = el('input', { id: fid + '-d', type: 'date', class: 'pg-wl-gift__input', max: todayIso(), value: todayIso() });
        dl.appendChild(date);
        var ql = el('label', { class: 'pg-wl-gift__field' });
        ql.appendChild(el('span', { class: 'pg-wl-qty__label' }, t('g_qty', 'Antall')));
        var q = el('input', { id: fid + '-q', type: 'number', min: '1', max: '99', inputmode: 'numeric', class: 'pg-wl-gift__input pg-wl-gift__input--qty', value: String(Math.max(1, (g.mine && g.mine.quantity) || Math.max(1, g.wanted - g.purchased))) });
        ql.appendChild(q);
        var save = el('button', { type: 'button', class: 'pg-wl__btn' }, t('save', 'Lagre'));
        var cancel = el('button', { type: 'button', class: 'pg-wl__btn pg-wl__btn--alt' }, t('cancel', 'Avbryt'));
        row.appendChild(dl); row.appendChild(ql); row.appendChild(save); row.appendChild(cancel);
        form.appendChild(row);
        cancel.addEventListener('click', function () { form.hidden = true; form.textContent = ''; if (opener) opener.focus({ preventScroll: true }); });
        save.addEventListener('click', function () {
          var qty = Math.min(99, Math.max(1, parseInt(q.value, 10) || 1));
          var on = /^\d{4}-\d{2}-\d{2}$/.test(date.value) && date.value <= todayIso() ? date.value : todayIso();
          save.disabled = true;
          postShared('/shared/claims', { session: sharedSession, item_ref: g.ref, status: 'purchased', quantity: qty, purchased_on: on })
            .then(function (r) { claimDone(r, save, t('g_bought_ok', 'Lagret som kjøpt.'), g.ref); });
        });
        date.focus();
      }
      if (badges.firstChild) box.insertBefore(badges, box.firstChild);
      box.appendChild(actions);
      box.appendChild(form);
      return box;
    }
    function claimDone(r, b, okText, itemRef) {
      if (r.status === 200 || r.status === 201) { say(okText); claimReload(itemRef); return; }
      if (b) b.disabled = false;
      var err = r.data && typeof r.data.error === 'string' ? r.data.error : '';
      /* 404: the line or the claim is gone; a dead session is found by the list read itself (it drops the session there). */
      if (r.status === 404) { say(t('g_failed', 'Kunne ikke lagre akkurat nå. Prøv igjen.')); claimReload(itemRef); return; }
      if (r.status === 409 && err === 'own_list') { say(t('g_own_list', 'Du kan ikke merke gaver på din egen liste.')); return; }
      if (r.status === 409 && err === 'order_linked') { say(t('g_order_linked', 'Kjøpet er registrert fra bestillingen.')); claimReload(itemRef); return; }
      if (r.status === 409 && err === 'not_gift') { say(t('g_not_gift', 'Denne lista er ikke en gaveliste lenger.')); claimReload(itemRef); return; }
      if (r.status === 422) { say(t('g_invalid', 'Sjekk dato og antall.')); return; }
      say(t('g_failed', 'Kunne ikke lagre akkurat nå. Prøv igjen.'));
    }

    /* E-mail addresses typed by the owner: one per line or separated by comma/semicolon; duplicates dropped; what does not look like an
       address is reported, never sent. */
    function parseEmails(text) {
      var seen = {}, ok = [], bad = [];
      String(text || '').split(/[\s,;]+/).forEach(function (e) {
        e = e.trim().toLowerCase();
        if (!e || seen[e]) return;
        seen[e] = true;
        if (/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(e) && e.length <= 254) ok.push(e); else bad.push(e.slice(0, 60));
      });
      return { ok: ok, bad: bad };
    }

    /* ── Port 3: the gift wizard (owner). Steps: 1 standard or gift, 2 invited only or link, 3 surprise or visible, 4 occasion, date, message
       and «fra», 5 e-mail addresses, 6 preview, 7 save and send. POST lists/{ref}/gift, then lists/{ref}/invitations; «Vanlig liste»
       on a gift list is POST lists/{ref}/ungift. Answers never turn the wishlist off. ── */
    function giftWizard(list, startStep) {
      if (typeof HTMLDialogElement === 'undefined' || !document.body) return;
      var g0 = list.gift || {};
      var v = {
        kind: 'gift', mode: g0.mode || 'invite_only', visibility: g0.visibility || 'surprise',
        occasion: g0.occasion || '', date: g0.date || '', message: g0.message || '', from: g0.from || '', emails: ''
      };
      var step = startStep || 1;
      var d = el('dialog', { class: 'rw wl-gift', 'aria-labelledby': 'wl-gift-title' });
      var box = el('div', { class: 'rw__box' });
      var head = el('div', { class: 'rw__head' });
      var title = el('h2', { id: 'wl-gift-title', class: 'rw__title', tabindex: '-1' });
      head.appendChild(title);
      var x = el('button', { type: 'button', class: 'rw__close', 'aria-label': t('close', 'Lukk') }, '×');
      head.appendChild(x);
      var body = el('div', { class: 'rw__body' });
      box.appendChild(head); box.appendChild(body); d.appendChild(box);
      var opener = document.activeElement, closed = false, changed = false;
      function close() {
        if (closed) return;
        closed = true;
        if (d.open) d.close();
        document.documentElement.classList.remove('pk-lock');
        if (d.parentNode) d.parentNode.removeChild(d);
        if (changed) reload(list.ref);
        else if (opener && opener.focus && document.contains(opener)) opener.focus({ preventScroll: true });
      }
      x.addEventListener('click', close);
      d.addEventListener('close', close);   // a 7-step form: no close on a backdrop click, so typed fields are not lost
      /* A message inside the dialog (the page notice is inert behind a modal). */
      function inline(text) {
        var old = body.querySelector('.wl-gift__err');
        if (old) old.parentNode.removeChild(old);
        body.insertBefore(el('p', { class: 'rw__msg rw__msg--error wl-gift__err', role: 'alert' }, text), body.firstChild);
      }
      function radios(name, opts, value, onPick, legend) {
        var fs = el('fieldset', { class: 'wl-pick__set' });
        fs.appendChild(el('legend', { class: 'wl-gift__legend' }, legend));
        opts.forEach(function (o) {
          var lab = el('label', { class: 'wl-pick__opt wl-pick__opt--text' });
          var inp = el('input', { type: 'radio', name: name, value: o[0], checked: o[0] === value ? true : null });
          inp.addEventListener('change', function () { onPick(o[0]); });
          lab.appendChild(inp);
          var tx = el('span');
          tx.appendChild(el('b', null, o[1]));
          if (o[2]) tx.appendChild(el('span', { class: 'wl-gift__help' }, o[2]));
          lab.appendChild(tx);
          fs.appendChild(lab);
        });
        return fs;
      }
      function field(label, input, help) {
        var w = el('div', { class: 'rw__field' });
        var lab = el('label', { class: 'rw__label', for: input.id }, label);
        w.appendChild(lab); w.appendChild(input);
        if (help) w.appendChild(el('p', { class: 'rw__help' }, help));
        return w;
      }
      function nav(nextLabel, onNext, back) {
        var a = el('div', { class: 'rw__actions' });
        var nx = el('button', { type: 'button', class: 'rw__submit' }, nextLabel);
        nx.addEventListener('click', onNext);
        a.appendChild(nx);
        if (back) { var bk = el('button', { type: 'button', class: 'rw__cancel' }, t('g_back', 'Tilbake')); bk.addEventListener('click', back); a.appendChild(bk); }
        return a;
      }
      function emailsOf(text) { return parseEmails(text).ok; }
      function show(n) {
        step = n;
        body.textContent = '';
        title.textContent = t('g_wizard_title', 'Gaveliste: __L__').replace('__L__', list.name) + ' · ' + t('g_step', 'steg __N__ av 7').replace('__N__', String(n));
        if (n === 1) {
          body.appendChild(radios('wl-g-kind', [['standard', t('g_kind_standard', 'Vanlig ønskeliste'), t('g_kind_standard_help', 'Bare for deg, eller delt med lenke.')], ['gift', t('g_kind_gift', 'Gaveliste'), t('g_kind_gift_help', 'Venner og familie kan merke hva de skal kjøpe.')]], v.kind, function (k) { v.kind = k; }, t('g_s1', 'Hva slags liste skal dette være?')));
          body.appendChild(nav(t('g_next', 'Neste'), function () {
            if (v.kind === 'gift') { show(2); return; }
            if (list.kind !== 'gift') { close(); return; }
            confirmUngift();
          }));
        } else if (n === 2) {
          body.appendChild(radios('wl-g-mode', [['invite_only', t('g_mode_invite', 'Bare de jeg inviterer'), t('g_mode_invite_help', 'De får en personlig lenke på e-post.')], ['unlisted', t('g_mode_link', 'Alle som har lenken'), t('g_mode_link_help', 'Du kan også dele en lenke selv.')]], v.mode, function (m) { v.mode = m; }, t('g_s2', 'Hvem skal kunne se lista og merke gaver?')));
          body.appendChild(nav(t('g_next', 'Neste'), function () { show(3); }, function () { show(1); }));
        } else if (n === 3) {
          body.appendChild(radios('wl-g-vis', [['surprise', t('g_vis_surprise', 'La det være en overraskelse'), t('g_vis_surprise_help', 'Du ser ikke hva andre har tenkt å kjøpe eller har kjøpt.')], ['visible', t('g_vis_visible', 'Vis meg hva som er planlagt og kjøpt'), t('g_vis_visible_help', 'Du ser «N planlagt / N kjøpt» ved hver vare.')]], v.visibility, function (s2) { v.visibility = s2; }, t('g_s3', 'Vil du se hva som er planlagt og kjøpt?')));
          body.appendChild(nav(t('g_next', 'Neste'), function () { show(4); }, function () { show(2); }));
        } else if (n === 4) {
          var occ = el('input', { id: 'wl-g-occ', type: 'text', maxlength: '60', class: 'rw__input', value: v.occasion, autocomplete: 'off' });
          var dt = el('input', { id: 'wl-g-date', type: 'date', class: 'rw__input', value: v.date });
          var msgI = el('textarea', { id: 'wl-g-msg', maxlength: '500', rows: '4', class: 'rw__input' });
          msgI.value = v.message;
          var from = el('input', { id: 'wl-g-from', type: 'text', maxlength: '60', class: 'rw__input', value: v.from, autocomplete: 'name' });
          body.appendChild(field(t('g_occasion', 'Anledning'), occ, t('g_occasion_help', 'For eksempel «Olav 2 år». Høyst 60 tegn.')));
          body.appendChild(field(t('g_date_event', 'Dato'), dt, t('g_optional', 'Valgfritt.')));
          body.appendChild(field(t('g_message', 'Hilsen til giverne'), msgI, t('g_message_help', 'Vises som sitat på gavesiden. Høyst 500 tegn.')));
          body.appendChild(field(t('g_from_name', 'Fra'), from, t('g_from_help', 'Navnet giverne ser i invitasjonen og på gavesiden.')));
          function keep() { v.occasion = occ.value.trim(); v.date = dt.value; v.message = msgI.value.trim(); v.from = from.value.trim(); }
          body.appendChild(nav(t('g_next', 'Neste'), function () { keep(); show(5); }, function () { keep(); show(3); }));
          title.focus({ preventScroll: true });
          return;
        } else if (n === 5) {
          var em = el('textarea', { id: 'wl-g-emails', rows: '4', class: 'rw__input', autocomplete: 'off', spellcheck: 'false' });
          em.value = v.emails;
          body.appendChild(field(t('g_emails', 'E-postadresser'), em, t('g_emails_help', 'Én per linje eller skilt med komma, høyst 25. Du kan også invitere senere.')));
          body.appendChild(nav(t('g_next', 'Neste'), function () {
            v.emails = em.value;
            var pe = parseEmails(v.emails);
            if (pe.bad.length) { inline(t('g_bad_emails', 'Sjekk adressene: __E__').replace('__E__', pe.bad.slice(0, 5).join(', '))); em.focus(); return; }
            if (pe.ok.length > 25) { inline(t('g_too_many', 'Høyst 25 adresser om gangen.')); em.focus(); return; }
            show(6);
          }, function () { v.emails = em.value; show(4); }));
          title.focus({ preventScroll: true });
          return;
        } else if (n === 6) {
          var list6 = el('dl', { class: 'wl-gift__preview' });
          function row6(k, val) { list6.appendChild(el('dt', null, k)); list6.appendChild(el('dd', null, val || '–')); }
          row6(t('g_p_access', 'Tilgang'), v.mode === 'unlisted' ? t('g_mode_link', 'Alle som har lenken') : t('g_mode_invite', 'Bare de jeg inviterer'));
          row6(t('g_p_you', 'Du ser'), v.visibility === 'visible' ? t('g_vis_visible', 'Vis meg hva som er planlagt og kjøpt') : t('g_vis_surprise', 'La det være en overraskelse'));
          row6(t('g_occasion', 'Anledning'), [v.occasion, dateNo(v.date)].filter(Boolean).join(' · '));
          row6(t('g_message', 'Hilsen til giverne'), v.message);
          row6(t('g_from_name', 'Fra'), v.from);
          var n6 = emailsOf(v.emails).length;
          row6(t('g_p_invites', 'Invitasjoner'), n6 ? t('g_p_invites_n', '__N__ adresser').replace('__N__', String(n6)) : t('g_p_none', 'Ingen nå'));
          body.appendChild(el('p', { class: 'rw__intro' }, t('g_s6', 'Slik blir gavelista. Giverne ser aldri hverandres navn.')));
          body.appendChild(list6);
          body.appendChild(nav(n6 ? t('g_save_send', 'Lagre og send') : t('save', 'Lagre'), function (e) { var b0 = e.currentTarget; if (b0.disabled) return; send(b0); }, function () { show(5); }));
        }
        /* The step is announced by moving focus to its heading. */
        title.focus({ preventScroll: true });
      }
      function fail(r) {
        var err = r.data && typeof r.data.error === 'string' ? r.data.error : '';
        if (r.status === 409 && err === 'surprise_locked') return t('g_locked', 'Noen har allerede begynt å planlegge gaver, så overraskelsen kan ikke slås av nå.');
        if (r.status === 409 && err === 'invitations_unavailable') return t('g_inv_unavailable', 'Invitasjoner kan ikke sendes akkurat nå.');
        if (r.status === 409 && err === 'limit_reached') return t('g_inv_limit', 'Lista har nådd grensen for invitasjoner.');
        if (r.status === 422) return t('g_invalid_fields', 'Sjekk feltene.');
        if (r.status === 429) return t('g_cooldown', 'Vent litt før du prøver igjen.');
        if (r.status >= 500 || r.status === 0 || !r.data) return t('g_unavailable', 'Gavelister er ikke tilgjengelige akkurat nå.');
        return failText(r).text;
      }
      function result(text, kind) {
        title.textContent = t('g_wizard_title', 'Gaveliste: __L__').replace('__L__', list.name);
        body.textContent = '';
        body.appendChild(el('p', { class: 'rw__msg rw__msg--' + kind, role: kind === 'error' ? 'alert' : 'status' }, text));
        var a = el('div', { class: 'rw__actions' });
        var ok = el('button', { type: 'button', class: 'rw__submit' }, t('close', 'Lukk'));
        ok.addEventListener('click', close);
        a.appendChild(ok);
        body.appendChild(a);
        ok.focus({ preventScroll: true });
      }
      function send(btn) {
        btn.disabled = true;
        var payload = { occasion: v.occasion, message: v.message, from_name: v.from, share_mode: v.mode, visibility: v.visibility };
        payload.event_date = v.date || null;
        write('/lists/' + encodeURIComponent(list.ref) + '/gift', payload, { noJudge: true }).then(function (r) {
          if (r.status !== 200 && r.status !== 201) {
            btn.disabled = false;
            var err = r.data && typeof r.data.error === 'string' ? r.data.error : '';
            /* Back to the step that can fix it, with the message there. */
            if (r.status === 409 && err === 'surprise_locked') { v.visibility = 'surprise'; show(3); inline(fail(r)); return; }
            if (r.status === 422) { show(4); inline(fail(r)); return; }
            result(fail(r), 'error');
            return;
          }
          changed = true;
          if (closed) { reload(list.ref); return; }
          var emails = emailsOf(v.emails);
          if (!emails.length) { result(t('g_saved', 'Gavelista er lagret.') + (v.mode === 'unlisted' ? ' ' + t('g_link_hint', 'Lenken lager du med «Del».') : ''), 'ok'); return; }
          write('/lists/' + encodeURIComponent(list.ref) + '/invitations', { emails: emails.slice(0, 25) }, { noJudge: true }).then(function (r2) {
            if (closed) { reload(list.ref); return; }
            if (r2.status !== 200 && r2.status !== 201) {
              /* The list is saved; the addresses are kept so the invitations can be sent again from «Invitasjoner». */
              result(t('g_saved', 'Gavelista er lagret.') + ' ' + fail(r2) + ' ' + t('g_retry_invites', 'Prøv igjen under «Invitasjoner».'), 'error');
              pendingInvites[list.ref] = v.emails;
              return;
            }
            var inv = r2.data && Array.isArray(r2.data.invitations) ? r2.data.invitations.length : emails.length;
            result(t('g_saved_sent', 'Gavelista er lagret, og __N__ invitasjoner er sendt.').replace('__N__', String(inv)), 'ok');
          });
        });
      }
      /* «Vanlig ønskeliste» on a gift list: say what stops working first. */
      function confirmUngift() {
        body.textContent = '';
        body.appendChild(el('p', { class: 'rw__msg rw__msg--info' }, t('g_ungift_confirm', 'Invitasjonene og lenken til lista slutter å virke, og det giverne har merket, skjules. Varene blir liggende.')));
        var a = el('div', { class: 'rw__actions' });
        var yes = el('button', { type: 'button', class: 'rw__submit' }, t('g_ungift_yes', 'Gjør til vanlig liste'));
        var no = el('button', { type: 'button', class: 'rw__cancel' }, t('g_back', 'Tilbake'));
        a.appendChild(yes); a.appendChild(no);
        body.appendChild(a);
        no.addEventListener('click', function () { show(1); });
        yes.addEventListener('click', function () { yes.disabled = no.disabled = true; ungift(); });
        yes.focus({ preventScroll: true });
      }
      function ungift() {
        write('/lists/' + encodeURIComponent(list.ref) + '/ungift', {}, { noJudge: true }).then(function (r) {
          if (r.status !== 200) { result(fail(r), 'error'); return; }
          changed = true;
          if (closed) { reload(list.ref); return; }
          result(t('g_ungifted', 'Lista er en vanlig ønskeliste igjen. Invitasjoner og lenker er trukket tilbake.'), 'ok');
        });
      }
      document.body.appendChild(d);
      d.showModal();
      document.documentElement.classList.add('pk-lock');
      show(step);
    }

    /* ── Port 3: invitations of a gift list (GET lists/{ref}/invitations): status, «Send på nytt» (429 cooldown), «Trekk tilbake», and
       more addresses. The owner sees the addresses she or he typed. ── */
    function invitesDialog(list) {
      if (typeof HTMLDialogElement === 'undefined' || !document.body) return;
      var d = el('dialog', { class: 'rw wl-invites', 'aria-labelledby': 'wl-inv-title' });
      var box = el('div', { class: 'rw__box' });
      var head = el('div', { class: 'rw__head' });
      head.appendChild(el('h2', { id: 'wl-inv-title', class: 'rw__title' }, t('g_inv_title', 'Invitasjoner: __L__').replace('__L__', list.name)));
      var x = el('button', { type: 'button', class: 'rw__close', 'aria-label': t('close', 'Lukk') }, '×');
      head.appendChild(x);
      var live2 = el('div', { class: 'wl-invites__live', role: 'status', 'aria-live': 'polite' });
      var body = el('div', { class: 'rw__body' });
      box.appendChild(head); box.appendChild(live2); box.appendChild(body); d.appendChild(box);
      var opener = document.activeElement, closed = false;
      function close() {
        if (closed) return;
        closed = true;
        if (d.open) d.close();
        document.documentElement.classList.remove('pk-lock');
        if (d.parentNode) d.parentNode.removeChild(d);
        if (opener && opener.focus && document.contains(opener)) opener.focus({ preventScroll: true });
      }
      x.addEventListener('click', close);
      d.addEventListener('close', close);
      d.addEventListener('click', function (e) { if (e.target === d) close(); });
      /* Messages inside the dialog: errors as an alert, results in the status line (the page notice is inert behind a modal). */
      function note2(text, kind) {
        live2.textContent = '';
        live2.appendChild(el('p', { class: 'rw__msg rw__msg--' + kind, role: kind === 'error' ? 'alert' : null }, text));
      }
      /* Ønskestua uses the same invitations (stua-kontrakt.md): its own «not available» text and the member limit. */
      var unavail = list.kind === 'stua' ? t('s_unavailable', 'Gaveplanen er ikke tilgjengelig akkurat nå.') : t('g_unavailable', 'Gavelister er ikke tilgjengelige akkurat nå.');
      var STATUS = { queued: t('g_st_queued', 'I kø'), sent: t('g_st_sent', 'Sendt'), failed: t('g_st_failed', 'Feilet'), revoked: t('g_st_revoked', 'Trukket tilbake') };
      function load(note, focusRef) {
        if (!body.firstChild) body.appendChild(el('p', { class: 'rw__intro' }, t('loading', 'Henter …')));
        request('/lists/' + encodeURIComponent(list.ref) + '/invitations', { method: 'GET' }, READ_MS).then(function (r) {
          body.textContent = '';
          if (note) note2(note[0], note[1]);
          var items = r.status === 200 && r.data && Array.isArray(r.data.invitations) ? r.data.invitations.slice(0, 100) : null;
          if (!items) { body.appendChild(el('p', { class: 'rw__msg rw__msg--error', role: 'alert' }, unavail)); return; }
          if (!items.length) body.appendChild(el('p', { class: 'rw__intro' }, t('g_inv_none', 'Ingen er invitert ennå.')));
          var ul = el('ul', { class: 'wl-invites__list', role: 'list' });
          items.forEach(function (it) {
            if (!it || !REF_RE.test(str(it.ref, 64))) return;
            /* {ref, email, status, sent_count, last_sent_at, expires_at, revoked} (portal 2026-10-11). */
            var st = it.revoked === true ? 'revoked' : (STATUS[it.status] ? it.status : 'queued');
            var li = el('li', { class: 'wl-invites__row', 'data-inv': it.ref });
            var tx = el('div', { class: 'wl-invites__text' });
            tx.appendChild(el('span', { class: 'wl-invites__email' }, str(it.email, 254)));
            var info = STATUS[st];
            var sentN = count(it.sent_count);
            var lastOn = /^\d{4}-\d{2}-\d{2}/.test(str(it.last_sent_at, 40)) ? dateNo(it.last_sent_at.slice(0, 10)) : '';
            if (st !== 'revoked' && sentN && lastOn) info += ' · ' + t('g_sent_info', 'sendt __N__ ganger, sist __D__').replace('__N__', String(sentN)).replace('__D__', lastOn);
            tx.appendChild(el('span', { class: 'wl-invites__status wl-invites__status--' + st }, info));
            li.appendChild(tx);
            if (st !== 'revoked') {
              var a = el('div', { class: 'wl-invites__actions' });
              var rs = el('button', { type: 'button', class: 'pg-wl__link' }, t('g_resend', 'Send på nytt'));
              var rv = el('button', { type: 'button', class: 'pg-wl__link' }, t('g_revoke', 'Trekk tilbake'));
              rs.addEventListener('click', function () {
                rs.disabled = true;
                write('/invitations/' + encodeURIComponent(it.ref) + '/resend', {}, { noJudge: true }).then(function (r2) {
                  if (r2.status === 200) { load([t('g_resent', 'Invitasjonen er sendt på nytt.'), 'ok'], it.ref); return; }
                  rs.disabled = false;
                  note2(r2.status === 429 ? t('g_cooldown', 'Vent litt før du sender på nytt (høyst tre ganger i døgnet).') : unavail, 'error');
                });
              });
              rv.addEventListener('click', function () {
                rv.disabled = true;
                write('/invitations/' + encodeURIComponent(it.ref) + '/revoke', {}, { noJudge: true }).then(function (r2) {
                  if (r2.status === 200) { load([t('g_revoked', 'Invitasjonen er trukket tilbake.'), 'ok'], it.ref); return; }
                  rv.disabled = false;
                  note2(unavail, 'error');
                });
              });
              a.appendChild(rs); a.appendChild(rv);
              li.appendChild(a);
            }
            ul.appendChild(li);
          });
          body.appendChild(ul);
          /* More addresses. */
          var fid = 'wl-inv-more';
          var w = el('div', { class: 'rw__field' });
          w.appendChild(el('label', { class: 'rw__label', for: fid }, t('g_emails', 'E-postadresser')));
          var em = el('textarea', { id: fid, rows: '3', class: 'rw__input', autocomplete: 'off', spellcheck: 'false' });
          if (pendingInvites[list.ref]) { em.value = pendingInvites[list.ref]; }   // addresses from a wizard save whose invitations failed
          w.appendChild(em);
          w.appendChild(el('p', { class: 'rw__help' }, t('g_emails_help', '')));
          body.appendChild(w);
          var acts = el('div', { class: 'rw__actions' });
          var add = el('button', { type: 'button', class: 'rw__submit' }, t('g_invite', 'Inviter'));
          acts.appendChild(add);
          body.appendChild(acts);
          add.addEventListener('click', function () {
            var pe = parseEmails(em.value);
            var emails = pe.ok;
            if (pe.bad.length) { note2(t('g_bad_emails', 'Sjekk adressene: __E__').replace('__E__', pe.bad.slice(0, 5).join(', ')), 'error'); em.focus(); return; }
            if (!emails.length) { em.focus(); return; }
            if (emails.length > 25) { note2(t('g_too_many', 'Høyst 25 adresser om gangen.'), 'error'); return; }
            add.disabled = true;
            write('/lists/' + encodeURIComponent(list.ref) + '/invitations', { emails: emails }, { noJudge: true }).then(function (r2) {
              add.disabled = false;
              if (r2.status === 200 || r2.status === 201) {
                delete pendingInvites[list.ref];
                var n2 = r2.data && Array.isArray(r2.data.invitations) ? r2.data.invitations.length : emails.length;
                load([t('g_invites_sent', '__N__ invitasjoner er sendt.').replace('__N__', String(n2)), 'ok']);
                return;
              }
              var err = r2.data && typeof r2.data.error === 'string' ? r2.data.error : '';
              note2(err === 'invitations_unavailable' ? t('g_inv_unavailable', 'Invitasjoner kan ikke sendes akkurat nå.')
                : err === 'limit_reached' ? (list.kind === 'stua' && r2.data && r2.data.limit === 'members' ? t('s_limit_members', 'Gaveplanen er full (høyst 30 deltakere).') : t('g_inv_limit', 'Lista har nådd grensen for invitasjoner.'))
                : r2.status === 429 ? t('g_cooldown', 'Vent litt før du prøver igjen.')
                : r2.status === 422 ? t('g_invalid_fields', 'Sjekk feltene.') : unavail, 'error');
            });
          });
          var f = (focusRef && body.querySelector('[data-inv="' + focusRef + '"] button')) || body.querySelector('.wl-invites__actions button, textarea');
          if (f) f.focus({ preventScroll: true });
        });
      }
      document.body.appendChild(d);
      d.showModal();
      document.documentElement.classList.add('pk-lock');
      load(null);
    }
    function sharedLine(it) {
      if (!it || typeof it !== 'object') return null;
      var prod = productOf(it.product);
      if (!prod) return null;
      var snap = it.snapshot && typeof it.snapshot === 'object' ? it.snapshot : {};
      var mine = Array.isArray(it.mine) ? it.mine[0] : it.mine;
      return {
        ref: null, v: prod.v, p: prod.p, readonly: true,
        /* Port 3 gift line: open ref for claims, wanted, others intending, purchased, status and my own claim. */
        giftItem: giftView && !ownView && REF_RE.test(str(it.ref, 64)) ? {
          ref: it.ref, wanted: count(it.wanted) || 1, intended: count(it.intended) || 0, purchased: count(it.purchased) || 0,
          done: it.status === 'purchased',
          mine: mine && typeof mine === 'object' && REF_RE.test(str(mine.ref, 64)) && (mine.status === 'intended' || mine.status === 'purchased')
            ? { ref: mine.ref, status: mine.status, quantity: count(mine.quantity) || 1, on: /^\d{4}-\d{2}-\d{2}$/.test(str(mine.purchased_on, 10)) ? mine.purchased_on : '', ordered: count(mine.ordered) || 0 } : null
        } : null,
        q: Math.min(QTY_MAX, Math.max(1, parseInt(it.quantity, 10) || 1)),
        note: '', chosen: it.variant_chosen !== false, product: prod, saved: null,
        snapshot: { title: str(snap.title, 300), variant: str(snap.variant_title, 200), image: safeImg(snap.image), price: typeof snap.price === 'number' ? snap.price : null }
      };
    }
    function showShared() {
      var my = ++gen;
      loading();
      if (shared.token || shared.invite) {
        /* Exactly one of {token} (a link) or {invite} (an invitation, port 3). */
        var ex = shared.invite ? { invite: shared.invite } : { token: shared.token };
        postShared('/shared/exchange', ex).then(function (r) {
          if (my !== gen) return;
          var d = r.data;
          if (r.status === 200 && d && TOKEN_RE.test(str(d.session, 64)) && d.list && REF_RE.test(str(d.list.ref, 64))) {
            storeSession(d.list.ref, d.session, d.expires_at);
            shared = { token: '', invite: '', ref: d.list.ref };
            replaceUrl(d.list.ref);
            listShared(my);
            return;
          }
          replaceUrl('');   // the secret leaves the address bar in any case; it stays in memory so «Prøv igjen» can send it again
          if (r.status === 404) dead(); else sharedDown();
        });
        return;
      }
      listShared(my);
    }
    function listShared(my) {
      var ses = readSession(shared.ref);
      if (!ses) { dead(); return; }
      postShared('/shared/list', { session: ses }).then(function (r) {
        if (my !== gen) return;
        var d = r.data;
        if (r.status === 200 && d && Array.isArray(d.items)) {
          /* Port 3: a gift list (list.kind 'gift') shows the owner's message, «Fra …» and the claim buttons. */
          giftView = d.list && d.list.kind === 'gift' ? (giftOf(d.list.gift) || giftOf({})) : null;
          orderLink = !!(giftView && d.list.order_link === true);   // missing or false (an older portal): the cart works as before
          /* The owner's own list (signed in, the ref is one of her or his lists): shown as givers see it, but without any activity and
             without claim buttons, so a surprise stays a surprise (§13 B1). */
          ownView = !!(giftView && signedIn && S.lists && listByRef(shared.ref));
          sharedSession = ses;
          setHeading(d.list && str(d.list.name, 80));
          lines = d.items.slice(0, GUEST_MAX).map(sharedLine).filter(Boolean);
          draw();
          if (focusClaim) {
            var fb = root.querySelector('[data-gift-ref="' + focusClaim + '"]');
            focusClaim = '';
            if (fb) fb.focus({ preventScroll: true });
          }
          return;
        }
        if (r.status === 404) { dropSession(shared.ref); dead(); return; }
        sharedDown();
      });
    }

    /* Variant as text only (a shared list): the owner chooses it. */
    function variantText(line) {
      var wrap = el('div', { class: 'pg-wl-variant' });
      var vt = line.product.variant;
      if (line.chosen && vt && vt !== 'Default Title') wrap.appendChild(el('p', { class: 'pg-wl-item__variant' }, vt));
      return wrap;
    }

    /* ── Ønskestua (fase 1, Knut 2026-10-11; contract stua-kontrakt.md, v4.1): a list the owner shares with invited, signed-in members.
       Members suggest items with a note, comment and give a thumbs up; the owner marks «Valgt», locks the list and removes suggestions,
       comments and members. Answers from the stua endpoints never turn the wishlist off (stuaGet / write noJudge); everything members write
       is plain text (textContent, no links). ── */
    var stuaRef = stueParam();      // ?stue=<ref>: a member's Ønskestue (the owner's own opens as its tab)
    var stuaData = null;            // the Ønskestue shown
    var inStua = false;             // the page shows an Ønskestue (showSlots hides the list-only blocks)
    var stuaSort = 'votes', stuaChosen = false, stuaMine = false;
    var stuaOpen = {};              // item ref -> its comment thread is open
    var stuaPending = null;         // { ref, fn }: an action to run once that Gaveplan is drawn (the plans button, J)
    var stuaV42 = false;            // some plan answer showed the portal has v4.2 (phase 2 items in the J menu)
    var stuaRefetchTimer = null;
    function stueParam() { var q = ''; try { q = new URLSearchParams(window.location.search).get('stue') || ''; } catch (e) { q = ''; } return REF_RE.test(q) ? q : ''; }
    function setStueUrl(ref) {
      try {
        var u = new URL(window.location.href);
        if (ref) u.searchParams.set('stue', ref); else u.searchParams.delete('stue');
        window.history.replaceState(window.history.state, '', u.pathname + u.search);
      } catch (e) { /* old browser */ }
    }
    function stuaGet(path) { return request(path, { method: 'GET' }, READ_MS); }
    function stuaPost(path, body) { return write(path, body || {}, { noJudge: true }); }
    function errOf(r) { return r.data && typeof r.data.error === 'string' ? r.data.error : ''; }
    /* An owner's own Ønskestue opens as its tab; a member's through ?stue=<ref>. */
    function openStua(ref) {
      if (S.lists && listByRef(ref)) { stuaRef = ''; setStueUrl(''); setCurrent(ref); }
      else { stuaRef = ref; setStueUrl(ref); }
      focusTab = true;
      refresh();
    }

    /* A small dialog (the .rw chrome): returns { body, msg, close }. msg(text, kind) writes inside the dialog (the page notice is inert behind
       a modal). onClose runs after it has closed. */
    function dlg(titleText, onClose) {
      if (typeof HTMLDialogElement === 'undefined' || !document.body) return null;
      var d = el('dialog', { class: 'rw wl-stua-dlg', 'aria-labelledby': 'wl-stua-dlg-title' });
      var box = el('div', { class: 'rw__box' });
      var head = el('div', { class: 'rw__head' });
      head.appendChild(el('h2', { id: 'wl-stua-dlg-title', class: 'rw__title' }, titleText));
      var x = el('button', { type: 'button', class: 'rw__close', 'aria-label': t('close', 'Lukk') }, '×');
      head.appendChild(x);
      var live2 = el('div', { class: 'wl-invites__live', role: 'status', 'aria-live': 'polite' });
      var body = el('div', { class: 'rw__body' });
      box.appendChild(head); box.appendChild(live2); box.appendChild(body); d.appendChild(box);
      var opener = document.activeElement, closed = false;
      function close() {
        if (closed) return;
        closed = true;
        if (d.open) d.close();
        document.documentElement.classList.remove('pk-lock');
        if (d.parentNode) d.parentNode.removeChild(d);
        if (onClose) onClose(opener);
        else if (opener && opener.focus && document.contains(opener)) opener.focus({ preventScroll: true });
      }
      x.addEventListener('click', close);
      d.addEventListener('close', close);
      document.body.appendChild(d);
      d.showModal();
      document.documentElement.classList.add('pk-lock');
      return {
        body: body, close: close,
        msg: function (text, kind) { live2.textContent = ''; if (text) live2.appendChild(el('p', { class: 'rw__msg rw__msg--' + (kind || 'info'), role: kind === 'error' ? 'alert' : null }, text)); }
      };
    }
    function fieldOf(label, input, help) {
      var w = el('div', { class: 'rw__field' });
      w.appendChild(el('label', { class: 'rw__label', for: input.id }, label));
      w.appendChild(input);
      if (help) w.appendChild(el('p', { class: 'rw__help' }, help));
      return w;
    }
    /* «Ja, …» / «Avbryt» next to a button instead of a dialog; done() puts the button back. */
    function confirmInline(btn, text, yesLabel, onYes) {
      var box = el('span', { class: 'pg-wl-stua__confirm', role: 'group' });
      var pid = 'wl-cf-' + Math.random().toString(36).slice(2, 9);
      box.appendChild(el('span', { id: pid, class: 'pg-wl-stua__ctext' }, text));
      var yes = el('button', { type: 'button', class: 'pg-wl__btn pg-wl-stua__yes', 'aria-describedby': pid }, yesLabel);
      var no = el('button', { type: 'button', class: 'pg-wl__link' }, t('cancel', 'Avbryt'));
      box.appendChild(yes); box.appendChild(no);
      btn.hidden = true;
      btn.parentNode.insertBefore(box, btn.nextSibling);
      function done() { if (box.parentNode) box.parentNode.removeChild(box); btn.hidden = false; if (document.contains(btn)) btn.focus({ preventScroll: true }); }
      no.addEventListener('click', done);
      yes.addEventListener('click', function () { yes.disabled = true; onYes(function () { yes.disabled = false; done(); }); });
      yes.focus({ preventScroll: true });
    }
    /* «12.10.2026 kl. 14.05» in the browser's time. */
    function timeNo(v) {
      var ms = Date.parse(str(v, 40));
      if (!isFinite(ms)) return '';
      var d = new Date(ms);
      function p2(n) { return (n < 10 ? '0' : '') + n; }
      return p2(d.getDate()) + '.' + p2(d.getMonth() + 1) + '.' + d.getFullYear() + ' ' + t('s_at', 'kl.') + ' ' + p2(d.getHours()) + '.' + p2(d.getMinutes());
    }

    /* ── Join: #s=<invite> waits in sessionStorage (also through the sign-in), then a visible name and POST stua/join. ── */
    function joinView() {
      clear();
      inStua = true;   // no list-only blocks (share, notes, gift box) under the join box
      var inv = stuaInvite();
      var box = el('div', { class: 'pg-wl-stua-join' });
      if (owl) box.appendChild(el('img', { class: 'pg-wl-stua-join__owl', src: owl, alt: '', width: '72', height: '72' }));
      var tx = el('div', { class: 'pg-wl-stua-join__text' });
      tx.appendChild(el('h2', { class: 'pg-wl-stua-join__title' }, t('s_join_title', 'Du er invitert til en gaveplan')));
      box.appendChild(tx);
      root.appendChild(box);
      function row() { var p = el('p', { class: 'pg-wl-stua-join__actions' }); tx.appendChild(p); return p; }
      function later() {
        var c = el('button', { type: 'button', class: 'pg-wl__link' }, t('s_join_later', 'Ikke nå'));
        c.addEventListener('click', function () { dropInvite(); refresh(); });
        return c;
      }
      if (!signedIn) {
        tx.appendChild(el('p', null, t('s_join_login_text', 'Logg inn for å bli med. Invitasjonen venter til du er logget inn.')));
        var r1 = row();
        r1.appendChild(el('a', { href: loginHref(), class: 'pg-wl__btn' }, t('s_join_login', 'Logg inn for å bli med')));
        r1.appendChild(later());
        showSlots(true);
        return;
      }
      if (!ready || !S.stuaOn) {
        tx.appendChild(el('p', null, t('s_unavailable', 'Gaveplanen er ikke tilgjengelig akkurat nå.')));
        row().appendChild(later());
        showSlots(true);
        return;
      }
      tx.appendChild(el('p', null, t('s_join_text', 'Velg navnet de andre ser når du foreslår varer og skriver kommentarer. E-postadressen din vises aldri.')));
      var fid = 'wl-stua-join-name';
      tx.appendChild(el('label', { for: fid, class: 'rw__label' }, t('s_display_name', 'Visningsnavn')));
      var input = el('input', { id: fid, type: 'text', maxlength: '40', class: 'rw__input pg-wl-stua__name', autocomplete: 'given-name' });
      tx.appendChild(input);
      var msg = el('p', { class: 'rw__msg rw__msg--error pg-wl-stua-join__msg', role: 'alert' });
      msg.hidden = true;
      tx.appendChild(msg);
      /* v4.3: «Send meg daglig sammendrag» is never ticked from the start (Knut 2026-10-12: opt-in). */
      var dBox = el('input', { type: 'checkbox', id: 'wl-stua-join-digest' });
      if (S.stuaDigest) {
        var dLab = el('label', { class: 'pg-wl-stua__check' });
        dLab.appendChild(dBox);
        dLab.appendChild(el('span', null, t('s_join_digest', 'Send meg daglig sammendrag på e-post med nye forslag og kommentarer')));
        tx.appendChild(dLab);
      }
      var go = el('button', { type: 'button', class: 'pg-wl__btn' }, t('s_join', 'Bli med'));
      var r2 = row(); r2.appendChild(go); r2.appendChild(later());
      function fail(text, spent) { msg.textContent = text; msg.hidden = false; if (spent) { dropInvite(); go.hidden = true; input.disabled = true; } }
      input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); go.click(); } });
      go.addEventListener('click', function () {
        var name = input.value.replace(/\s+/g, ' ').trim().slice(0, 40);
        if (!name) { fail(t('s_name_required', 'Skriv et visningsnavn (1–40 tegn).')); input.focus(); return; }
        go.disabled = true;
        var body = { invite: inv, display_name: name };
        if (dBox.checked) body.notify_digest = true;
        var digestNote = '';
        stuaPost('/stua/join', body).then(function (r) {
          /* The digest could not be switched on (no address, or the part is off): join without it and say so afterwards. */
          var fields = r.status === 422 && r.data && r.data.fields ? r.data.fields : null;
          if (body.notify_digest && ((r.status === 409 && errOf(r) === 'email_unavailable') || (fields && fields.notify_digest))) {
            digestNote = r.status === 409 ? stuaFail(r) : t('s_digest_unavailable', 'Daglig sammendrag er ikke tilgjengelig ennå.');
            delete body.notify_digest;
            return stuaPost('/stua/join', body);
          }
          return r;
        }).then(function (r) {
          go.disabled = false;
          var d = r.data, err = errOf(r);
          if (r.status === 200 && d && d.list && REF_RE.test(str(d.list.ref, 64))) {
            dropInvite();
            var ref = d.list.ref, nm = str(d.list.name, 80) || t('s_name', 'Gaveplan');
            loadState().then(function () { stuaButtons(); openStua(ref); say(t('s_joined', 'Du er med i «__L__».').replace('__L__', nm) + (digestNote ? ' ' + digestNote : '')); });
            return;
          }
          if (err === 'invite_used') { fail(t('s_invite_used', 'Denne invitasjonen er allerede brukt av en annen konto. Be eieren om en ny.'), true); return; }
          if (err === 'own_list') { fail(t('s_own_list', 'Dette er din egen gaveplan.'), true); return; }
          if (r.status === 404) { fail(t('s_invite_dead', 'Invitasjonen virker ikke lenger. Be eieren om en ny.'), true); return; }
          if (r.status === 422) { fail(t('s_name_required', 'Skriv et visningsnavn (1–40 tegn).')); input.focus(); return; }
          fail(stuaFail(r));
        });
      });
      showSlots(true);
      input.focus({ preventScroll: true });
    }
    /* ?stue=<ref> while signed out. */
    function stuaLogin() {
      clear();
      inStua = true;
      var box = el('div', { class: 'pg-wl-stua-join' });
      var tx = el('div', { class: 'pg-wl-stua-join__text' });
      tx.appendChild(el('h2', { class: 'pg-wl-stua-join__title' }, t('s_name', 'Gaveplan')));
      tx.appendChild(el('p', null, t('s_login_text', 'Logg inn for å se gaveplanen.')));
      var p = el('p', { class: 'pg-wl-stua-join__actions' });
      p.appendChild(el('a', { href: loginHref(), class: 'pg-wl__btn' }, t('login', 'Logg inn')));
      tx.appendChild(p);
      box.appendChild(tx);
      root.appendChild(box);
      showSlots(true);
    }

    /* ── The Ønskestue page ── */
    var STUA_PAGE = 50;
    var STUA_SORT = { votes: 'votes', new: 'new', price: 'price_asc', price_desc: 'price_desc' };
    /* GET stua/{ref} with sort, filter and a page (contract v4.2). Only one filter goes to the server; with both chips on, «chosen» goes there
       and «mine» is applied in the browser. */
    function stuaQuery(cursor) {
      var q = '?sort=' + STUA_SORT[stuaSort] + '&limit=' + STUA_PAGE;
      if (stuaChosen) q += '&filter=chosen'; else if (stuaMine) q += '&filter=mine';
      if (cursor) q += '&cursor=' + encodeURIComponent(cursor);
      return q;
    }
    function showStua(ref) {
      var my = ++gen;
      if (!root.querySelector('.pg-wl-stua') || !stuaData || stuaData.ref !== ref) loading();
      stuaGet('/stua/' + encodeURIComponent(ref) + stuaQuery('')).then(function (r) {
        /* A portal without v4.2 may refuse the parameters: ask again without them (the browser sorts then). */
        if (r.status === 422) return stuaGet('/stua/' + encodeURIComponent(ref));
        return r;
      }).then(function (r) {
        if (my !== gen) return;
        var d = r.data;
        if (r.status === 200 && d && d.list && Array.isArray(d.items)) {
          var l = d.list, me = d.me && d.me.member && typeof d.me.member === 'object' ? d.me.member : {};
          var pending = stuaPending && stuaPending.ref === ref ? stuaPending.fn : (stuaData && stuaData.ref === ref ? stuaData.pending : null);
          stuaPending = null;
          if (Object.prototype.hasOwnProperty.call(d, 'next_cursor')) stuaV42 = true;
          stuaData = {
            ref: ref, name: str(l.name, 80) || t('s_name', 'Gaveplan'), locked: l.locked === true, occasion: str(l.occasion, 60),
            date: /^\d{4}-\d{2}-\d{2}$/.test(str(l.event_date, 10)) ? l.event_date : '', message: str(l.message, 500), from: str(l.from_name, 60),
            me: {
              name: str(me.display_name, 40), owner: me.role === 'owner',
              /* v4.3: present only while the part is on (notify_joins only for the owner); undefined = no switch. */
              digest: typeof me.notify_digest === 'boolean' ? me.notify_digest : undefined,
              joins: typeof me.notify_joins === 'boolean' ? me.notify_joins : undefined
            },
            /* v4.3 gating: each part shows only when it is true. */
            feat: {
              digest: !!(d.features && d.features.digest === true),
              joinNotice: !!(d.features && d.features.join_notice === true),
              transfer: !!(d.features && d.features.transfer === true)
            },
            members: count0(d.members),
            items: d.items.slice(0, GUEST_MAX).map(stuaItemOf).filter(Boolean),
            /* v4.2: the answer has next_cursor (string or null) when a limit was sent; then the server sorts, filters and pages, and the
               phase 2 controls show (copy, edit, rename, restore, duplicate). */
            v42: Object.prototype.hasOwnProperty.call(d, 'next_cursor'),
            cursor: typeof d.next_cursor === 'string' && d.next_cursor.length < 2048 ? d.next_cursor : ''
          };
          drawStua();
          if (typeof pending === 'function') pending();
          return;
        }
        stuaPending = null;
        if (r.status === 401) { stuaLogin(); return; }
        stuaData = null;
        if (r.status === 404) {
          if (stuaRef === ref) { stuaRef = ''; setStueUrl(''); }
          status(t('s_gone', 'Du har ikke tilgang til denne gaveplanen lenger.'));
          loadState().then(stuaButtons);
        } else status(stuaFail(r), true);
        /* The owner keeps the tabs above the message, so the other lists stay in reach. */
        if (S.lists) root.insertBefore(listBar(), root.firstChild);
      });
    }
    function stuaItemOf(it) {
      if (!it || typeof it !== 'object' || !REF_RE.test(str(it.ref, 64))) return null;
      var prod = productOf(it.product);
      if (!prod) return null;
      var by = it.added_by && typeof it.added_by === 'object' ? it.added_by : null;
      return {
        ref: it.ref, product: prod, note: str(it.note, 1000), added: Date.parse(str(it.added_at, 40)) || 0, by: whoName(by),
        votes: count0(it.votes), voted: it.voted === true, chosen: it.chosen === true, comments: count0(it.comments), mine: it.mine === true,
        voters: votersOf(it.voters)
      };
    }
    /* v4.4 (proposed): who gave a thumbs up, oldest first; undefined while the portal does not send it (then no tooltip). */
    function votersOf(v) {
      if (!Array.isArray(v)) return undefined;
      return v.slice(0, 30).filter(function (o) { return o && typeof o === 'object'; }).map(function (o) {
        return { name: str(o.display_name, 40), former: o.former === true, me: o.me === true };
      });
    }
    /* «Tommel opp fra deg, Kari, Ola og 2 til»: you first, at most 8 names, former members counted together. */
    function votersText(it) {
      var vs = it.voters;
      if (!vs || !vs.length || !it.votes) return '';
      var me = false, names = [], former = 0;
      vs.forEach(function (v) { if (v.me) me = true; else if (v.former || !v.name) former++; else names.push(v.name); });
      /* voters holds at most the 30 oldest; votes beyond that are counted into «og N til» (portal 2026-10-13). */
      var parts = names.slice(0, 8), rest = names.length - parts.length + Math.max(0, it.votes - vs.length);
      if (me) parts.unshift(t('s_voters_you', 'deg'));
      if (former) parts.push(tn('s_voters_former', former, '__N__ tidligere deltakere'));
      if (rest > 0) parts.push(t('s_voters_more', '__N__ til').replace('__N__', String(rest)));
      if (!parts.length) return '';
      var list = parts.length === 1 ? parts[0] : parts.slice(0, -1).join(', ') + t('s_voters_and', ' og ') + parts[parts.length - 1];
      return t('s_voters', 'Tommel opp fra __L__').replace('__L__', list);
    }
    /* The tooltip under the thumb: shown on mouse hover and keyboard focus (CSS), Esc hides it, screen readers get it as a description. */
    function setVoteTip(tip, vote, it) {
      var txt = votersText(it);
      tip.textContent = txt;
      tip.hidden = !txt;
      var line = tip.closest('[data-stua-item]');
      line = line && line.querySelector('[data-part="voters"]');
      if (line) { line.textContent = txt; line.hidden = !txt; }
      if (txt) vote.setAttribute('aria-describedby', tip.id); else vote.removeAttribute('aria-describedby');
    }
    function drawStua() {
      if (dead || !stuaData) return;
      clear();
      inStua = true;
      var sd = stuaData, owner = sd.me.owner, locked = sd.locked;
      if (S.lists) root.appendChild(listBar());
      var wrap = el('div', { class: 'pg-wl-stua' + (locked ? ' is-locked' : '') });
      /* Head: name, occasion and date, the message, «Fra», the members; the lock note. */
      var head = el('div', { class: 'pg-wl-stua__head' });
      head.appendChild(el('p', { class: 'pg-wl__kicker' }, t('s_name', 'Gaveplan')));
      head.appendChild(el('h2', { class: 'pg-wl-stua__title' }, sd.name));
      var when = [sd.occasion, dateNo(sd.date)].filter(Boolean).join(' · ');
      if (when) head.appendChild(el('p', { class: 'pg-wl-gift__when' }, when));
      if (sd.message) head.appendChild(el('blockquote', { class: 'pg-wl-gift__quote' }, sd.message));
      if (sd.from) head.appendChild(el('p', { class: 'pg-wl-gift__from' }, t('g_from', 'Fra __N__').replace('__N__', sd.from)));
      var meta = el('p', { class: 'pg-wl-stua__meta' });
      meta.appendChild(el('span', null, tn('s_members', sd.members, '__N__ deltakere')));
      if (sd.me.name) meta.appendChild(el('span', null, t('s_you_are', 'Du heter «__N__» her').replace('__N__', sd.me.name) + (owner ? ' · ' + t('s_owner', 'Eier') : '')));
      head.appendChild(meta);
      if (locked) head.appendChild(el('p', { class: 'pg-wl-stua__lock' }, t('s_locked_banner', 'Gaveplanen er låst av eieren. Du kan lese, men ikke endre.')));
      var acts = el('div', { class: 'pg-wl-stua__actions' });
      function act(label, fn, cls) { var b = el('button', { type: 'button', class: cls || 'pg-wl__btn pg-wl__btn--alt pg-wl-stua__act' }, label); b.addEventListener('click', function () { fn(b); }); acts.appendChild(b); return b; }
      var ownList = owner && S.lists ? listByRef(sd.ref) : null;
      if (owner) {
        if (ownList) act(t('s_invite', 'Inviter'), function () { invitesDialog(ownList); });   // allowed while locked (Tillegg 1 §5)
        act(t('s_members_btn', 'Deltakere'), function () { membersDialog(); });
        act(locked ? t('s_unlock', 'Lås opp') : t('s_lock', 'Lås'), function (b) {
          b.disabled = true;
          stuaPost('/stua/' + encodeURIComponent(sd.ref) + (locked ? '/unlock' : '/lock')).then(function (r) {
            b.disabled = false;
            if (r.status === 200) {
              sd.locked = !!(r.data && r.data.list && r.data.list.locked === true);
              drawStua();
              say(sd.locked ? t('s_locked_done', 'Gaveplanen er låst.') : t('s_unlocked_done', 'Gaveplanen er låst opp.'));
              loadState().then(stuaButtons);
              return;
            }
            say(stuaFail(r));
          });
        });
        if (ownList) act(t('s_settings', 'Innstillinger'), function () { stuaDialog(ownList, 'edit'); });
        if (sd.v42) act(t('s_removed_btn', 'Nylig fjernet'), function () { removedDialog(); }).setAttribute('data-act', 'removed');
      } else {
        act(t('s_members_btn', 'Deltakere'), function () { membersDialog(); });
        var lv = act(t('s_leave', 'Forlat gaveplanen'), function () {
          confirmInline(lv, t('s_leave_confirm', 'Du mister tilgangen. Forslagene og kommentarene dine blir stående som «Tidligere deltaker».'), t('s_leave_yes', 'Ja, forlat'), function (done) {
            stuaPost('/stua/' + encodeURIComponent(sd.ref) + '/leave').then(function (r) {
              if (r.status === 200) {
                var nm = sd.name;
                stuaRef = ''; setStueUrl(''); stuaData = null;
                loadState().then(function () { stuaButtons(); refresh(); say(t('s_left', 'Du har forlatt «__L__».').replace('__L__', nm)); });
                return;
              }
              done(); say(stuaFail(r));
            });
          });
        }, 'pg-wl__link pg-wl-stua__leave');
      }
      /* Phase 2 for everyone: duplicate to an own wishlist, a new visible name (also while locked). */
      if (sd.v42) {
        act(t('s_duplicate', 'Dupliser'), function () { duplicateDialog(); });
        var rn = act(t('s_rename_me', 'Bytt visningsnavn'), function () { renameMe(rn); }, 'pg-wl__link pg-wl-stua__renameme');
      }
      head.appendChild(acts);
      var notes = notifySwitches();
      if (notes) head.appendChild(notes);
      wrap.appendChild(head);
      /* Add: search the shop (existing POST stua/{ref}/items) and, with v4.2, copy from own lists. */
      if (!locked) wrap.appendChild(addPanel());
      /* Sort and filter (in the browser). */
      var tools = el('div', { class: 'pg-wl-stua__tools' });
      var sid = 'wl-stua-sort';
      var sw = el('div', { class: 'pg-wl-stua__sortwrap' });
      sw.appendChild(el('label', { for: sid, class: 'pg-wl-stua__label' }, t('s_sort', 'Sorter')));
      var sel = el('select', { id: sid, class: 'pg-wl-variant__select pg-wl-stua__sort' });
      [['votes', t('s_sort_votes', 'Flest tomler')], ['new', t('s_sort_new', 'Nyeste')], ['price', t('s_sort_price', 'Pris, lav til høy')], ['price_desc', t('s_sort_price_desc', 'Pris, høy til lav')]].forEach(function (o) {
        sel.appendChild(el('option', { value: o[0], selected: o[0] === stuaSort ? true : null }, o[1]));
      });
      sel.addEventListener('change', function () {
        stuaSort = sel.value;
        if (!sd.v42) { drawStuaItems(); return; }
        window.clearTimeout(stuaRefetchTimer);
        stuaRefetchTimer = window.setTimeout(function () { refetchKeep(sid); }, 350);
      });
      sw.appendChild(sel);
      tools.appendChild(sw);
      var chips = el('div', { class: 'pg-wl-stua__chips', role: 'group', 'aria-label': t('s_filter', 'Vis') });
      function chip(label, on, set) {
        var cid = 'wl-stua-chip-' + chips.children.length;
        var c = el('button', { type: 'button', id: cid, class: 'pg-wl-stua__chip', 'aria-pressed': on ? 'true' : 'false' }, label);
        c.addEventListener('click', function () { var v = c.getAttribute('aria-pressed') !== 'true'; c.setAttribute('aria-pressed', v ? 'true' : 'false'); set(v); if (sd.v42) refetchKeep(cid); else drawStuaItems(); });
        chips.appendChild(c);
      }
      chip(t('s_filter_chosen', 'Valgte'), stuaChosen, function (v) { stuaChosen = v; });
      chip(t('s_filter_mine', 'Mine forslag'), stuaMine, function (v) { stuaMine = v; });
      tools.appendChild(chips);
      wrap.appendChild(tools);
      sd.ul = el('ul', { class: 'pg-wl-stua__list', role: 'list' });
      wrap.appendChild(sd.ul);
      sd.empty = el('p', { class: 'pg-wl-stua__empty' });
      wrap.appendChild(sd.empty);
      /* v4.2 pages: «Vis flere» while next_cursor is set. */
      sd.more = el('button', { type: 'button', class: 'pg-wl__btn pg-wl__btn--alt pg-wl-stua__more' }, t('s_more', 'Vis flere'));
      sd.more.hidden = !sd.cursor;
      sd.more.addEventListener('click', function () { moreStua(sd.more); });
      wrap.appendChild(sd.more);
      root.appendChild(wrap);
      drawStuaItems();
      showSlots(true);
      tabFocus();
    }
    function drawStuaItems() {
      var sd = stuaData;
      if (!sd || !sd.ul) return;
      /* Keep focus on the same control of the same item across a redraw. */
      var a = document.activeElement, keep = null;
      if (a && sd.ul.contains(a)) {
        var holder = a.closest('[data-stua-item]');
        if (holder) keep = { ref: holder.getAttribute('data-stua-item'), f: a.getAttribute('data-focus') };
      }
      sd.ul.textContent = '';
      var list = sd.items.filter(function (it) { return (!stuaChosen || it.chosen) && (!stuaMine || it.mine); });
      function price(it) { return it.product.ok && it.product.price !== null ? it.product.price : null; }
      if (!sd.v42) list.sort(function (x, y) {
        if (stuaSort === 'new') return y.added - x.added;
        if (stuaSort === 'price' || stuaSort === 'price_desc') {
          var px = price(x), py = price(y);
          if (px === null && py === null) return 0;
          if (px === null) return 1;
          if (py === null) return -1;
          return stuaSort === 'price' ? px - py : py - px;
        }
        return (y.votes - x.votes) || (y.added - x.added);
      });
      list.forEach(function (it) { sd.ul.appendChild(stuaItemEl(it)); });
      sd.empty.hidden = !!list.length;
      sd.empty.textContent = sd.items.length
        ? t('s_none_filtered', 'Ingen forslag passer med det du har valgt å vise.')
        : t('s_empty', 'Ingen forslag ennå. Gå til et produkt og trykk «Legg til i gaveplanen».');
      var known = null;
      S.stua.forEach(function (x) { if (x.ref === sd.ref) known = x.count; });
      var total = sd.v42 && (stuaChosen || stuaMine || sd.cursor) && known !== null ? known : sd.items.length;
      if (countEl) { countEl.textContent = tn('count', total, ''); countEl.hidden = false; }
      if (sd.more) sd.more.hidden = !sd.cursor;
      if (keep) {
        var li = sd.ul.querySelector('[data-stua-item="' + keep.ref + '"]');
        var f = li && keep.f ? li.querySelector('[data-focus="' + keep.f + '"]') : null;
        if (f && !f.disabled) f.focus({ preventScroll: true });
        else if (li) li.focus({ preventScroll: true });
      }
    }
    function stuaItemEl(it) {
      var sd = stuaData, owner = sd.me.owner, locked = sd.locked;
      var prod = it.product;
      var li = el('li', { class: 'pg-wl-stua__item' + (it.chosen ? ' is-chosen' : ''), 'data-stua-item': it.ref, tabindex: '-1' });
      var href = prod.ok ? prod.url : '';
      var name = prod.ok && prod.short ? prod.short : prod.ok && prod.title ? shortTitle(prod.title, prod.vendor) : t('unavailable', 'Ikke tilgjengelig nå');
      var media = el(href ? 'a' : 'div', { class: 'pg-wl-item__media', href: href || null, tabindex: href ? '-1' : null, 'aria-hidden': 'true' });
      if (prod.ok && prod.image) media.appendChild(el('img', { src: prod.image, alt: '', loading: 'lazy', width: '224', height: '224' }));
      li.appendChild(media);
      var info = el('div', { class: 'pg-wl-stua__info' });
      if (prod.ok && prod.vendor) info.appendChild(el('p', { class: 'pg-wl-item__vendor' }, prod.vendor));
      var h = el('h3', { class: 'pg-wl-item__title' });
      if (href) h.appendChild(el('a', { href: href }, name)); else h.textContent = name;
      info.appendChild(h);
      if (prod.ok && prod.variant && prod.variant !== 'Default Title') info.appendChild(el('p', { class: 'pg-wl-item__variant' }, prod.variant));
      var line = el('p', { class: 'pg-wl-stua__line' });
      if (prod.ok && prod.price !== null) line.appendChild(el('b', { class: 'pg-wl-item__now' + (prod.compare ? ' is-sale' : '') }, money(prod.price)));
      if (prod.ok && prod.availability) line.appendChild(el('span', { class: 'pg-wl-stua__stock' }, t(prod.availability)));
      if (!prod.ok) line.appendChild(el('span', { class: 'pg-wl-item__gone' }, t('unavailable', 'Ikke tilgjengelig nå')));
      var chosenBadge = el('span', { class: 'pg-wl-badge pg-wl-badge--bought', 'data-part': 'chosen' }, t('s_chosen', 'Valgt'));
      chosenBadge.hidden = !it.chosen;
      line.appendChild(chosenBadge);
      info.appendChild(line);
      info.appendChild(el('p', { class: 'pg-wl-stua__by' }, it.mine ? t('s_by_you', 'Foreslått av deg') : t('s_by', 'Foreslått av __N__').replace('__N__', it.by)));
      var noteP = el('p', { class: 'pg-wl-stua__note', 'data-part': 'note' }, it.note);
      noteP.hidden = !it.note;
      info.appendChild(noteP);
      /* Touch screens have no hover: the same names as a small line under the suggestion (Knut 2026-10-13, A). CSS shows it only
         where hover is missing; aria-hidden, since the thumb already has the names as its description. */
      var vline = el('p', { class: 'pg-wl-stua__voters', 'data-part': 'voters', 'aria-hidden': 'true' });
      info.appendChild(vline);
      li.appendChild(info);
      var acts = el('div', { class: 'pg-wl-stua__itemacts' });
      var vote = el('button', {
        type: 'button', class: 'pg-wl-stua__vote', 'aria-pressed': it.voted ? 'true' : 'false', 'data-focus': 'vote', disabled: locked ? true : null,
        'aria-label': t('s_vote_label', 'Tommel opp for __T__ (__N__)').replace('__T__', name).replace('__N__', String(it.votes))
      });
      vote.appendChild(el('span', { class: 'pg-wl-stua__thumb', 'aria-hidden': 'true' }, '👍'));
      vote.appendChild(el('span', { 'aria-hidden': 'true', 'data-part': 'votes' }, String(it.votes)));
      vote.addEventListener('click', function () { voteItem(it, vote); });
      var vwrap = el('span', { class: 'pg-wl-stua__votewrap' });
      var vtip = el('span', { id: 'wl-stua-vt-' + it.ref, class: 'pg-wl-stua__vtip', role: 'tooltip', 'data-part': 'vtip' });
      vwrap.appendChild(vote); vwrap.appendChild(vtip);
      setVoteTip(vtip, vote, it);
      vline.textContent = vtip.textContent; vline.hidden = vtip.hidden;   // the row is not in the page yet, so set the line here
      vote.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !vtip.hidden) vwrap.classList.add('is-tipoff'); });
      vote.addEventListener('blur', function () { vwrap.classList.remove('is-tipoff'); });
      vwrap.addEventListener('mouseleave', function () { vwrap.classList.remove('is-tipoff'); });
      acts.appendChild(vwrap);
      var tid = 'wl-stua-th-' + it.ref;
      var ct = el('button', { type: 'button', class: 'pg-wl-stua__ctoggle', 'aria-expanded': stuaOpen[it.ref] ? 'true' : 'false', 'aria-controls': tid, 'data-focus': 'comments' }, tn('s_comments', it.comments, 'Kommentarer (__N__)'));
      acts.appendChild(ct);
      if (owner) {
        var ch = el('button', { type: 'button', class: 'pg-wl__link', 'data-focus': 'choose' }, it.chosen ? t('s_unchoose', 'Fjern «Valgt»') : t('s_choose', 'Merk som valgt'));
        ch.addEventListener('click', function () { chooseItem(it, ch); });
        acts.appendChild(ch);
      }
      /* The one who suggested it can write or change the note (POST stua/items/{ref} {note}). */
      if (it.mine && !locked) {
        var ne = el('button', { type: 'button', class: 'pg-wl__link', 'data-focus': 'note', 'aria-expanded': 'false' }, it.note ? t('s_note_edit', 'Endre notat') : t('s_note_add', 'Skriv notat'));
        ne.addEventListener('click', function () { noteForm(it, li, ne); });
        acts.appendChild(ne);
      }
      if ((owner || it.mine) && !locked) {
        var rm = el('button', { type: 'button', class: 'pg-wl__link pg-wl-stua__rm', 'data-focus': 'remove' }, t('s_remove', 'Fjern'));
        rm.addEventListener('click', function () {
          confirmInline(rm, t('s_remove_confirm', 'Fjerne «__T__»?').replace('__T__', name), t('s_remove_yes', 'Ja, fjern'), function (done) { removeItem(it, done); });
        });
        acts.appendChild(rm);
      }
      li.appendChild(acts);
      var th = el('div', { id: tid, class: 'pg-wl-stua__thread' });
      th.hidden = !stuaOpen[it.ref];
      li.appendChild(th);
      ct.addEventListener('click', function () {
        stuaOpen[it.ref] = !stuaOpen[it.ref];
        ct.setAttribute('aria-expanded', stuaOpen[it.ref] ? 'true' : 'false');
        th.hidden = !stuaOpen[it.ref];
        if (stuaOpen[it.ref]) loadThread(it, th);
      });
      if (stuaOpen[it.ref]) loadThread(it, th);
      return li;
    }
    /* After a refused write: the text, and the Ønskestue read again when it is locked or gone. */
    function stuaRefused(r) {
      say(stuaFail(r));
      var err = errOf(r);
      if (err === 'list_locked' || r.status === 404) refresh();
    }
    /* A busy button keeps focus (aria-busy, not disabled); a second click while busy does nothing. */
    function busy(b, on) { if (on) b.setAttribute('aria-busy', 'true'); else b.removeAttribute('aria-busy'); }
    function isBusy(b) { return b.getAttribute('aria-busy') === 'true'; }
    /* Vote and «Valgt» change only their own item in place (the order is kept until the list is sorted again), so focus and an open
       comment draft stay. */
    function patchItem(it) {
      var li = stuaData && stuaData.ul && stuaData.ul.querySelector('[data-stua-item="' + it.ref + '"]');
      if (!li) return;
      li.classList.toggle('is-chosen', it.chosen);
      var cb = li.querySelector('[data-part="chosen"]'); if (cb) cb.hidden = !it.chosen;
      var vt = li.querySelector('[data-part="votes"]'); if (vt) vt.textContent = String(it.votes);
      var vb = li.querySelector('[data-focus="vote"]');
      if (vb) {
        vb.setAttribute('aria-pressed', it.voted ? 'true' : 'false');
        var nm = li.querySelector('.pg-wl-item__title');
        vb.setAttribute('aria-label', t('s_vote_label', 'Tommel opp for __T__ (__N__)').replace('__T__', nm ? nm.textContent : '').replace('__N__', String(it.votes)));
        var vtp = li.querySelector('[data-part="vtip"]'); if (vtp) setVoteTip(vtp, vb, it);
      }
      var chb = li.querySelector('[data-focus="choose"]'); if (chb) chb.textContent = it.chosen ? t('s_unchoose', 'Fjern «Valgt»') : t('s_choose', 'Merk som valgt');
      var np = li.querySelector('[data-part="note"]'); if (np) { np.textContent = it.note; np.hidden = !it.note; }
    }
    function voteItem(it, b) {
      if (isBusy(b)) return;
      busy(b, true);
      stuaPost('/stua/items/' + encodeURIComponent(it.ref) + (it.voted ? '/unvote' : '/vote')).then(function (r) {
        busy(b, false);
        if (r.status === 200 && r.data && r.data.item) {
          it.votes = count0(r.data.item.votes); it.voted = r.data.item.voted === true;
          var vv = votersOf(r.data.item.voters);
          /* Without voters in the answer, the list is kept and only your own entry follows the vote. */
          if (vv !== undefined) it.voters = vv;
          else if (it.voters) { it.voters = it.voters.filter(function (v) { return !v.me; }); if (it.voted) it.voters.unshift({ name: '', former: false, me: true }); }
          patchItem(it);
          return;
        }
        stuaRefused(r);
      });
    }
    function chooseItem(it, b) {
      if (isBusy(b)) return;
      busy(b, true);
      stuaPost('/stua/items/' + encodeURIComponent(it.ref) + (it.chosen ? '/unchoose' : '/choose')).then(function (r) {
        busy(b, false);
        if (r.status === 200 && r.data && r.data.item) {
          it.chosen = r.data.item.chosen === true;
          patchItem(it);
          say(it.chosen ? t('s_chosen_done', 'Merket som valgt.') : t('s_unchosen_done', '«Valgt» er fjernet.'));
          return;
        }
        stuaRefused(r);
      });
    }
    /* Privacy hint under the free-text fields others read (Knut 2026-10-13): short and calm, tied to the field with aria-describedby. */
    function privacyHint(id) {
      return el('p', { id: id, class: 'pg-wl-stua__privacy' }, t('s_privacy', 'Alle i gaveplanen ser det du skriver. Ikke del sensitive opplysninger, som helse eller personnummer.'));
    }
    /* «Skriv notat» / «Endre notat» on your own suggestion: plain text, at most 1000 characters. */
    function noteForm(it, li, opener) {
      var old = li.querySelector('.pg-wl-stua__noteform');
      if (old) { old.parentNode.removeChild(old); opener.setAttribute('aria-expanded', 'false'); return; }
      opener.setAttribute('aria-expanded', 'true');
      var f = el('div', { class: 'pg-wl-stua__noteform pg-wl-stua__cform' });
      var nid = 'wl-stua-n-' + it.ref;
      f.appendChild(el('label', { for: nid, class: 'rw__label' }, t('s_note_label', 'Notat til de andre')));
      var ta = el('textarea', { id: nid, rows: '3', maxlength: '1000', class: 'rw__input pg-wl-stua__ctextarea', 'aria-describedby': nid + '-p' });
      ta.value = it.note;
      f.appendChild(ta);
      f.appendChild(privacyHint(nid + '-p'));
      var foot = el('div', { class: 'pg-wl-stua__cfoot' });
      var save = el('button', { type: 'button', class: 'pg-wl__btn pg-wl-stua__send' }, t('save', 'Lagre'));
      var cancel = el('button', { type: 'button', class: 'pg-wl__link' }, t('cancel', 'Avbryt'));
      foot.appendChild(save); foot.appendChild(cancel);
      f.appendChild(foot);
      function done() { if (f.parentNode) f.parentNode.removeChild(f); opener.setAttribute('aria-expanded', 'false'); opener.focus({ preventScroll: true }); }
      cancel.addEventListener('click', done);
      save.addEventListener('click', function () {
        if (isBusy(save)) return;
        busy(save, true);
        stuaPost('/stua/items/' + encodeURIComponent(it.ref), { note: ta.value.trim().slice(0, 1000) }).then(function (r) {
          busy(save, false);
          if (r.status === 200 && r.data && r.data.item) {
            it.note = str(r.data.item.note, 1000);
            patchItem(it);
            opener.textContent = it.note ? t('s_note_edit', 'Endre notat') : t('s_note_add', 'Skriv notat');
            say(t('s_note_saved', 'Notatet er lagret.'));
            done();
            return;
          }
          stuaRefused(r);
        });
      });
      var th = li.querySelector('.pg-wl-stua__thread');
      li.insertBefore(f, th);
      ta.focus({ preventScroll: true });
    }
    function removeItem(it, done) {
      stuaPost('/stua/items/' + encodeURIComponent(it.ref) + '/remove').then(function (r) {
        if (r.status === 200) {
          var at = stuaData.items.indexOf(it);
          if (at !== -1) stuaData.items.splice(at, 1);
          drawStuaItems();
          say(t('s_removed', 'Forslaget er fjernet.'), stuaData.v42 ? { text: t('undo', 'Angre'), action: function () { restoreItem(it.ref); } } : null);
          var s2 = document.getElementById('wl-stua-sort');
          if (s2) s2.focus({ preventScroll: true });
          return;
        }
        done();
        stuaRefused(r);
      });
    }

    /* ── Comments: plain text, oldest first; «Slett» on your own (and on all for the owner) while the Ønskestue is open. ── */
    function loadThread(it, th) {
      th.textContent = '';
      th.appendChild(el('p', { class: 'pg-wl__status' }, t('loading', 'Henter …')));
      stuaGet('/stua/items/' + encodeURIComponent(it.ref) + '/comments').then(function (r) {
        if (!th.isConnected || !stuaData) return;
        th.textContent = '';
        if (r.status !== 200 || !r.data || !Array.isArray(r.data.comments)) { th.appendChild(el('p', { class: 'pg-wl__status' }, stuaFail(r))); return; }
        var ol = el('ol', { class: 'pg-wl-stua__comments' });
        r.data.comments.slice(0, 200).forEach(function (c) { var n = commentEl(c); if (n) ol.appendChild(n); });
        if (!ol.firstChild) th.appendChild(el('p', { class: 'pg-wl-stua__nocom' }, t('s_no_comments', 'Ingen kommentarer ennå.')));
        th.appendChild(ol);
        if (!stuaData.locked) th.appendChild(commentForm(it, ol, th));
      });
    }
    function commentEl(c) {
      if (!c || typeof c !== 'object' || !REF_RE.test(str(c.ref, 64))) return null;
      var li = el('li', { class: 'pg-wl-stua__comment' + (c.deleted === true ? ' is-deleted' : ''), tabindex: '-1' });
      var hd = el('p', { class: 'pg-wl-stua__chead' });
      hd.appendChild(el('b', null, c.mine === true ? t('s_you', 'Du') : whoName(c.member)));
      var when = timeNo(c.created_at);
      if (when) hd.appendChild(el('span', null, when));
      if (c.edited === true && c.deleted !== true) hd.appendChild(el('span', { class: 'pg-wl-stua__edited', title: timeNo(c.edited_at) || null }, t('s_edited', '(redigert)')));
      li.appendChild(hd);
      if (c.deleted === true) { li.appendChild(el('p', { class: 'pg-wl-stua__cbody' }, t('s_comment_deleted', 'Kommentar slettet'))); return li; }
      li.appendChild(el('p', { class: 'pg-wl-stua__cbody' }, str(c.body, 1000)));
      if ((c.mine === true || stuaData.me.owner) && !stuaData.locked) {
        var del = el('button', { type: 'button', class: 'pg-wl__link', 'aria-label': t('s_delete_label', 'Slett kommentaren fra __N__').replace('__N__', c.mine === true ? t('s_you', 'Du') : whoName(c.member)) }, t('s_delete', 'Slett'));
        del.addEventListener('click', function () {
          del.disabled = true;
          stuaPost('/stua/comments/' + encodeURIComponent(c.ref) + '/delete').then(function (r) {
            if (r.status === 200) {
              c.deleted = true;
              var n = commentEl(c);
              if (li.parentNode && n) { li.parentNode.replaceChild(n, li); n.focus({ preventScroll: true }); }
              /* v4.2: «Angre» brings it back (POST stua/comments/{ref}/restore). */
              say(t('s_comment_deleted_done', 'Kommentaren er slettet.'), stuaData && stuaData.v42 ? { text: t('undo', 'Angre'), action: function () {
                stuaPost('/stua/comments/' + encodeURIComponent(c.ref) + '/restore').then(function (r2) {
                  if (r2.status === 200 && r2.data && r2.data.comment) {
                    var back = commentEl(r2.data.comment);
                    if (n && n.parentNode && back) { n.parentNode.replaceChild(back, n); back.focus({ preventScroll: true }); }
                    say(t('s_comment_restored', 'Kommentaren er tilbake.'));
                    return;
                  }
                  stuaRefused(r2);
                });
              } } : null);
              return;
            }
            del.disabled = false;
            stuaRefused(r);
          });
        });
        li.appendChild(del);
        if (c.mine === true && stuaData.v42) {
          var ed = el('button', { type: 'button', class: 'pg-wl__link', 'aria-expanded': 'false' }, t('s_edit', 'Endre'));
          ed.addEventListener('click', function () { editComment(c, li, ed); });
          li.appendChild(ed);
        }
      }
      return li;
    }
    function commentForm(it, ol, th) {
      var f = el('div', { class: 'pg-wl-stua__cform' });
      var id2 = 'wl-stua-c-' + it.ref, cid = id2 + '-n';
      f.appendChild(el('label', { for: id2, class: 'rw__label' }, t('s_comment_label', 'Skriv en kommentar')));
      var ta = el('textarea', { id: id2, rows: '3', maxlength: '1000', class: 'rw__input pg-wl-stua__ctextarea', 'aria-describedby': id2 + '-p ' + cid });
      f.appendChild(ta);
      f.appendChild(privacyHint(id2 + '-p'));
      var foot = el('div', { class: 'pg-wl-stua__cfoot' });
      var cnt = el('span', { id: cid, class: 'pg-wl-stua__count' }, t('s_chars', '__N__ av 1000 tegn').replace('__N__', '0'));
      var send = el('button', { type: 'button', class: 'pg-wl__btn pg-wl-stua__send' }, t('s_send', 'Send'));
      foot.appendChild(cnt); foot.appendChild(send);
      f.appendChild(foot);
      ta.addEventListener('input', function () { cnt.textContent = t('s_chars', '__N__ av 1000 tegn').replace('__N__', String(ta.value.length)); });
      send.addEventListener('click', function () {
        var body = ta.value.trim();
        if (!body) { ta.focus(); return; }
        send.disabled = true;
        stuaPost('/stua/items/' + encodeURIComponent(it.ref) + '/comments', { body: body.slice(0, 1000) }).then(function (r) {
          send.disabled = false;
          if (r.status === 200 && r.data && r.data.comment) {
            var n = commentEl(r.data.comment);
            if (n) ol.appendChild(n);
            var none = th.querySelector('.pg-wl-stua__nocom');
            if (none) none.parentNode.removeChild(none);
            ta.value = '';
            cnt.textContent = t('s_chars', '__N__ av 1000 tegn').replace('__N__', '0');
            it.comments += 1;
            var holder = th.closest('[data-stua-item]');
            var tg = holder && holder.querySelector('.pg-wl-stua__ctoggle');
            if (tg) tg.textContent = tn('s_comments', it.comments, 'Kommentarer (__N__)');
            say(t('s_comment_sent', 'Kommentaren er lagt til.'));
            ta.focus({ preventScroll: true });
            return;
          }
          stuaRefused(r);
        });
      });
      return f;
    }


    /* ── Gaveplan fase 2 (contract v4.2) ── */
    /* Read the plan again (server sort, filter, page) and give focus back to the control with this id. */
    function refetchKeep(focusId) {
      var sd = stuaData;
      if (!sd) return;
      sd.pending = function () { var f = document.getElementById(focusId); if (f) f.focus({ preventScroll: true }); };
      showStua(sd.ref);
    }
    function moreStua(b) {
      var sd = stuaData;
      if (!sd || !sd.cursor || isBusy(b)) return;
      busy(b, true);
      stuaGet('/stua/' + encodeURIComponent(sd.ref) + stuaQuery(sd.cursor)).then(function (r) {
        busy(b, false);
        if (stuaData !== sd) return;
        var d = r.data;
        if (r.status !== 200 || !d || !Array.isArray(d.items)) { say(stuaFail(r)); return; }
        var have = {};
        sd.items.forEach(function (it) { have[it.ref] = true; });
        var first = null;
        d.items.slice(0, 100).map(stuaItemOf).filter(Boolean).forEach(function (it) { if (!have[it.ref] && sd.items.length < GUEST_MAX) { sd.items.push(it); if (!first) first = it.ref; } });
        sd.cursor = typeof d.next_cursor === 'string' && d.next_cursor.length < 2048 ? d.next_cursor : '';
        drawStuaItems();
        /* Focus moves to the first new item (the button may be gone). */
        var li = first && sd.ul.querySelector('[data-stua-item="' + first + '"]');
        if (li) li.focus({ preventScroll: true }); else if (!sd.more.hidden) sd.more.focus({ preventScroll: true });
      });
    }
    function restoreItem(ref) {
      stuaPost('/stua/items/' + encodeURIComponent(ref) + '/restore').then(function (r) {
        if (r.status === 200) { say(t('s_restored', 'Forslaget er tilbake.')); if (stuaData) showStua(stuaData.ref); return; }
        stuaRefused(r);
      });
    }
    /* Edit your own comment: plain text, 1–1000 characters; «(redigert)» afterwards. */
    function editComment(c, li, opener) {
      var old = li.querySelector('.pg-wl-stua__cedit');
      if (old) { old.parentNode.removeChild(old); opener.setAttribute('aria-expanded', 'false'); return; }
      opener.setAttribute('aria-expanded', 'true');
      var f = el('div', { class: 'pg-wl-stua__cedit pg-wl-stua__cform' });
      var eid = 'wl-stua-e-' + c.ref;
      f.appendChild(el('label', { for: eid, class: 'rw__label' }, t('s_edit_label', 'Endre kommentaren')));
      var ta = el('textarea', { id: eid, rows: '3', maxlength: '1000', class: 'rw__input pg-wl-stua__ctextarea', 'aria-describedby': eid + '-p' });
      ta.value = str(c.body, 1000);
      f.appendChild(ta);
      f.appendChild(privacyHint(eid + '-p'));
      var foot = el('div', { class: 'pg-wl-stua__cfoot' });
      var save = el('button', { type: 'button', class: 'pg-wl__btn pg-wl-stua__send' }, t('save', 'Lagre'));
      var cancel = el('button', { type: 'button', class: 'pg-wl__link' }, t('cancel', 'Avbryt'));
      foot.appendChild(save); foot.appendChild(cancel);
      f.appendChild(foot);
      function done() { if (f.parentNode) f.parentNode.removeChild(f); opener.setAttribute('aria-expanded', 'false'); opener.focus({ preventScroll: true }); }
      cancel.addEventListener('click', done);
      save.addEventListener('click', function () {
        var body = ta.value.trim();
        if (!body) { ta.focus(); return; }
        if (isBusy(save)) return;
        busy(save, true);
        stuaPost('/stua/comments/' + encodeURIComponent(c.ref), { body: body.slice(0, 1000) }).then(function (r) {
          busy(save, false);
          if (r.status === 200 && r.data && r.data.comment) {
            var n = commentEl(r.data.comment);
            if (li.parentNode && n) { li.parentNode.replaceChild(n, li); n.focus({ preventScroll: true }); }
            say(t('s_comment_edited', 'Kommentaren er endret.'));
            return;
          }
          stuaRefused(r);
        });
      });
      li.appendChild(f);
      ta.focus({ preventScroll: true });
    }
    /* A new visible name (POST stua/{ref}/me, also while locked). */
    function renameMe(opener) {
      var sd = stuaData;
      if (!sd) return;
      var head = opener.closest('.pg-wl-stua__head');
      var old = head && head.querySelector('.pg-wl-stua__rename');
      if (old) { old.parentNode.removeChild(old); opener.setAttribute('aria-expanded', 'false'); return; }
      opener.setAttribute('aria-expanded', 'true');
      var f = el('div', { class: 'pg-wl-stua__rename pg-wl-stua__cform' });
      var rid = 'wl-stua-me';
      f.appendChild(el('label', { for: rid, class: 'rw__label' }, t('s_display_name', 'Visningsnavn')));
      var input = el('input', { id: rid, type: 'text', maxlength: '40', class: 'rw__input pg-wl-stua__name', value: sd.me.name, autocomplete: 'given-name' });
      f.appendChild(input);
      var foot = el('div', { class: 'pg-wl-stua__cfoot' });
      var save = el('button', { type: 'button', class: 'pg-wl__btn pg-wl-stua__send' }, t('save', 'Lagre'));
      var cancel = el('button', { type: 'button', class: 'pg-wl__link' }, t('cancel', 'Avbryt'));
      foot.appendChild(save); foot.appendChild(cancel);
      f.appendChild(foot);
      cancel.addEventListener('click', function () { if (f.parentNode) f.parentNode.removeChild(f); opener.setAttribute('aria-expanded', 'false'); opener.focus({ preventScroll: true }); });
      input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); save.click(); } });
      save.addEventListener('click', function () {
        var name = input.value.replace(/\s+/g, ' ').trim().slice(0, 40);
        if (!name) { say(t('s_name_required', 'Skriv et visningsnavn (1–40 tegn).')); input.focus(); return; }
        if (isBusy(save)) return;
        busy(save, true);
        stuaPost('/stua/' + encodeURIComponent(sd.ref) + '/me', { display_name: name }).then(function (r) {
          busy(save, false);
          if (r.status === 200 && r.data && r.data.member) {
            sd.me.name = str(r.data.member.display_name, 40) || name;
            sd.pending = function () { var rb = root.querySelector('.pg-wl-stua__renameme'); if (rb) rb.focus({ preventScroll: true }); };
            showStua(sd.ref);
            say(t('s_renamed_me', 'Du heter nå «__N__» her.').replace('__N__', sd.me.name));
            return;
          }
          say(stuaFail(r));
          input.focus();
        });
      });
      opener.parentNode.parentNode.insertBefore(f, opener.parentNode.nextSibling);
      input.focus({ preventScroll: true });
    }
    /* «Legg til varer»: search the shop's products (/search/suggest.json) and suggest one; with v4.2 also copy from own lists. */
    function addPanel() {
      var sd = stuaData;
      var det = el('details', { class: 'pg-wl-stua__add' });
      det.appendChild(el('summary', { class: 'pg-wl-stua__addsum' }, t('s_add_items', 'Legg til varer')));
      var box = el('div', { class: 'pg-wl-stua__addbox' });
      var sid = 'wl-stua-q';
      box.appendChild(el('label', { for: sid, class: 'rw__label' }, t('s_search_label', 'Søk i butikken')));
      var q = el('input', { id: sid, type: 'search', class: 'rw__input pg-wl-stua__q', autocomplete: 'off', placeholder: t('s_search_ph', 'For eksempel «kosedyr»') });
      box.appendChild(q);
      var res = el('ul', { class: 'pg-wl-stua__results', role: 'list', 'aria-live': 'polite' });
      box.appendChild(res);
      var timer = null, seq = 0;
      q.addEventListener('input', function () {
        window.clearTimeout(timer);
        timer = window.setTimeout(function () { search(q.value.trim()); }, 300);
      });
      function search(term) {
        var my = ++seq;
        res.textContent = '';
        if (term.length < 2) return;
        fetch('/search/suggest.json?q=' + encodeURIComponent(term) + '&resources[type]=product&resources[limit]=8', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : null; }, function () { return null; })
          .then(function (d) {
            if (my !== seq) return;
            var ps = d && d.resources && d.resources.results && Array.isArray(d.resources.results.products) ? d.resources.results.products : [];
            if (!ps.length) { res.appendChild(el('li', { class: 'pg-wl-stua__nores' }, t('s_search_none', 'Ingen treff.'))); return; }
            ps.slice(0, 8).forEach(function (pr) { var li = resultEl(pr); if (li) res.appendChild(li); });
          });
      }
      function resultEl(pr) {
        var vs = Array.isArray(pr.variants) ? pr.variants.filter(function (v) { return v && id(v.id); }) : [];
        if (!vs.length || typeof pr.title !== 'string') return null;
        var li = el('li', { class: 'pg-wl-stua__result' });
        var img = pr.featured_image && safeImg(pr.featured_image.url) ? pr.featured_image.url : safeImg(pr.image);
        if (img) li.appendChild(el('img', { src: img, alt: '', width: '48', height: '48', loading: 'lazy' }));
        var tx = el('span', { class: 'pg-wl-stua__rtext' });
        tx.appendChild(el('b', null, str(pr.title, 200)));
        if (pr.price) tx.appendChild(el('span', null, money(Math.round(parseFloat(pr.price) * 100))));
        li.appendChild(tx);
        var pick = null;
        if (vs.length > 1) {
          var vid = 'wl-stua-v-' + id(pr.id);
          pick = el('select', { id: vid, class: 'pg-wl-variant__select', 'aria-label': t('variant_pick', 'Velg variant') });
          vs.slice(0, 50).forEach(function (v) { pick.appendChild(el('option', { value: id(v.id), disabled: v.available === false ? true : null }, str(v.title, 120))); });
          li.appendChild(pick);
        }
        var add = el('button', { type: 'button', class: 'pg-wl__btn pg-wl__btn--alt pg-wl-stua__radd' }, t('s_suggest', 'Foreslå'));
        add.addEventListener('click', function () {
          var v = pick ? pick.value : id(vs[0].id);
          if (!v || isBusy(add)) return;
          busy(add, true);
          stuaPost('/stua/' + encodeURIComponent(sd.ref) + '/items', { variant_id: v, quantity: 1 }).then(function (r) {
            busy(add, false);
            var d = r.data;
            if (r.status === 200 && d && d.item) {
              say(d.created !== true && d.voted === true ? t('s_voted_instead', 'Den var allerede foreslått – du ga den en tommel opp') : t('s_suggested', '«__T__» er foreslått.').replace('__T__', str(pr.title, 200)));
              addAfter(q.value);
              return;
            }
            stuaRefused(r);
          });
        });
        li.appendChild(add);
        return li;
      }
      if (sd.v42 && S.lists) {
        var cp = el('button', { type: 'button', class: 'pg-wl__btn pg-wl__btn--alt pg-wl-stua__copy' }, t('s_copy_from', 'Kopier fra mine lister'));
        cp.addEventListener('click', function () { copyDialog(); });
        box.appendChild(cp);
      }
      det.appendChild(box);
      return det;
    }
    /* After an add, read the plan again but keep the add panel open with its search. */
    function addAfter(term) {
      var sd = stuaData;
      if (!sd) return;
      sd.pending = function () {
        var d = root.querySelector('.pg-wl-stua__add');
        if (!d) return;
        d.open = true;
        var q2 = d.querySelector('.pg-wl-stua__q');
        if (q2) { q2.value = term || ''; q2.focus({ preventScroll: true }); if (term) q2.dispatchEvent(new Event('input')); }
      };
      loadState().then(function () { stuaButtons(); showStua(sd.ref); });
    }
    /* Copy from own lists (POST stua/{ref}/items/bulk, at most 50; notes and quantities do not follow). */
    function copyDialog() {
      var sd = stuaData;
      if (!sd) return;
      var lists = activeLists().filter(function (l) { return l.kind !== 'stua'; });
      var dg = dlg(t('s_copy_title', 'Kopier fra mine lister'));
      if (!dg) return;
      var fid = 'wl-stua-cl';
      dg.body.appendChild(el('label', { for: fid, class: 'rw__label' }, t('s_copy_list', 'Fra lista')));
      var sel = el('select', { id: fid, class: 'rw__input' });
      lists.forEach(function (l) { sel.appendChild(el('option', { value: l.ref }, l.name + ' (' + l.count + ')')); });
      dg.body.appendChild(sel);
      var wrap = el('div', { class: 'pg-wl-stua__copylist' });
      dg.body.appendChild(wrap);
      var a = el('div', { class: 'rw__actions' });
      var go = el('button', { type: 'button', class: 'rw__submit' }, t('s_copy_go', 'Kopier valgte'));
      var no = el('button', { type: 'button', class: 'rw__cancel' }, t('cancel', 'Avbryt'));
      a.appendChild(go); a.appendChild(no);
      dg.body.appendChild(a);
      no.addEventListener('click', dg.close);
      var loadSeq = 0;
      function load() {
        var my = ++loadSeq;
        wrap.textContent = '';
        wrap.appendChild(el('p', { class: 'rw__intro' }, t('loading', 'Henter …')));
        loadList(sel.value).then(function (items) {
          if (my !== loadSeq) return;
          wrap.textContent = '';
          if (!items) { dg.msg(t('load_failed', 'Kunne ikke hente varene akkurat nå.'), 'error'); return; }
          if (!items.length) { wrap.appendChild(el('p', { class: 'rw__intro' }, t('s_copy_empty', 'Lista er tom.'))); return; }
          var fs = el('fieldset', { class: 'wl-pick__set' });
          fs.appendChild(el('legend', { class: 'rw__sr' }, t('s_copy_title', 'Kopier fra mine lister')));
          var n = 0;
          items.slice(0, 250).forEach(function (it) {
            var ln = lineOf(it);
            if (!ln) return;
            var lab = el('label', { class: 'wl-pick__opt' });
            lab.appendChild(el('input', { type: 'checkbox', value: ln.ref, checked: n++ < 50 ? true : null }));
            lab.appendChild(el('span', null, title(ln)));
            fs.appendChild(lab);
          });
          wrap.appendChild(fs);
        });
      }
      sel.addEventListener('change', load);
      go.addEventListener('click', function () {
        var refs = Array.prototype.map.call(wrap.querySelectorAll('input:checked'), function (c) { return c.value; }).filter(function (v) { return REF_RE.test(v); });
        if (!refs.length) { dg.msg(t('s_copy_none', 'Velg minst én vare.'), 'error'); return; }
        if (refs.length > 50) { dg.msg(t('s_copy_max', 'Høyst 50 varer om gangen.'), 'error'); return; }
        go.disabled = true;
        stuaPost('/stua/' + encodeURIComponent(sd.ref) + '/items/bulk', { item_refs: refs }).then(function (r) {
          go.disabled = false;
          var d = r.data;
          if (r.status === 200 && d) {
            var added = Array.isArray(d.added) ? d.added.length : 0, voted = Array.isArray(d.voted) ? d.voted.length : 0, skipped = Array.isArray(d.skipped) ? d.skipped.length : 0;
            dg.close();
            /* State again first (counts on the tabs and in the plans), then the plan, then the notice. */
            loadState().then(function () {
              stuaButtons();
              sd.pending = function () { say(t('s_copy_done', 'Lagt til: __A__. Tommel opp: __V__. Hoppet over: __S__.').replace('__A__', String(added)).replace('__V__', String(voted)).replace('__S__', String(skipped))); };
              showStua(sd.ref);
            });
            return;
          }
          dg.msg(stuaFail(r), 'error');
        });
      });
      if (!lists.length) { dg.msg(t('s_copy_nolists', 'Du har ingen egne lister å kopiere fra.'), 'info'); go.disabled = true; return; }
      load();
      sel.focus({ preventScroll: true });
    }
    /* «Dupliser»: a plain wishlist of your own with the items (all, or only «Valgt»); comments and votes stay in the plan. */
    function duplicateDialog() {
      var sd = stuaData;
      if (!sd) return;
      var chosenN = sd.items.filter(function (it) { return it.chosen; }).length;
      var dg = dlg(t('s_dup_title', 'Dupliser «__L__»').replace('__L__', sd.name));
      if (!dg) return;
      dg.body.appendChild(el('p', { class: 'rw__intro' }, t('s_dup_intro', 'Varene kopieres til en ny ønskeliste som er din. Kommentarer og tomler blir i gaveplanen.')));
      var nid = 'wl-stua-dup-name';
      var name = el('input', { id: nid, type: 'text', maxlength: '80', class: 'rw__input', autocomplete: 'off', value: (sd.name + ' ' + t('s_dup_suffix', '(kopi)')).slice(0, 80) });
      dg.body.appendChild(fieldOf(t('list_name', 'Navn på lista'), name));
      var fs = el('fieldset', { class: 'wl-pick__set' });
      fs.appendChild(el('legend', { class: 'wl-gift__legend' }, t('s_dup_what', 'Hva skal kopieres?')));
      function opt(v, label, on, off) {
        var lab = el('label', { class: 'wl-pick__opt' });
        lab.appendChild(el('input', { type: 'radio', name: 'wl-stua-dup', value: v, checked: on ? true : null, disabled: off ? true : null }));
        lab.appendChild(el('span', null, label));
        fs.appendChild(lab);
      }
      var anyChosen = chosenN > 0 || stuaChosen;
      opt('chosen', chosenN ? t('s_dup_chosen', 'Bare valgte (__N__)').replace('__N__', String(chosenN)) : t('s_dup_chosen_plain', 'Bare valgte'), anyChosen, false);
      opt('all', t('s_dup_all', 'Hele gaveplanen'), !anyChosen, false);
      dg.body.appendChild(fs);
      var a = el('div', { class: 'rw__actions' });
      var go = el('button', { type: 'button', class: 'rw__submit' }, t('s_duplicate', 'Dupliser'));
      var no = el('button', { type: 'button', class: 'rw__cancel' }, t('cancel', 'Avbryt'));
      a.appendChild(go); a.appendChild(no);
      dg.body.appendChild(a);
      no.addEventListener('click', dg.close);
      go.addEventListener('click', function () {
        var nm = name.value.replace(/\s+/g, ' ').trim().slice(0, 80);
        if (!nm) { dg.msg(t('name_required', 'Skriv et navn.'), 'error'); name.focus(); return; }
        var only = !!fs.querySelector('input[value="chosen"]:checked');
        go.disabled = true;
        stuaPost('/stua/' + encodeURIComponent(sd.ref) + '/duplicate', { name: nm, only_chosen: only }).then(function (r) {
          go.disabled = false;
          var d = r.data;
          if (r.status === 200 && d && d.list && REF_RE.test(str(d.list.ref, 64))) {
            var ref = d.list.ref, added = count0(d.added), skipped = Array.isArray(d.skipped) ? d.skipped.length : 0;
            var made = listOf(d.list);
            dg.close();
            listLoaded = null;
            loadState().then(function () {
              /* Go/no-go 2026-10-12: the copy must show in the tabs at once. State is read again; if that failed or is late, the answer's
                 list goes in, and the list bar is drawn again before the notice. */
              if (S.lists && made && !listByRef(ref)) S.lists.push(made);
              sync();
              stuaButtons();
              redrawBar();
              var text = t('s_dup_done', '«__L__» er laget med __N__ varer.').replace('__L__', nm).replace('__N__', String(added)) + (skipped ? ' ' + t('s_dup_skipped', '__S__ ble hoppet over.').replace('__S__', String(skipped)) : '');
              /* «Gjør til gaveliste nå» (Knut 2026-10-12): the copy opens and the gift wizard starts on it; without gifts just «Åpne lista». */
              var giftNow = giftsOn();
              say(text, {
                text: giftNow ? t('s_gift_now', 'Gjør til gaveliste nå') : t('s_dup_open', 'Åpne lista'),
                action: function () {
                  stuaRef = ''; setStueUrl(''); setCurrent(ref); focusTab = true; refresh();
                  if (giftNow) { var l2 = listByRef(ref); if (l2 && canGift(l2)) giftWizard(l2, 2); }
                }
              });
            });
            return;
          }
          var fields = r.status === 422 && d && d.fields && typeof d.fields === 'object' ? d.fields : {};
          /* v4.2: 409 limit_reached on duplicate is the list limit (limit = max_lists as a number); 422 fields.only_chosen «none_chosen». */
          var dupErr = d && typeof d.error === 'string' ? d.error : '';
          dg.msg(dupErr === 'limit_reached' ? t('s_limit_lists', 'Du har nådd grensen for antall lister.')
            : fields.only_chosen ? t('s_dup_none_chosen', 'Ingen varer er merket som valgt.')
            : fields.name ? t('s_dup_bad_name', 'Sjekk navnet (1–80 tegn).') : stuaFail(r), 'error');
        });
      });
      name.focus({ preventScroll: true });
    }
    /* «Nylig fjernet» (owner): suggestions and comments removed in the last 30 days, with «Gjenopprett» when restorable. */
    function removedDialog() {
      var sd = stuaData;
      if (!sd) return;
      var changed = false;
      var dg = dlg(t('s_removed_title', 'Nylig fjernet i «__L__»').replace('__L__', sd.name), function (opener) {
        if (changed) { sd.pending = function () { var b = Array.prototype.filter.call(root.querySelectorAll('.pg-wl-stua__actions button'), function (x) { return x.getAttribute('data-act') === 'removed'; })[0]; if (b) b.focus({ preventScroll: true }); }; showStua(sd.ref); }
        else if (opener && opener.focus && document.contains(opener)) opener.focus({ preventScroll: true });
      });
      if (!dg) return;
      function load(refocus) {
        dg.body.textContent = '';
        dg.body.appendChild(el('p', { class: 'rw__intro' }, t('loading', 'Henter …')));
        stuaGet('/stua/' + encodeURIComponent(sd.ref) + '/removed').then(function (r) {
          dg.body.textContent = '';
          if (refocus) window.setTimeout(function () { var f = dg.body.querySelector('button') || dg.body.closest('.rw__box').querySelector('.rw__close'); if (f) f.focus({ preventScroll: true }); }, 0);
          var d = r.data;
          if (r.status !== 200 || !d) { dg.msg(stuaFail(r), 'error'); return; }
          var items = Array.isArray(d.items) ? d.items.slice(0, 100) : [], comments = Array.isArray(d.comments) ? d.comments.slice(0, 100) : [];
          if (!items.length && !comments.length) { dg.body.appendChild(el('p', { class: 'rw__intro' }, t('s_removed_none', 'Ingenting er fjernet de siste 30 dagene.'))); return; }
          function section(head, rows, path, labelOf, whenOf) {
            if (!rows.length) return;
            dg.body.appendChild(el('h3', { class: 'wl-gift__legend' }, head));
            var ul = el('ul', { class: 'wl-invites__list' });
            rows.forEach(function (o) {
              if (!o || !REF_RE.test(str(o.ref, 64))) return;
              var li = el('li', { class: 'wl-invites__row' });
              var tx = el('span', { class: 'wl-invites__text' });
              tx.appendChild(el('b', null, labelOf(o)));
              var w = whenOf(o);
              if (w) tx.appendChild(el('span', { class: 'wl-gift__help' }, t('s_removed_on', 'Fjernet __D__').replace('__D__', w)));
              li.appendChild(tx);
              if (o.restorable === true) {
                var rb = el('button', { type: 'button', class: 'rw__cancel' }, t('s_restore', 'Gjenopprett'));
                rb.addEventListener('click', function () {
                  rb.disabled = true;
                  stuaPost(path(o.ref)).then(function (r2) {
                    if (r2.status === 200) { changed = true; dg.msg(t('s_restored_one', 'Gjenopprettet.'), 'ok'); load(true); return; }
                    rb.disabled = false;
                    dg.msg(stuaFail(r2), 'error');
                  });
                });
                li.appendChild(rb);
              }
              ul.appendChild(li);
            });
            dg.body.appendChild(ul);
          }
          section(t('s_removed_items', 'Forslag'), items, function (ref) { return '/stua/items/' + encodeURIComponent(ref) + '/restore'; }, function (o) {
            var pr = productOf(o.product);
            return pr && pr.ok && pr.title ? (pr.short || shortTitle(pr.title, pr.vendor)) : t('unavailable', 'Ikke tilgjengelig nå');
          }, function (o) { return timeNo(o.removed_at); });
          section(t('s_removed_comments', 'Kommentarer'), comments, function (ref) { return '/stua/comments/' + encodeURIComponent(ref) + '/restore'; }, function (o) {
            return whoName(o.member) + ': ' + str(o.body, 120);
          }, function (o) { return timeNo(o.deleted_at); });
        });
      }
      load();
    }

    /* ── v4.3 e-mail switches (opt-in): «Daglig sammendrag» for everyone while features.digest is on, «Når noen blir med» for the owner while
       features.join_notice is on. Switching on may meet 409 email_unavailable (no address from an order yet): the box goes back off. ── */
    function notifySwitches() {
      var sd = stuaData;
      var showD = sd.feat.digest && typeof sd.me.digest === 'boolean';
      var showJ = sd.feat.joinNotice && sd.me.owner && typeof sd.me.joins === 'boolean';
      if (!showD && !showJ) return null;
      var fs = el('fieldset', { class: 'pg-wl-stua__notify' });
      fs.appendChild(el('legend', { class: 'pg-wl-stua__label' }, t('s_notify_legend', 'Varsler på e-post')));
      function sw(key, field, label, on) {
        var lab = el('label', { class: 'pg-wl-stua__check' });
        var box = el('input', { type: 'checkbox', id: 'wl-stua-n-' + key, checked: on ? true : null });
        lab.appendChild(box);
        lab.appendChild(el('span', null, label));
        box.addEventListener('change', function () {
          var want = box.checked;
          if (isBusy(box)) { box.checked = !want; return; }
          busy(box, true);
          var body = {};
          body[field] = want;
          stuaPost('/stua/' + encodeURIComponent(sd.ref) + '/me', body).then(function (r) {
            busy(box, false);
            var m = r.data && r.data.member;
            if (r.status === 200 && m) {
              var now = m[field] === true;
              box.checked = now;
              if (key === 'digest') sd.me.digest = now; else sd.me.joins = now;
              say(now ? t('s_notify_on', 'Varselet er slått på.') : t('s_notify_off', 'Varselet er slått av.'));
              return;
            }
            box.checked = !want;
            var fields = r.status === 422 && r.data && r.data.fields ? r.data.fields : null;
            say(fields && fields[field] === 'unavailable' ? t('s_digest_unavailable', 'Daglig sammendrag er ikke tilgjengelig ennå.') : stuaFail(r));
          });
        });
        fs.appendChild(lab);
      }
      if (showD) sw('digest', 'notify_digest', t('s_notify_digest', 'Daglig sammendrag med nye forslag og kommentarer (kl. 19)'), sd.me.digest);
      if (showJ) sw('joins', 'notify_joins', t('s_notify_joins', 'E-post når noen blir med'), sd.me.joins);
      fs.appendChild(el('p', { class: 'pg-wl-stua__nhelp' }, t('s_notify_help', 'E-posten går til adressen fra din siste ordre. Du kan melde deg av fra hver e-post.')));
      return fs;
    }

    /* ── Members: active members with «Eier»; the owner can remove others. ── */
    function membersDialog() {
      var sd = stuaData;
      if (!sd) return;
      var changed = false, transferred = null, dgClosed = false;
      /* After a transfer the plan is no longer this customer's list: state again, then the plan opens as a member's plan. */
      function afterTransfer(tf) {
        loadState().then(function () {
          stuaButtons();
          openStua(sd.ref);
          say(tf.told
            ? t('s_transfer_done', '«__N__» er nå eier av gaveplanen.').replace('__N__', tf.name)
            : t('s_transfer_done_silent', '«__N__» er nå eier av gaveplanen. Hen har ikke slått på e-postvarsler, så si gjerne fra selv.').replace('__N__', tf.name));
        });
      }
      var dg = dlg(t('s_members_title', 'Deltakere i «__L__»').replace('__L__', sd.name), function (opener) {
        dgClosed = true;
        if (transferred) { afterTransfer(transferred); return; }
        if (changed) refresh(); else if (opener && opener.focus && document.contains(opener)) opener.focus({ preventScroll: true });
      });
      if (!dg) return;
      /* «Gjør til eier»: asked once in the row; the old owner stays as a member. */
      function transferConfirm(m, li, opener) {
        var nm = str(m.display_name, 40);
        var box = el('div', { class: 'pg-wl-stua__tconfirm', role: 'group' });
        var pid = 'wl-tr-' + m.ref;
        box.appendChild(el('p', { id: pid, class: 'rw__help' }, t('s_transfer_confirm', 'Du blir vanlig deltaker. «__N__» blir eier og kan låse, invitere og fjerne deltakere.').replace('__N__', nm)));
        var yes = el('button', { type: 'button', class: 'rw__submit', 'aria-describedby': pid }, t('s_transfer_yes', 'Ja, gjør til eier'));
        var no = el('button', { type: 'button', class: 'rw__cancel' }, t('cancel', 'Avbryt'));
        box.appendChild(yes); box.appendChild(no);
        li.appendChild(box);
        opener.hidden = true;
        no.addEventListener('click', function () { if (box.parentNode) box.parentNode.removeChild(box); opener.hidden = false; opener.focus({ preventScroll: true }); });
        yes.addEventListener('click', function () {
          yes.disabled = true;
          stuaPost('/stua/' + encodeURIComponent(sd.ref) + '/transfer', { member_ref: m.ref }).then(function (r) {
            var d = r.data;
            if (r.status === 200 && d) {
              transferred = { name: nm, told: d.notified === true };
              /* Closed while the call ran: carry on here, the dialog's own close will not run again. */
              if (dgClosed) afterTransfer(transferred); else dg.close();
              return;
            }
            if (dgClosed) { say(stuaFail(r)); return; }
            yes.disabled = false;
            var err = errOf(r);
            if (r.status === 404) { dg.msg(t('s_transfer_gone', '«__N__» er ikke med i gaveplanen lenger.').replace('__N__', nm), 'error'); load(); return; }
            dg.msg(err === 'limit_reached' ? t('s_transfer_limit', '«__N__» har nådd grensen for antall lister og kan ikke bli eier nå.').replace('__N__', nm) : err === 'own_list' ? t('s_transfer_self', 'Du er allerede eier.') : stuaFail(r), 'error');
          });
        });
        yes.focus({ preventScroll: true });
      }
      function load() {
        dg.body.textContent = '';
        dg.body.appendChild(el('p', { class: 'rw__intro' }, t('loading', 'Henter …')));
        stuaGet('/stua/' + encodeURIComponent(sd.ref) + '/members').then(function (r) {
          dg.body.textContent = '';
          if (r.status !== 200 || !r.data || !Array.isArray(r.data.members)) { dg.msg(stuaFail(r), 'error'); return; }
          var ul = el('ul', { class: 'wl-invites__list' });
          r.data.members.slice(0, 50).forEach(function (m) {
            if (!m || !REF_RE.test(str(m.ref, 64))) return;
            var li = el('li', { class: 'wl-invites__row' });
            var tx = el('span', { class: 'wl-invites__text' });
            tx.appendChild(el('b', null, str(m.display_name, 40) || t('s_former', 'Tidligere deltaker')));
            if (m.role === 'owner') tx.appendChild(el('span', { class: 'pg-wl-lists__badge' }, t('s_owner', 'Eier')));
            var when = dateNo(str(m.joined_at, 10));
            if (when) tx.appendChild(el('span', { class: 'wl-gift__help' }, t('s_joined_on', 'Med siden __D__').replace('__D__', when)));
            li.appendChild(tx);
            if (sd.me.owner && m.role !== 'owner') {
              var rm = el('button', { type: 'button', class: 'rw__cancel', 'aria-label': t('s_member_remove_label', 'Fjern __N__ fra gaveplanen').replace('__N__', str(m.display_name, 40)) }, t('s_remove', 'Fjern'));
              rm.addEventListener('click', function () {
                rm.disabled = true;
                stuaPost('/stua/members/' + encodeURIComponent(m.ref) + '/remove').then(function (r2) {
                  if (r2.status === 200) { changed = true; sd.members = Math.max(0, sd.members - 1); dg.msg(t('s_member_removed', '__N__ er fjernet.').replace('__N__', str(m.display_name, 40)), 'ok'); load(); return; }
                  rm.disabled = false;
                  dg.msg(stuaFail(r2), 'error');
                });
              });
              li.appendChild(rm);
              if (sd.feat && sd.feat.transfer) {
                var mk = el('button', { type: 'button', class: 'rw__cancel', 'aria-label': t('s_transfer_label', 'Gjør __N__ til eier').replace('__N__', str(m.display_name, 40)) }, t('s_transfer', 'Gjør til eier'));
                mk.addEventListener('click', function () { transferConfirm(m, li, mk); });
                li.appendChild(mk);
              }
            }
            ul.appendChild(li);
          });
          dg.body.appendChild(ul);
          if (sd.me.owner) dg.body.appendChild(el('p', { class: 'rw__help' }, t('s_members_help', 'Den som fjernes, mister tilgangen. Forslagene og kommentarene blir stående som «Tidligere deltaker».')));
        });
      }
      load();
    }

    /* ── Create, convert and settings (owner): visible name (the members see it), occasion, date, message and «Fra». ── */
    function stuaDialog(list, mode, pre) {
      var g0 = (list && list.gift) || {};
      var cur0 = pre || (stuaData && list && stuaData.ref === list.ref ? stuaData : null);
      var made = '';   // «Ny Ønskestue»: the list made by POST lists, so a second «Lag» does not make another
      var title = mode === 'new' ? t('s_new', 'Ny gaveplan') : mode === 'edit' ? t('s_settings_title', 'Innstillinger for «__L__»').replace('__L__', list.name) : t('s_convert_title', 'Gjør «__L__» om til en gaveplan').replace('__L__', list.name);
      var dg = dlg(title);
      if (!dg) return;
      var b = dg.body;
      if (mode !== 'edit') b.appendChild(el('p', { class: 'rw__intro' }, t('s_intro', 'I gaveplanen kan de du inviterer foreslå varer, kommentere og gi tommel opp. Du bestemmer hva som er valgt.')));
      var nameI = null;
      if (mode === 'new') {
        nameI = el('input', { id: 'wl-s-list', type: 'text', maxlength: '80', class: 'rw__input', autocomplete: 'off' });
        b.appendChild(fieldOf(t('list_name', 'Navn på lista'), nameI));
      }
      var dn = el('input', { id: 'wl-s-dn', type: 'text', maxlength: '40', class: 'rw__input', autocomplete: 'given-name', value: (cur0 && cur0.me.name) || g0.from || '' });
      var occ = el('input', { id: 'wl-s-occ', type: 'text', maxlength: '60', class: 'rw__input', autocomplete: 'off', value: (cur0 && cur0.occasion) || g0.occasion || '' });
      var dt = el('input', { id: 'wl-s-date', type: 'date', class: 'rw__input', value: (cur0 && cur0.date) || g0.date || '' });
      var msgI = el('textarea', { id: 'wl-s-msg', maxlength: '500', rows: '3', class: 'rw__input' });
      msgI.value = (cur0 && cur0.message) || g0.message || '';
      var from = el('input', { id: 'wl-s-from', type: 'text', maxlength: '60', class: 'rw__input', autocomplete: 'name', value: (cur0 && cur0.from) || g0.from || '' });
      b.appendChild(fieldOf(t('s_display_name', 'Visningsnavn'), dn, t('s_display_name_help', 'Navnet de andre ser ved forslagene og kommentarene dine. 1–40 tegn.')));
      b.appendChild(fieldOf(t('g_occasion', 'Anledning'), occ, t('g_occasion_help', 'For eksempel «Olav 2 år». Høyst 60 tegn.')));
      b.appendChild(fieldOf(t('g_date_event', 'Dato'), dt, t('g_optional', 'Valgfritt.')));
      b.appendChild(fieldOf(t('s_message', 'Hilsen til deltakerne'), msgI, t('s_message_help', 'Vises øverst i gaveplanen og i invitasjonen. Høyst 500 tegn.')));
      b.appendChild(fieldOf(t('g_from_name', 'Fra'), from, t('s_from_help', 'Navnet i invitasjonen.')));
      var a = el('div', { class: 'rw__actions' });
      var save = el('button', { type: 'button', class: 'rw__submit' }, mode === 'edit' ? t('save', 'Lagre') : t('s_make', 'Lag gaveplanen'));
      var cancel = el('button', { type: 'button', class: 'rw__cancel' }, t('cancel', 'Avbryt'));
      a.appendChild(save); a.appendChild(cancel);
      b.appendChild(a);
      cancel.addEventListener('click', dg.close);
      function payload() {
        return {
          display_name: dn.value.replace(/\s+/g, ' ').trim().slice(0, 40), occasion: occ.value.trim().slice(0, 60),
          event_date: /^\d{4}-\d{2}-\d{2}$/.test(dt.value) ? dt.value : null, message: msgI.value.trim().slice(0, 500), from_name: from.value.trim().slice(0, 60)
        };
      }
      function toStua(ref, name) {
        return stuaPost('/lists/' + encodeURIComponent(ref) + '/stua', payload()).then(function (r) {
          if (r.status === 200) {
            dg.close();
            loadState().then(function () {
              stuaButtons();
              setCurrent(ref); stuaRef = ''; setStueUrl(''); focusTab = true; refresh();
              var l2 = listByRef(ref);
              if (mode === 'edit') say(t('s_saved', 'Innstillingene er lagret.'));
              else say(t('s_created', '«__L__» er nå en gaveplan.').replace('__L__', name), l2 ? { text: t('s_invite', 'Inviter'), action: function () { invitesDialog(l2); } } : null);
            });
            return true;
          }
          var err = errOf(r);
          dg.msg(err === 'wrong_kind' ? t('s_wrong_kind_gift', 'En gaveliste kan ikke gjøres om til en gaveplan. Gjør den til en vanlig liste først.') : r.status === 422 ? t('s_invalid', 'Sjekk det du har skrevet.') : stuaFail(r), 'error');
          return false;
        });
      }
      save.addEventListener('click', function () {
        var p = payload();
        if (!p.display_name) { dg.msg(t('s_name_required', 'Skriv et visningsnavn (1–40 tegn).'), 'error'); dn.focus(); return; }
        save.disabled = true;
        if (mode !== 'new') { toStua(list.ref, list.name).then(function () { save.disabled = false; }); return; }
        var ln = nameI.value.replace(/\s+/g, ' ').trim().slice(0, 80);
        if (!ln) { save.disabled = false; dg.msg(t('name_required', 'Skriv et navn.'), 'error'); nameI.focus(); return; }
        if (made) { toStua(made, ln).then(function () { save.disabled = false; }); return; }
        write('/lists', { name: ln }).then(function (r) {
          made = (r.status === 201 || r.status === 200) && r.data && r.data.list && REF_RE.test(str(r.data.list.ref, 64)) ? r.data.list.ref : '';
          if (!made) { save.disabled = false; dg.msg(isOff() ? t('error', 'Noe gikk galt. Prøv igjen senere.') : listFail(r, '', 'list'), 'error'); return; }
          toStua(made, ln).then(function () { save.disabled = false; });
        });
      });
      (nameI || dn).focus({ preventScroll: true });
    }
    /* «Gjør til vanlig liste» (owner): invitations are withdrawn and members lose access; the portal keeps their rows hidden. */
    function unstuaDialog(list) {
      var dg = dlg(t('s_unstua_title', 'Gjør «__L__» til en vanlig liste?').replace('__L__', list.name));
      if (!dg) return;
      dg.body.appendChild(el('p', { class: 'rw__intro' }, t('s_unstua_text', 'Invitasjonene trekkes tilbake, og deltakerne mister tilgangen. Varene blir liggende i lista.')));
      var a = el('div', { class: 'rw__actions' });
      var yes = el('button', { type: 'button', class: 'rw__submit' }, t('s_unstua_yes', 'Gjør til vanlig liste'));
      var no = el('button', { type: 'button', class: 'rw__cancel' }, t('cancel', 'Avbryt'));
      a.appendChild(yes); a.appendChild(no);
      dg.body.appendChild(a);
      no.addEventListener('click', dg.close);
      yes.addEventListener('click', function () {
        yes.disabled = true;
        stuaPost('/lists/' + encodeURIComponent(list.ref) + '/unstua').then(function (r) {
          if (r.status === 200) {
            dg.close();
            stuaData = null;
            /* «Gjør til gaveliste nå» (Knut 2026-10-12): a finished plan becomes a gift list in one step (gift is allowed right after unstua). */
            reload(list.ref, t('s_unstua_done', 'Lista er en vanlig ønskeliste igjen.'), giftsOn() ? { text: t('s_gift_now', 'Gjør til gaveliste nå'), action: function () {
              var l2 = listByRef(list.ref);
              if (l2 && canGift(l2)) giftWizard(l2, 2);
            } } : null);
            loadState().then(stuaButtons);
            return;
          }
          yes.disabled = false;
          dg.msg(stuaFail(r), 'error');
        });
      });
      no.focus({ preventScroll: true });
    }

    return {
      refresh: refresh, status: status, loading: loading, isShared: function () { return !!shared; },
      destroy: function () { dead = true; gen++; clear(); }
    };
  }

  /* ── Start ───────────────────────────────────────────────────────────────────────────────────────────────────────── */
  function start() {
    followForm();
    /* Only the shared view on the wishlist page (snippets/wishlist-assets.liquid viewer_only): for visitors who do not get the wishlist
       itself (staff pilot), so a shared link works for everyone (§13 choice 5). */
    if (cfg.viewer_only === true) {
      if (page && page.isShared()) page.refresh();
      else if (page) page.status(pageRoot.getAttribute('data-unavailable') || t('error'));
      return;
    }
    if (!signedIn) {
      ready = true;
      sync();
      if (page) page.refresh();
      return;
    }
    if (isOff()) { settled = true; hideHearts(); if (page) page.refresh(); return; }
    if (page) page.loading();
    loadState().then(function (ok) {
      settled = true;
      ready = ok && !isOff();
      if (!ready) { hideHearts(); if (page) page.refresh(); return; }
      sync();
      if (page) page.refresh();
      checkGuestList();
    });
  }

  /* Theme editor: the section is drawn again on every change of a setting or block (the panels, Knut 2026-10-11), so the page is set up again
     on the new root; the old page's bar at the bottom goes with the old section. */
  document.addEventListener('shopify:section:unload', function (e) {
    if (page && pageRoot && e.target && e.target.contains(pageRoot)) { page.destroy(); page = null; pageRoot = null; }
  });
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target && e.target.querySelector('[data-wl-page]');
    if (!r) return;
    if (page) page.destroy();
    pageRoot = r;
    page = makePage(r);
    if (cfg.viewer_only === true) { if (page.isShared()) page.refresh(); else page.status(r.getAttribute('data-unavailable') || t('error')); return; }
    if (!signedIn || settled) page.refresh(); else page.loading();   // still waiting for the state: start() draws when it has answered
  });

  /* Cards that arrive later (filters swap the grid, carousels clone their slides) get the current state. */
  if (typeof MutationObserver === 'function' && document.body) {
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var added = records[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType === 1 && (n.matches('button[data-wl-btn], [data-wl-move]') || n.querySelector('button[data-wl-btn], [data-wl-move]'))) { followForm(); queueSync(); return; }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  start();
})();
